import React, { useState, useEffect, useRef, useField } from "react";
import { connect } from "react-redux";
import { apiServices } from "../../../services/apiServices";
import moment from "moment";
import swal from "sweetalert";
import PropTypes from "prop-types";
import { db } from "../../../firebaseConfig";
import FingerprintCapture from "../../../pages/fingerprint/FingerprintCapture";
import Html5QrcodePlugin from "../../html5qrbarcodescanner/Html5QrBarcodeScanner";
import TablePagination from "@material-ui/core/TablePagination"; // MUI v4
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode, faTimes } from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Divider } from "@mui/material";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CardHeader from "@material-ui/core/CardHeader";
import CloseIcon from "@material-ui/icons/Close";
import Image from "@material-ui/icons/Image";
import CreateField from "../../fields/CreateField";
import CreateSearchField from "../../fields/CreateSearchField";
import CreateStageField from "../../fields/CreateStageField";
import { useTranslation, Trans } from "react-i18next";
import OfflineDb from "../../../db";
import { useGlobalSpinnerActionsContext } from "../../../context/GlobalSpinnerContext";
import { ReactFinalForm } from "@dhis2/ui";
import { useHistory } from "react-router-dom";
import TaskList from "../../taskList/TaskList";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import EventNoteIcon from "@material-ui/icons/EventNote";
import EditIcon from "@material-ui/icons/Edit";
import Avatar from "@material-ui/core/Avatar";
import clsx from "clsx";
import Customcaseslist from "../../../pages/cases/Customcaseslist.js";
import PersonIcon from "@material-ui/icons/Person";
import DeleteIcon from "@material-ui/icons/Delete";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { CheckboxFieldFF } from "@dhis2/ui";
import QRCode from "qrcode.react";
//custom radio button
import axios from "axios";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import SignatureCanvas from "react-signature-canvas";
import { Tooltip } from "@mui/material";
import "../../../assets/css/customstyles.css";
import "react-html5-camera-photo/build/css/index.css";

//last
const { Form, Field } = ReactFinalForm;

const getTranslatedLabels = (stage) => {
  if (localStorage.getItem("locale") === "en") {
    return stage.displayName;
  } else if (stage.translations && stage.translations.length > 0) {
    let label = stage.translations.filter(
      (tanslation) =>
        tanslation.property === "NAME" &&
        tanslation.locale === localStorage.getItem("locale")
    );
    if (label.length > 0) {
      return label[0].value;
    } else {
      return stage.displayName;
    }
  }
  return stage.displayName;
};

const getTranslatedDataElementLabels = (dataElement) => {
  if (localStorage.getItem("locale") === "en") {
    return dataElement.formName
      ? dataElement.formName
      : dataElement.displayName
      ? dataElement.displayName
      : dataElement.description;
  } else if (dataElement.translations && dataElement.translations.length > 0) {
    let label = dataElement.translations.filter(
      (tanslation) =>
        tanslation.property === "NAME" &&
        tanslation.locale === localStorage.getItem("locale")
    );
    if (label.length > 0) {
      return label[0].value;
    } else {
      return dataElement.formName
        ? dataElement.formName
        : dataElement.displayName
        ? dataElement.displayName
        : dataElement.description;
    }
  }
  return dataElement.formName
    ? dataElement.formName
    : dataElement.displayName
    ? dataElement.displayName
    : dataElement.description;
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  table: {
    minWidth: 650,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      className="reginnertabcontainer"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SimpleTabs(props) {
  const theme = useTheme();
  const formRef = useRef(null);
  let activeTabs = [];
  let activeTabsOnSubmit = [];
  let userData = props.userData;
  let programData = props.programData;
  let programRules = props.programRules.programRules;
  let programRulesVariables = props.programRulesVariables.programRuleVariables;
  let dedupEnabled = props.dedupEnabled;
  let searchEnabled = props.searchEnabled;
  let relationShipId = props.relationShipId;
  let dataElementGroup = props.dataElementGroup.dataElementGroups;
  let currentGeolocation = props.currentGeolocation;
  let OUJSON = props.OUJSON;
  let workFlow = false;
  try {
    workFlow =
      programData.programs[0].attributeValues.length > 0
        ? _.filter(programData.programs[0].attributeValues, [
            "attribute.name",
            "Is workflow",
          ]) &&
          _.filter(programData.programs[0].attributeValues, [
            "attribute.name",
            "Is workflow",
          ]).length > 0 &&
          _.filter(programData.programs[0].attributeValues, [
            "attribute.name",
            "Is workflow",
          ])[0].value === "true"
          ? true
          : false
        : false;
  } catch (e) {
    console.log(e);
  }
  const history = useHistory();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [searchTabvalue, setSearchTabValue] = React.useState(0);
  const [activeCaseDetails, setActiveCaseDetails] = useState(null);
  const [activeCaseFormData, setActiveCaseFormData] = useState(null);
  const [linkContactFlag, setLinkContactFlag] = useState(null);
  const [trackentityInstanceDetails, setTrackentityInstanceDetails] =
    useState(null);
  const [newServiceStartFlag, setServiceStartFlag] = useState(true);
  const [searchResponse, setSearchResponse] = React.useState(null);
  const [searchHeader, setSearchHeader] = React.useState(null);
  const [formValuePostDeDup, setFormValuePostDeDup] = React.useState(null);
  const [dataUri, setDataUri] = useState("");
  const [Configuration, setConfiguration] = React.useState(null);
  const [programBoDetails, setProgramBoDetails] = React.useState(null);
  const [openCamera, setCameraStatus] = React.useState(false);

  const [subSectionJson, setsubSectionJson] = useState({});
  const [dateDependencies, setDateDependencies] = useState({});
  const [allsubsectiondes, setallsubsectiondes] = useState([]);
  const [ncdsubsectionDeListItems, setncdsubsectionDeListItems] = useState([]);
  const [healthservicesubsection, sethealthservicesubsection] = useState([]);

  // Code for Search start
  const [sessionUserBoValue, setSessionUserBoValue] = useState(null);
  const [metaData, setMetaData] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  let stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
  // code for link Tab
  const [linkIndexList, setLinkIndexList] = useState([]);
  const [linkContactList, setLinkContactList] = useState([]);
  const [showScanner, setshowScanner] = useState(false);
  const [qrCodeId, setQrCode] = useState(null);

  // Event Data to show Table
  const [editEventsId, setEditEventsId] = useState(null);
  const [stageImageValue, setStageImageValue] = useState(null);
  const [stageregImageValue, setStageregImageValue] = useState(null);
  const [firstNameId, setFirstNameId] = useState(null);
  const [givenName, setGivenName] = useState(null);
  const [regAddressId, setRegAddressId] = useState(false);
  const [dobID, setDobID] = useState(null);
  const [placeofVisit, setPlaceofVisit] = useState(null);
  const [nameofHaltPoint, setNameofHaltPoint] = useState(null);

  const [doyouhavechild, setdoyouhavechild] = useState(null);
  const [noofmale, setnoofmale] = useState(null);
  const [nooffemale, setnooffemale] = useState(null);
  const [nooftg, setnooftg] = useState(null);
  const [mobilenumberId, setmobilenumberId] = useState(null);

  const [ispermanentaddsameascurrentId, setispermanentaddsameascurrentId] =
    useState(null);
  const [currentwardId, setcurrentwardId] = useState(null);
  const [permanentwardId, setpermanentwardId] = useState(null);
  const [currentstreetId, setcurrentstreetId] = useState(null);
  const [permanentstreetId, setpermanentstreetId] = useState(null);
  const [permanentvillageId, setpermanentvillageId] = useState(null);
  const [currentvillageId, setcurrentvillageId] = useState(null);
  const [permanentblockId, setpermanentblockId] = useState(null);
  const [currentblockId, setcurrentblockId] = useState(null);
  const [permanentdistrictId, setpermanentdistrictId] = useState(null);
  const [currentdistrictId, setcurrentdistrictId] = useState(null);
  const [permanentstateId, setpermanentstateId] = useState(null);
  const [currentstateId, setcurrentstateId] = useState(null);
  const [currentfamilynoId, setcurrentfamilynoId] = useState(null);
  const [permanentfamilynoId, setpermanentfamilynoId] = useState(null);
  const [currentlandmarkId, setcurrentlandmarkId] = useState(null);
  const [permanentlandmarkId, setpermanentlandmarkId] = useState(null);

  const [addContactFlag, setAddContactFlag] = useState(false);
  const [ageUID, setAgeUID] = useState(false);
  const [genderUID, setGenderUID] = useState(false);
  const [userrolename, setuserrolename] = React.useState(null);
  const patientRole = "Patient Role";
  const superAdmin = "superuser";
  const [tbTestingStageId, setTbTestingStageId] = useState(null);
  const [tbTretmentInitiationStageId, setTBTretmentInitiationStageId] =
    useState(false);
  const [mWRDresultId, setmWRDresultId] = useState(null);
  const [CXRresultId, setCXRresultId] = useState(null);
  const [CRPresultId, setCRPresultId] = useState(null);
  const [tbTestRusultId, setTBTestRusultId] = useState(false);
  const [noneOptionID, setNoneOptionID] = useState(false);
  const [testingforTBinfectionID, setTestingforTBinfectionID] = useState(false);
  const [symptomsID, setSymptomsID] = useState(false);
  const [mWRDreportavailableID, setmWRDreportavailableID] = useState(false);
  const [CRPreportavailableID, setCRPreportavailableID] = useState(false);
  const [symptomsDisplayName, setSymptomsDisplayName] = useState(false);
  const [hivStatusId, setHivStatusId] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  // To show image modal
  const [imageResponse, setImageResponse] = React.useState(null);
  const [imageTitle, setImageTitle] = React.useState(null);
  const [riskAssementStageId, setRiskAssementStageId] = useState(false);
  const [referralServiceStageId, setReferralServiceStageId] = useState(false);
  const [sampleCollectionStageId, setSampleCollectionStageId] = useState(false);
  const [NCDStageId, setNCDStageId] = useState(null);
  const [CDStageId, setCDStageId] = useState(null);
  const [IspatienteligibleforTBIId, setIspatienteligibleforTBIId] =
    useState(null);
  const [testresultTBId, setTestresultTBId] = useState(null);

  const [TypeOfServiceId, setTypeOfServiceId] = useState(null);

  const [drugbyinjectionId, setdrugbyinjectionId] = useState(null);
  const [howlongwasitusedId, sethowlongwasitusedId] = useState(null);
  const [doyougohomeonfectivalId, setdoyougohomeonfectivalId] = useState(null);
  const [howmanydaysdoyoustayathomeId, sethowmanydaysdoyoustayathomeId] =
    useState(null);
  const [currentpincodeId, setcurrentpincodeId] = useState(null);
  const [permanentpincodeId, setpermanentpincodeId] = useState(null);
  const [clientregdateId, setclientregdateId] = useState(null);
  const [DateofAccessingServiceId, setDateofAccessingServiceId] =
    useState(null);
  const [dateoflifestyleassessmentId, setdateoflifestyleassessmentId] =
    useState(null);
  const [
    dateofsexualbehaviourassessmentId,
    setdateofsexualbehaviourassessmentId,
  ] = useState(null);

  const [doyouhavechildId, setdoyouhavechildId] = useState(null);
  const [partnernameId, setpartnernameId] = useState(null);
  const [occupationId, setoccupationId] = useState(null);
  const [occupationotherId, setoccupationotherId] = useState(null);
  const [maoccupationIdritalstatusId, setmaritalstatusId] = useState(null);
  const [pleasespecifydrugsId, setpleasespecifydrugsId] = useState(null);
  const [areyousexuallyactiveId, setareyousexuallyactiveId] = useState(null);
  const [lasttimeyouhadsexId, setlasttimeyouhadsexId] = useState(null);
  const [dateofconfirmationId, setdateofconfirmationId] = useState(null);
  const [resultofconfirmatorytestId, setresultofconfirmatorytestId] =
    useState(null);
  const [artlinkdateId, setartlinkdateId] = useState(null);
  const [artlinkId, setartlinkId] = useState(null);
  const [bpSystolicId, setbpSystolicId] = useState(null);
  const [bpDiastolicId, setbpDiastolicId] = useState(null);
  const [addServiceId, setaddServiceId] = useState(null);

  const [pulseId, setpulseId] = useState(null);
  const [heightId, setheightId] = useState(null);
  const [weightId, setweightId] = useState(null);
  const [bmiID, setbmiID] = useState(null);
  const [serviceAvailedDate, setserviceAvailedDate] = useState(null);
  const [addRefDate, setaddRefDate] = useState(null);
  const [BPRefFacNameId, setBPRefFacNameId] = useState(null);
  const [SexualPartnerId, setSexualPartnerId] = useState(null);
  const [LoverId, setLoverId] = useState(null);
  const [PaidId, setPaidId] = useState(null);
  const [OtherSexPartnerId, setOtherSexPartnerId] = useState(null);
  const [cd4testdateId, setcd4testdateId] = useState(null);
  const [cd4countId, setcd4countId] = useState(null);
  const [vlcountId, setvlcountId] = useState(null);
  const [vltestdateId, setvltestdateId] = useState(null);
  const [dateofbpscreeningId, setdateofbpscreeningId] = useState(null);
  const [dateofbpserviceavailedId, setdateofbpserviceavailedId] =
    useState(null);
  const [dateofpulsescreeningId, setdateofpulsescreeningId] = useState(null);
  const [dateofeyescreeningId, setdateofeyescreeningId] = useState(null);
  const [dateoforaldentalscreeningId, setdateoforaldentalscreeningId] =
    useState(null);
  const [dateofdiabetesscreeningId, setdateofdiabetesscreeningId] =
    useState(null);
  const [dateofsleepscreeningId, setdateofsleepscreeningId] = useState(null);
  const [dateofmentalhealthsscreeningId, setdateofmentalhealthsscreeningId] =
    useState(null);
  const [dateofrespiratoryscreeningId, setdateofrespiratoryscreeningId] =
    useState(null);
  const [dateofstomachscreeningId, setdateofstomachscreeningId] =
    useState(null);
  const [dateofotherncdscreeningId, setdateofotherncdscreeningId] =
    useState(null);
  const [dateofeyeserviceavailedId, setdateofeyeserviceavailedId] =
    useState(null);
  const [
    dateoforaldentalserviceavailedId,
    setdateoforaldentalserviceavailedId,
  ] = useState(null);
  const [dateofdiabetesserviceavailedId, setdateofdiabetesserviceavailedId] =
    useState(null);
  const [dateofchronicserviceavailedId, setdateofchronicserviceavailedId] =
    useState(null);
  const [dateofsleepserviceavailedId, setdateofsleepserviceavailedId] =
    useState(null);
  const [
    dateofmentalhealthserviceavailedId,
    setdateofmentalhealthserviceavailedId,
  ] = useState(null);
  const [
    dateofrespiratoryserviceavailedId,
    setdateofrespiratoryserviceavailedId,
  ] = useState(null);
  const [dateofstomachserviceavailedId, setdateofstomachserviceavailedId] =
    useState(null);
  const [dateofotherncdserviceavailedId, setdateofotherncdserviceavailedId] =
    useState(null);
  const [coworkerId, setcoworkerId] = useState(null);
  const [dateofSTItreatmentdateId, setdateofSTItreatmentdateId] =
    useState(null);
  const [TBcompletiondateId, setTBcompletiondateId] = useState(null);
  const [DiabetesIndaysId, setDiabetesIndaysId] = useState(null);
  const [DiabetesPEDId, setDiabetesPEDId] = useState(null);
  const [eyeissueidentifiedId, seteyeissueidentifiedId] = useState(null);
  const [eyedetailofissueId, seteyedetailofissueId] = useState(null);
  const [dateofchronicpainscreeningId, setdateofchronicpainscreeningId] =
    useState(null);
  const [Noofparttnerinlast1weekId, setNoofparttnerinlast1weekId] =
    useState(null);
  const [
    howmanytimescomdomusedwithregularId,
    sethowmanytimescomdomusedwithregularId,
  ] = useState(null);
  const [
    howmanytimescomdomusedwithotherId,
    sethowmanytimescomdomusedwithotherId,
  ] = useState(null);
  const [didyouexpSTIId, setdidyouexpSTIId] = useState(null);
  const [didyourecsyphilistreatmentId, setdidyourecsyphilistreatmentId] =
    useState(null);
  const [haveyouuseddrugininjectionId, sethaveyouuseddrugininjectionId] =
    useState(null);
  const [heroinbrownsugarId, setheroinbrownsugarId] = useState(null);
  const [whitenersolventId, setwhitenersolventId] = useState(null);
  const [
    howmanydaysareyouusuallyawayfromhomeId,
    sethowmanydaysareyouusuallyawayfromhomeId,
  ] = useState(null);
  const [artStateId, setartStateId] = useState(null);
  const [artDistrictId, setartDistrictId] = useState(null);

  const [nameofartId, setnameofartId] = useState(null);
  const [onartnumberId, setonartnumberId] = useState(null);
  const [foundtbsymptomId, setfoundtbsymptomId] = useState(null);
  const [referfortbId, setreferfortbId] = useState(null);
  const [dateofserviceaddId, setdateofserviceaddId] = useState(null);
  const [dateserviceavailedaddId, setdateserviceavailedaddId] = useState(null);
  const [reffacnameId, setreffacnameId] = useState(null);
  const [dateofhivId, setdateofhivId] = useState(null);
  const [dateoftbscreeningId, setdateoftbscreeningId] = useState(null);
  const [dateoftreatmentinitiationId, setdateoftreatmentinitiationId] =
    useState(null);
  const [dateoftbtestId, setdateoftbtestId] = useState(null);
  const [dateofstiscreeningId, setdateofstiscreeningId] = useState(null);
  const [
    dateofsyphilistreatmentinitiationId,
    setdateofsyphilistreatmentinitiationId,
  ] = useState(null);
  const [
    dateofsyphilistreatmentcompletionId,
    setdateofsyphilistreatmentcompletionId,
  ] = useState(null);
  const [dateofsyphilisscreeningId, setdateofsyphilisscreeningId] =
    useState(null);
  const [dateofhepBtreatmentinitiationId, setdateofhepBtreatmentinitiationId] =
    useState(null);
  const [dateofhepBtreatmentcompletionId, setdateofhepBtreatmentcompletionId] =
    useState(null);
  const [dateofhepCtreatmentinitiationId, setdateofhepCtreatmentinitiationId] =
    useState(null);
  const [dateofhepCtreatmentcompletionId, setdateofhepCtreatmentcompletionId] =
    useState(null);
  const [dateoflinkagetoserviceId, setdateoflinkagetoserviceId] =
    useState(null);
  const [dateofserviceavailedId, setdateofserviceavailedId] = useState(null);
  const [dateofhepBscreeningId, setdateofhepBscreeningId] = useState(null);
  const [dateofhepCscreeningId, setdateofhepCscreeningId] = useState(null);
  const [dateofservicefamilyId, setdateofservicefamilyId] = useState(null);
  const [
    dateofserviceavailedsocialwelfareId,
    setdateofserviceavailedsocialwelfareId,
  ] = useState(null);
  const [dateofservicesocialwelfareId, setdateofservicesocialwelfareId] =
    useState(null);
  const [placeofhivId, setplaceofhivId] = useState(null);
  const [referforconfirmationhivId, setreferforconfirmationhivId] =
    useState(null);
  const [dateofconfirmationhivId, setdateofconfirmationhivId] = useState(null);
  const [placeofconfirmationhivId, setplaceofconfirmationhivId] =
    useState(null);
  const [resultofconfirmatorytesthivId, setresultofconfirmatorytesthivId] =
    useState(null);
  const [refneededforserviceId, setrefneededforserviceId] = useState(null);
  const [additionalavailedserviceId, setadditionalavailedserviceId] =
    useState(null);

  const [druguseId, setdruguseId] = useState(null);
  const [hivresultId, sethivresultId] = useState(null);
  const [hivreferforconfirmationId, sethivreferforconfirmationId] =
    useState(null);

  const [doseTakenMedicines, setDoseTakenMedicines] = useState(null);
  const [missedDoseMedicines, setMissedDoseMedicines] = useState(null);
  const [referToFacilityCenter, setReferToFacilityCenter] = useState(false);
  const [orgDetails, setorgDetails] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [subsectionactiveAccordion, setActiveSubSectionAccordion] =
    useState(null);
  const activeCaseFormDataRef = useRef(null);
  const [openSignatureModal, setOpenSignatureModal] = useState(false);
  const sigCanvasRef = useRef(null);

  const [signatureDataURL, setSignatureDataURL] = useState(null);
  const [signatureBlob, setSignatureBlob] = useState(null); // <- Store blob here
  const [fingerDataURL, setFingerDataURL] = useState(null);
  const [fingerBlob, setFingerBlob] = useState(null); // <- Store blob here
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isRegSubmitted, setIsRegSubmitted] = useState(false);

  const [fingerOrSignature, setFingerOrSignature] = useState("signature");
  const [isRegAvailable, setisRegAvailable] = useState("false")


  const handleOpenconsent = () => setOpen(true);
  const handleCloseconsent = () => setOpen(false);

  const handleOpen = () => setOpenSignatureModal(true);
  const handleClose = () => setOpenSignatureModal(false);


  const clearSignature = () => {
    if (sigCanvasRef.current) sigCanvasRef.current.clear();
  };

  const DeleteSignature = () => {
    setSignatureDataURL(null);
    setSignatureBlob(null); // Clear the blob as well
  };

  const saveSignature = () => {
    if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
      const originalCanvas = sigCanvasRef.current.getCanvas(); // safer than getTrimmedCanvas()
      const exportCanvas = document.createElement("canvas");

      exportCanvas.width = originalCanvas.width;
      exportCanvas.height = originalCanvas.height;

      const ctx = exportCanvas.getContext("2d");

      // White background (optional, avoids black)
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

      // Draw original canvas onto export canvas
      ctx.drawImage(originalCanvas, 0, 0);

      // Convert to Data URL
      const dataUrl = exportCanvas.toDataURL("image/png");

      fetch(dataUrl)
        .then((res) => res.blob())
        .then((blob) => {
          if (blob.size === 0) {
            console.error("Exported PNG blob is empty!");
            return;
          }

          // console.log("signature blob", blob);

          const file = new File([blob], "signature.png", { type: "image/png" });
          // console.log("signature file", file);
          const objectURL = URL.createObjectURL(file);
          // console.log("signature objectURL", objectURL);
          setSignatureDataURL(objectURL);
          setSignatureBlob(file);
          handleClose();
        });
    }
  };

  useEffect(() => {
    if (value == programData.programs[0].programStages.length + stepIncrement) {
      createIndexContactList();
    }
  }, [value]);
  // const [stepIncrement,setStepIncrement] =  useState(1)
  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    setMetaData(metadata.data);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    setConfiguration(configurations.data.configuration);

    let programBoDetails = await OfflineDb.getDataFromPouchDB(
      "programBoDetails"
    );
    setProgramBoDetails(programBoDetails.data);

    let orgDetails = await OfflineDb.getDataFromPouchDB("orgDetails");
    // console.log("orgDetails", orgDetails);
    setorgDetails(orgDetails.data);
  }

  async function getSubsectionData() {
    let subSectionJson = await OfflineDb.getDataFromPouchDB("subSectionJson");
    setsubSectionJson(subSectionJson.data);

    let allsubsectiondes = await OfflineDb.getDataFromPouchDB(
      "allsubsectiondes"
    );
    setallsubsectiondes(allsubsectiondes.data);

    let ncdsubsectionDeListItems = await OfflineDb.getDataFromPouchDB(
      "ncdsubsectionDeListItems"
    );
    setncdsubsectionDeListItems(ncdsubsectionDeListItems.data);

    let healthservicesubsection = await OfflineDb.getDataFromPouchDB(
      "healthservicesubsection"
    );
    sethealthservicesubsection(healthservicesubsection.data);
  }

  function getsubSection() {
    const getsubSectionURL = "dataStore/subSections/sections";
    setGlobalSpinner(true);
    apiServices
      .getAPI(getsubSectionURL)
      .then((subSections) => {
        setGlobalSpinner(false);
        setsubSectionJson(subSections.data);
        const allDeListItems = subSections.data["Client Profile"].flatMap(
          (item) => item.deList
        );
        setallsubsectiondes(allDeListItems);

        const ncdDeListItems = subSections.data[
          "NCDs Screening, Treatment and Linkages"
        ].flatMap((item) => item.deList);
        setncdsubsectionDeListItems(ncdDeListItems);

        const healthservicesubsection = subSections.data[
          "Health Service (Minimum Package)"
        ].flatMap((item) => item.deList);
        sethealthservicesubsection(healthservicesubsection);
      })
      .catch((err) => {
        setGlobalSpinner(false);
      });
  }

  function getDateDependencies() {
    const getDatesIdURL = "dataStore/dateDependencies/dateDependencies";
    setGlobalSpinner(true);
    apiServices
      .getAPI(getDatesIdURL)
      .then((datesfield) => {
        setGlobalSpinner(false);
        setDateDependencies(datesfield.data);
      })
      .catch((err) => {
        setGlobalSpinner(false);
      });
  }

  useEffect(() => {
    getMetaData();
    //getsubSection()
    getSubsectionData();
    getDateDependencies();
    return () => {
      OfflineDb.removeDataFromPouchDB("activeCaseDetails");
      OfflineDb.removeDataFromPouchDB("activeCaseFormData");
      OfflineDb.removeDataFromPouchDB("linkContactFlag");
      OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });
    };
  }, []);

  useEffect(() => {
    if (sessionUserBoValue != null) {
      /**SET USER ROLE */
      setuserrolename(
        sessionUserBoValue.userCredentials.userRoles[0].name ||
          sessionUserBoValue.userCredentials.userRoles[0].displayName
      );
    }
  }, [sessionUserBoValue]);

  // Code for Search END
  // New code for table data show

  const FieldWatcher = ({ name }) => {
    const {
      input: { value },
    } = useField(name);

    // console.log("watcher", name);

    useEffect(() => {
      let initialValues = activeCaseFormData.data
        ? activeCaseFormData.data.formFormat != null
          ? activeCaseFormData.data.formFormat
          : {}
        : {};
    }, [value, name]);

    return null;
  };

  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const { t, i18n } = useTranslation();

  //=========for Search UNDP==================
  const [searchFilter, setsearchFilter] = useState({});
  const [stageDetail, setStageDetail] = useState(null);
  const [dataElementDetail, setdataElementDetail] = useState(null);
  const [qrDataElementDetail, setqrDataElementDetail] = useState(null);

  //=========custom logic for UNDP==================
  const [PresentlyOnAntiTBMedicationId, setPresentlyOnAntiTBMedicationId] =
    useState(null);
  const [clientTypeID, setClientTypeID] = useState(null);
  const [verifiedFieldId, setVerifiedFieldId] = useState(null);

  const [searchdata, setsearchdata] = useState(null);
  const [offlineFieldId, setOfflineFieldId] = useState(null);
  const [customfieldobj, setcustomfieldobj] = useState(null);
  const [addressLocationId, setAaddressLocationId] = useState(null);
  const [
    reduxSelectTrackedEntityInstanceId,
    setReduxSelectTrackedEntityInstanceId,
  ] = useState(null);
  const [tbtreatmentinitiatedId, setTbtreatmentinitiatedId] = useState(null);
  const [uicId, setUicId] = useState(null);
  const [UIC, setUIC] = useState(null);
  const [lastNameId, setlastNameId] = useState(null);
  const patientroleid =
    Configuration != null ? Configuration.patientroleid : null;
  const patienttrackedInstanceId =
    Configuration != null ? Configuration.patientTrackedInstanceId : null;
  const mainAccountId =
    Configuration != null ? Configuration.mainAccountId : null;
  const userGroupId = Configuration != null ? Configuration.userGroupId : null;
  const [regPhoneNumberId, setRegPhoneNumberId] = useState(false);
  const [regPhoneNumberCodeId, setRegPhoneNumberCodeId] = useState(false);
  const [regRegisteredById, setRegRegisteredById] = useState(false);
  const [referToId, setReferToId] = useState(false);
  const [selectReferralServiceId, setSelectReferralServiceId] = useState(false);
  const [regPhoneNumberSecondaryId, setRegPhoneNumberSecondaryId] =
    useState(false);

  const [stagesInitialValues, setstagesInitialValues] = useState(null);
  const [
    behaviouralstageInitialValueData,
    setbehaviouralstageInitialValueData,
  ] = useState(null);

  let hivarray1 = [
    {
      id: dateofhivId,
      status: false,
      value: "",
      group: ["reactive", "positive", "art"],
      shouldHide: true, //from behavioural hiv options
    },
    {
      id: placeofhivId,
      status: false,
      value: "",
      group: ["reactive", "positive", "art"],
      shouldHide: true, //from behavioural hiv options
    },
    {
      id: hivresultId,
      status: false,
      value: "",
      group: ["reactive", "positive", "art"],
      shouldHide: true, //from behavioural hiv options
      shouldSetDefault: true, //from behavioural hiv options
      defaultValue: "Reactive",
    },
    {
      id: referforconfirmationhivId,
      status: false,
      value: "",
      group: ["positive", "art"],
      shouldHide: true, //from behavioural hiv options
      shouldSetDefault: true, //from behavioural hiv options
      defaultValue: "Yes",
    },
    {
      id: dateofconfirmationhivId,
      status: false,
      value: "",
      group: ["positive", "art"],
      shouldHide: true, //from behavioural hiv options
    },
    {
      id: placeofconfirmationhivId,
      status: false,
      value: "",
      group: ["positive", "art"],
      shouldHide: true, //from behavioural hiv options
    },
    {
      id: resultofconfirmatorytesthivId,
      status: false,
      value: "",
      group: ["positive", "art"],
      shouldHide: true, //from behavioural hiv options
      shouldSetDefault: true, //from behavioural hiv options
      defaultValue: "Positive",
    },
    {
      id: artlinkId,
      status: false,
      value: "",
      group: ["art"],
      // shouldSetDefault: true, //from behavioural hiv options
      // defaultValue: "Yes",
    },
    {
      id: artlinkdateId,
      status: false,
      value: "",
      group: ["art"],
      shouldRemoveDateDeps: true, //from behavioural hiv options
    },
    { id: nameofartId, status: false, value: "", group: ["art"] },
    { id: onartnumberId, status: false, value: "", group: ["art"] },
    { id: artStateId, status: false, value: "", group: ["art"] },
    { id: artDistrictId, status: false, value: "", group: ["art"] },
  ];

  const [hivarraydata, sethivarraydata] = useState(hivarray1);
  const [AllHIVConditionCheck, setAllHIVConditionCheck] = useState(false);
  const [hivConditions, setHivConditions] = useState({});

  function getCustomVariableIds() {
    let tempobj = {};
    programData.programs[0].programTrackedEntityAttributes.map((regField) => {
      let regFieldName = regField.trackedEntityAttribute.description
        ? regField.trackedEntityAttribute.description
        : regField.trackedEntityAttribute.displayName;

      if (
        regField.trackedEntityAttribute.displayName
          .trim()
          .toLocaleLowerCase() == "presently on anti-tb medication?"
      ) {
        setPresentlyOnAntiTBMedicationId(regField.trackedEntityAttribute.id);
      }
      if (
        regField.trackedEntityAttribute.displayName
          .trim()
          .toLocaleLowerCase() == "documents verified"
      ) {
        setVerifiedFieldId(regField.trackedEntityAttribute.id);
      }
      if (
        regField.trackedEntityAttribute.displayName
          .trim()
          .toLocaleLowerCase() == "offlineid"
      ) {
        setOfflineFieldId(regField.trackedEntityAttribute.id);
      }
      if (regFieldName.trim().toLocaleLowerCase() == "client type") {
        setClientTypeID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["clientTypeID"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "client uid - mrunner") {
        setUicId(regField.trackedEntityAttribute.id);
        tempobj = { ...tempobj, ["uicId"]: regField.trackedEntityAttribute.id };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "first name") {
        setFirstNameId(regField.trackedEntityAttribute.id);
        setGivenName(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["firstNameId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "surname") {
        setlastNameId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["lastNameId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (
        regFieldName.trim().toLocaleLowerCase() == "phone number (permanent)"
      ) {
        setRegPhoneNumberId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regPhoneNumberId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLocaleLowerCase() == "phone number (secondary)"
      ) {
        setRegPhoneNumberSecondaryId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regPhoneNumberSecondaryId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "code") {
        setRegPhoneNumberCodeId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regPhoneNumberCodeId"]: regField.trackedEntityAttribute.id,
          ["regPhoneNumberCodeBO"]: regField.trackedEntityAttribute,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "registered by") {
        setRegRegisteredById(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regRegisteredById"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "addresslocation") {
        setAaddressLocationId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["addressLocationId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim() == "QR code") {
        setQrCode(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["qrCodeId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "age - mrunner") {
        setAgeUID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["ageUID"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "gender") {
        setGenderUID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["genderUID"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "hiv status") {
        setHivStatusId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["hivStatusId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "patient address") {
        setRegAddressId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regAddressId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "date of birth") {
        setDobID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["dobID"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "place of visit - mrunner") {
        setPlaceofVisit(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["placeofVisit"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "name of halt point - mrunner") {
        setNameofHaltPoint(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["nameofHaltPoint"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() == "do you have a child - mrunner"
      ) {
        setdoyouhavechild(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["doyouhavechild"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "no. of male - mrunner") {
        setnoofmale(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["noofmale"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "no. of female - mrunner") {
        setnooffemale(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["nooffemale"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "no. of tg - mrunner") {
        setnooftg(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["nooftg"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "mobile number - mrunner") {
        setmobilenumberId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["mobilenumberId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "is permanent address same as current address"
      ) {
        setispermanentaddsameascurrentId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["ispermanentaddsameascurrentId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "current ward/house number - mrunner"
      ) {
        setcurrentwardId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentwardId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "current state - mrunner") {
        setcurrentstateId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentstateId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "permanent state - mrunner") {
        setpermanentstateId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentstateId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "current district - mrunner") {
        setcurrentdistrictId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentdistrictId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "permanent district - mrunner") {
        setpermanentdistrictId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentdistrictId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "current block/taluka/mandal - mrunner"
      ) {
        setcurrentblockId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentblockId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (
        regFieldName.trim().toLowerCase() ==
        "permanent block/taluka/mandal - mrunner"
      ) {
        setpermanentblockId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentblockId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() == "current village / city - mrunner"
      ) {
        setcurrentvillageId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentvillageId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (
        regFieldName.trim().toLowerCase() ==
        "permanent village / city - mrunner"
      ) {
        setpermanentvillageId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentvillageId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "permanent street / colony name - mrunner"
      ) {
        setpermanentstreetId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentstreetId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "current street / colony name - mrunner"
      ) {
        setcurrentstreetId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentstreetId"]: regField.trackedEntityAttribute.id,
        };
      } //Current Street / Colony Name - Mrunner

      if (
        regFieldName.trim().toLowerCase() ==
        "permanent ward/house number - mrunner"
      ) {
        setpermanentwardId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentwardId"]: regField.trackedEntityAttribute.id,
        };
      }

      //Current Family Mobile No - Mrunner
      if (
        regFieldName.trim().toLowerCase() ==
        "current family mobile no - mrunner"
      ) {
        setcurrentfamilynoId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentfamilynoId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "permanent family mobile no - mrunner"
      ) {
        setpermanentfamilynoId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentfamilynoId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "current landmark - mrunner") {
        setcurrentlandmarkId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentlandmarkId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "permanent landmark - mrunner") {
        setpermanentlandmarkId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentlandmarkId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "current pincode - mrunner") {
        setcurrentpincodeId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["currentpincodeId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "permanent pincode - mrunner") {
        setpermanentpincodeId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["permanentpincodeId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() ==
        "client registration date - mrunner"
      ) {
        setclientregdateId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["clientregdateId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLowerCase() == "do you have a child - mrunner"
      ) {
        setdoyouhavechildId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["doyouhavechildId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (
        regFieldName.trim().toLowerCase() ==
        "spouse / partner name (if applicable) - mrunner"
      ) {
        setpartnernameId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["partnernameId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "marital status - mrunner") {
        setmaritalstatusId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["maritalstatusId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "occupation - mrunner") {
        setoccupationId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["occupationId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "other - mrunner") {
        setoccupationotherId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["occupationotherId"]: regField.trackedEntityAttribute.id,
        };
      }
    });

    programData.programs[0].programStages.map((stage) => {
      let stageName = stage.description ? stage.description : stage.displayName;

      if (stageName.trim() == "Risk Assessment") {
        setRiskAssementStageId(stage.id);
        tempobj = { ...tempobj, ["riskAssementStageId"]: stage.id };
      }
      if (stageName.trim() == "Referral Services") {
        setReferralServiceStageId(stage.id);
        tempobj = { ...tempobj, ["referralServiceStageId"]: stage.id };
      }
      if (stageName.trim() == "NCD Screening") {
        setNCDStageId(stage.id);
        tempobj = { ...tempobj, ["NCDStageId"]: stage.id };
      }
      if (stageName.trim() == "CD Screening") {
        setCDStageId(stage.id);
        tempobj = { ...tempobj, ["CDStageId"]: stage.id };
      }
      stage.programStageDataElements.map((de) => {
        let fieldname = de.dataElement.description
          ? de.dataElement.description
          : de.dataElement.formName
          ? de.dataElement.formName
          : de.dataElement.displayName;
        if (fieldname) {
          if (
            fieldname.trim().toLowerCase() ==
            "date of accessing service - mrunner"
          ) {
            setDateofAccessingServiceId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["DateofAccessingServiceId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim().toLowerCase() ==
            "date of lifestyle assessment – mrunner"
          ) {
            setdateoflifestyleassessmentId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateoflifestyleassessmentId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim().toLowerCase() ==
            "date of sexual behaviour assessment  - mrunner"
          ) {
            setdateofsexualbehaviourassessmentId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofsexualbehaviourassessmentId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Test result (TB)") {
            setTestresultTBId(de.dataElement.id);
            tempobj = { ...tempobj, ["testresultTBId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "TB treatment initiated") {
            setTbtreatmentinitiatedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["tbtreatmentinitiatedId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Refer to") {
            setReferToId(de.dataElement.id);
            tempobj = { ...tempobj, ["referToId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Select Referral Service") {
            setSelectReferralServiceId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["selectReferralServiceId"]: de.dataElement.id,
            };
          }

          //referral start
          if (fieldname.trim() == "mWRD Result") {
            setmWRDresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["mWRDresultId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "CXR outcome") {
            setCXRresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["CXRresultId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "CRP Result") {
            setCRPresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["CRPresultId"]: de.dataElement.id };
          }
          //Eligibility for TB infection testing

          if (fieldname.trim() == "Lab Test result") {
            //TB Test result
            setTBTestRusultId(de.dataElement.id);
            tempobj = { ...tempobj, ["tbTestRusultId"]: de.dataElement.id };
          }
          //setNoneOptionID
          if (fieldname.trim() == "None") {
            //TB Test result
            setNoneOptionID(de.dataElement.id);
            tempobj = { ...tempobj, ["noneOptionID"]: de.dataElement.id };
          }
          //setSymptomsID
          if (
            fieldname.trim() ==
            "Currently are you experiencing any of the following symptoms"
          ) {
            //TB Test result
            setSymptomsID(de.dataElement.id);
            tempobj = { ...tempobj, ["symptomsID"]: de.dataElement.id };
            setSymptomsDisplayName(de.dataElement.displayName);
            tempobj = {
              ...tempobj,
              ["symptomsDisplayName"]: de.dataElement.displayName,
            };
          }

          if (fieldname.trim() == "Is mWRD report available?") {
            //TB Test result
            setmWRDreportavailableID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["mWRDreportavailableID"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Is CRP report available?") {
            //TB Test result
            setCRPreportavailableID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["CRPreportavailableID"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Referral facility") {
            //TB Test result
            setReferToFacilityCenter(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referToFacilityCenter"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Family - Type of Service - Mrunner") {
            setTypeOfServiceId(de.dataElement.id);
            tempobj = { ...tempobj, ["TypeOfServiceId"]: de.dataElement.id };
          }
          if (
            fieldname.trim() ==
            "Have you ever used any drug by Injection (NON-MEDICAL USE ONLY)? - Mrunner"
          ) {
            setdrugbyinjectionId(de.dataElement.id);
            tempobj = { ...tempobj, ["drugbyinjectionId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "How long ago was it used? - Mrunner") {
            sethowlongwasitusedId(de.dataElement.id);
            tempobj = { ...tempobj, ["howlongwasitusedId"]: de.dataElement.id };
          }
          if (
            fieldname.trim() ==
            "Do you go home on any specific time like festival etc.? - Mrunner"
          ) {
            setdoyougohomeonfectivalId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["doyougohomeonfectivalId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "How many days do you stay at home when you go to home during specific time? - Mrunner"
          ) {
            sethowmanydaysdoyoustayathomeId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["howmanydaysdoyoustayathomeId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Current Pincode - Mrunner") {
            setcurrentpincodeId(de.dataElement.id);
            tempobj = { ...tempobj, ["currentpincodeId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Permanent Pincode - Mrunner") {
            setpermanentpincodeId(de.dataElement.id);
            tempobj = { ...tempobj, ["permanentpincodeId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Drug use - Mrunner") {
            setdruguseId(de.dataElement.id);
            tempobj = { ...tempobj, ["druguseId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Please Specify - Drug use - Mrunner") {
            setpleasespecifydrugsId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["pleasespecifydrugsId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "If Reactive Referred for Confirmation - Mrunner"
          ) {
            sethivreferforconfirmationId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["hivreferforconfirmationId"]: de.dataElement.id,
            };
          }

          //Are you sexually active? - Mrunner

          if (fieldname.trim() == "Are you sexually active? - Mrunner") {
            setareyousexuallyactiveId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["areyousexuallyactiveId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "When was the last time you had sex? - Mrunner"
          ) {
            setlasttimeyouhadsexId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["lasttimeyouhadsexId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Result of Confirmatory Test - Mrunner") {
            setresultofconfirmatorytestId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["resultofconfirmatorytestId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Confirmation - Mrunner") {
            setdateofconfirmationId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofconfirmationId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "ART Link Date - Mrunner") {
            setartlinkdateId(de.dataElement.id);
            tempobj = { ...tempobj, ["artlinkdateId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Name of ART Center - Mrunner") {
            setnameofartId(de.dataElement.id);
            tempobj = { ...tempobj, ["nameofartId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "ON ART Number - Mrunner") {
            setonartnumberId(de.dataElement.id);
            tempobj = { ...tempobj, ["onartnumberId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Found TB Symptoms - Mrunner") {
            setfoundtbsymptomId(de.dataElement.id);
            tempobj = { ...tempobj, ["foundtbsymptomId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Referred for TB Test - Mrunner") {
            setreferfortbId(de.dataElement.id);
            tempobj = { ...tempobj, ["referfortbId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Additional Date of Service - Mrunner") {
            setdateofserviceaddId(de.dataElement.id);
            tempobj = { ...tempobj, ["dateofserviceaddId"]: de.dataElement.id };
          }
          if (
            fieldname.trim() == "Additional - Service Availed Date - Mrunner"
          ) {
            setdateserviceavailedaddId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateserviceavailedaddId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Additional-Referral Facility Name-Mrunner") {
            setreffacnameId(de.dataElement.id);
            tempobj = { ...tempobj, ["reffacnameId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Date of HIV Screening - Mrunner") {
            setdateofhivId(de.dataElement.id);
            tempobj = { ...tempobj, ["dateofhivId"]: de.dataElement.id };
          }

          //Family - Date of Service - Mrunner
          if (fieldname.trim() == "Family - Date of Service - Mrunner") {
            setdateofservicefamilyId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofservicefamilyId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Social Welfare Schemes - Date of Service Availed-Mrunner"
          ) {
            setdateofserviceavailedsocialwelfareId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofserviceavailedsocialwelfareId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Social Welfare Schemes -Date of Service-Mrunner"
          ) {
            setdateofservicesocialwelfareId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofservicesocialwelfareId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Social Protection -Date of Service Availed-Mrunner"
          ) {
            setdateofserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Social Linkage -Date of Linkage to Service-Mrunner"
          ) {
            setdateoflinkagetoserviceId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateoflinkagetoserviceId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Hep. C Date of Treatment Completion - Mrunner"
          ) {
            setdateofhepCtreatmentcompletionId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofhepCtreatmentcompletionId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Hep. B Date of Treatment Completion - Mrunner"
          ) {
            setdateofhepBtreatmentcompletionId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofhepBtreatmentcompletionId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Hep. C Treatment Initiate Date - Mrunner") {
            setdateofhepCtreatmentinitiationId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofhepCtreatmentinitiationId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Hep. B Treatment Initiate Date - Mrunner") {
            setdateofhepBtreatmentinitiationId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofhepBtreatmentinitiationId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Hep. B Test - Mrunner") {
            setdateofhepBscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofhepBscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Hep. C Test - Mrunner") {
            setdateofhepCscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofhepCscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Syphilis Test - Mrunner") {
            setdateofsyphilisscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofsyphilisscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of STI Screening - Mrunner") {
            setdateofstiscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofstiscreeningId"]: de.dataElement.id,
            };
          }

          //Syphilis Date of Treatment Completion - Mrunner
          if (
            fieldname.trim() ==
            "Syphilis Date of Treatment Completion - Mrunner"
          ) {
            setdateofsyphilistreatmentcompletionId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofsyphilistreatmentcompletionId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Syphilis Treatment Initiate Date - Mrunner"
          ) {
            setdateofsyphilistreatmentinitiationId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofsyphilistreatmentinitiationId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Treatment Initiation - Mrunner") {
            setdateoftreatmentinitiationId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateoftreatmentinitiationId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of TB Test - Mrunner") {
            setdateoftbtestId(de.dataElement.id);
            tempobj = { ...tempobj, ["dateoftbtestId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Date of TB Screening - Mrunner") {
            setdateoftbscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateoftbscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "HIV -Place of HIV Screening - Mrunner") {
            setplaceofhivId(de.dataElement.id);
            tempobj = { ...tempobj, ["placeofhivId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "HIV Result - Mrunner") {
            sethivresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["hivresultId"]: de.dataElement.id };
          }
          if (
            fieldname.trim() ==
            "If Reactive Referred for Confirmation - Mrunner"
          ) {
            setreferforconfirmationhivId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referforconfirmationhivId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Confirmation - Mrunner") {
            setdateofconfirmationhivId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofconfirmationhivId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Place of Confirmation Test - Mrunner") {
            setplaceofconfirmationhivId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["placeofconfirmationhivId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Result of Confirmatory Test - Mrunner") {
            setresultofconfirmatorytesthivId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["resultofconfirmatorytesthivId"]: de.dataElement.id,
            };
          }
          //Referral Needed for Which Service
          if (fieldname.trim() == "Additional-Referral Needed-Mrunner") {
            setrefneededforserviceId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["refneededforserviceId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Additional Availed Service - Mrunner") {
            setadditionalavailedserviceId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["additionalavailedserviceId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "ART Link - Mrunner") {
            setartlinkId(de.dataElement.id);
            tempobj = { ...tempobj, ["artlinkId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "BP (Measure) Systolic - Mrunner") {
            setbpSystolicId(de.dataElement.id);
            tempobj = { ...tempobj, ["bpSystolicId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "BP (Measure) Diastolic- Mrunner") {
            setbpDiastolicId(de.dataElement.id);
            tempobj = { ...tempobj, ["bpDiastolicId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Additional Service - Mrunner") {
            setaddServiceId(de.dataElement.id);
            tempobj = { ...tempobj, ["addServiceId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Pulse - Mrunner") {
            setpulseId(de.dataElement.id);
            tempobj = { ...tempobj, ["pulseId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Weight (Measure) - Mrunner") {
            setweightId(de.dataElement.id);
            tempobj = { ...tempobj, ["weightId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Height (Measure) - Mrunner") {
            setheightId(de.dataElement.id);
            tempobj = { ...tempobj, ["heightId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "ART State - Mrunner") {
            setartStateId(de.dataElement.id);
            tempobj = { ...tempobj, ["artStateId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "ART District - Mrunner") {
            setartDistrictId(de.dataElement.id);
            tempobj = { ...tempobj, ["artDistrictId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "BMI (Measure) - Mrunner") {
            setbmiID(de.dataElement.id);
            tempobj = { ...tempobj, ["bmiID"]: de.dataElement.id };
          }
          //Service Availed Date - Referral
          if (fieldname.trim() == "Service Availed Date - Referral") {
            setserviceAvailedDate(de.dataElement.id);
            tempobj = { ...tempobj, ["serviceAvailedDate"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Additional - Date of Referral - Mrunner") {
            setaddRefDate(de.dataElement.id);
            tempobj = { ...tempobj, ["addRefDate"]: de.dataElement.id };
          }

          if (fieldname.trim() == "BP Referral Facility Name - Mrunner") {
            setBPRefFacNameId(de.dataElement.id);
            tempobj = { ...tempobj, ["BPRefFacNameId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Sexual Partners - Mrunner") {
            setSexualPartnerId(de.dataElement.id);
            tempobj = { ...tempobj, ["SexualPartnerId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Lover - Mrunner") {
            setLoverId(de.dataElement.id);
            tempobj = { ...tempobj, ["LoverId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Paid - Mrunner") {
            setPaidId(de.dataElement.id);
            tempobj = { ...tempobj, ["PaidId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Others - Sexual Partners - Mrunner") {
            setOtherSexPartnerId(de.dataElement.id);
            tempobj = { ...tempobj, ["OtherSexPartnerId"]: de.dataElement.id };
          }

          if (
            fieldname.trim() ==
            "How many days are you usually away from home during one trip? - Mrunner"
          ) {
            sethowmanydaysareyouusuallyawayfromhomeId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["howmanydaysareyouusuallyawayfromhomeId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "Have you ever used any drug by Injection (NON-MEDICAL USE ONLY)? - Mrunner"
          ) {
            sethaveyouuseddrugininjectionId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["haveyouuseddrugininjectionId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Heroin/Brown Sugar - Mrunner") {
            setheroinbrownsugarId(de.dataElement.id);
            tempobj = { ...tempobj, ["heroinbrownsugarId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Whitener/Solvents - Mrunner") {
            setwhitenersolventId(de.dataElement.id);
            tempobj = { ...tempobj, ["whitenersolventId"]: de.dataElement.id };
          }

          if (
            fieldname.trim() ==
            "Did you received treatment for Syphilis? - Mrunner"
          ) {
            setdidyourecsyphilistreatmentId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["didyourecsyphilistreatmentId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "Did you experience any STI symptom in last three months? - Mrunner"
          ) {
            setdidyouexpSTIId(de.dataElement.id);
            tempobj = { ...tempobj, ["didyouexpSTIId"]: de.dataElement.id };
          }

          if (
            fieldname.trim() ==
            "How many times did you use condoms while having sex with other partner? - Mrunner"
          ) {
            sethowmanytimescomdomusedwithotherId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["howmanytimescomdomusedwithotherId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "How many times did you use condom while having sex with regular partner? - Mrunner"
          ) {
            sethowmanytimescomdomusedwithregularId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["howmanytimescomdomusedwithregularId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "Number of partners you have had in last 1 week? - Mrunner"
          ) {
            setNoofparttnerinlast1weekId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["Noofparttnerinlast1weekId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "CD4 Test Date - Mrunner") {
            setcd4testdateId(de.dataElement.id);
            tempobj = { ...tempobj, ["cd4testdateId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "CD4 Count - Mrunner") {
            setcd4countId(de.dataElement.id);
            tempobj = { ...tempobj, ["cd4countId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "VL Count - Mrunner") {
            setvlcountId(de.dataElement.id);
            tempobj = { ...tempobj, ["vlcountId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Viral Load Test Date - Mrunner") {
            setvltestdateId(de.dataElement.id);
            tempobj = { ...tempobj, ["vltestdateId"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Date of BP Screening  - Mrunner") {
            setdateofbpscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofbpscreeningId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "BP Service Availed Date - Mrunner") {
            setdateofbpserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofbpserviceavailedId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Pulse Screening  - Mrunner") {
            setdateofpulsescreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofpulsescreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Eye Checkup Date - Mrunner") {
            setdateofeyescreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofeyescreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Oral/Dental Checkup Date - Mrunner") {
            setdateoforaldentalscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateoforaldentalscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Diabetes Screening  - Mrunner") {
            setdateofdiabetesscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofdiabetesscreeningId"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "Date of Chronic pain or musculoskeletal Screening  - Mrunner"
          ) {
            setdateofchronicpainscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofchronicpainscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Sleep-related Screening - Mrunner") {
            setdateofsleepscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofsleepscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Mental Health Screening Date  - Mrunner") {
            setdateofmentalhealthsscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofmentalhealthsscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Date of Respiratory Check  - Mrunner") {
            setdateofrespiratoryscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofrespiratoryscreeningId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Acidity / Stomach Screening Date  - Mrunner"
          ) {
            setdateofstomachscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofstomachscreeningId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Other NCDs Screening Date - Mrunner") {
            setdateofotherncdscreeningId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofotherncdscreeningId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Eye Service Availed Date - Mrunner") {
            setdateofeyeserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofeyeserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Oral/Dental Service Availed Date - Mrunner"
          ) {
            setdateoforaldentalserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateoforaldentalserviceavailedId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Diabetes Service Availed Date - Mrunner") {
            setdateofdiabetesserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofdiabetesserviceavailedId"]: de.dataElement.id,
            };
          }
          //Chronic pain Service Availed Date - Mrunner

          if (
            fieldname.trim() == "Chronic pain Service Availed Date - Mrunner"
          ) {
            setdateofchronicserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofchronicserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Sleep-related Service Availed Date - Mrunner"
          ) {
            setdateofsleepserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofsleepserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Mental Health Service Availed Date - Mrunner"
          ) {
            setdateofmentalhealthserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofmentalhealthserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Respiratory Service Availed Date - Mrunner"
          ) {
            setdateofrespiratoryserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofrespiratoryserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Acidity or Stomach Service Availed Date - Mrunner"
          ) {
            setdateofstomachserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofstomachserviceavailedId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Any Other NCDs Service Availed Date - Mrunner"
          ) {
            setdateofotherncdserviceavailedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofotherncdserviceavailedId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Co-Worker - Mrunner") {
            setcoworkerId(de.dataElement.id);
            tempobj = { ...tempobj, ["coworkerId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "STI Treatment Initiate Date - Mrunner") {
            setdateofSTItreatmentdateId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateofSTItreatmentdateId"]: de.dataElement.id,
            };
          }
          //TB Date of Treatment Completion- Mrunner
          if (fieldname.trim() == "TB Date of Treatment Completion- Mrunner") {
            setTBcompletiondateId(de.dataElement.id);
            tempobj = { ...tempobj, ["TBcompletiondateId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Diabetes - In days - Mrunner") {
            setDiabetesIndaysId(de.dataElement.id);
            tempobj = { ...tempobj, ["DiabetesIndaysId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Diabetes-Pre-Existing Diseases - Mrunner") {
            setDiabetesPEDId(de.dataElement.id);
            tempobj = { ...tempobj, ["DiabetesPEDId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Eye Issue Identified - Mrunner") {
            seteyeissueidentifiedId(de.dataElement.id);
            tempobj = { ...tempobj, ["eyeissueidentified"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Eye Detail of issue - Mrunner") {
            seteyedetailofissueId(de.dataElement.id);
            tempobj = { ...tempobj, ["eyedetailofissueId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Eye Detail of issue - Mrunner") {
            seteyedetailofissueId(de.dataElement.id);
            tempobj = { ...tempobj, ["eyedetailofissueId"]: de.dataElement.id };
          }

          //end
        }
      });
    });
    setcustomfieldobj(tempobj);
  }

  async function fetchCaseDetailsFromDatabase() {
    let CaseDetails = await OfflineDb.getDataFromPouchDB("activeCaseDetails");
    setActiveCaseDetails(CaseDetails);

    let CaseFormData = await OfflineDb.getDataFromPouchDB("activeCaseFormData");
    setActiveCaseFormData(CaseFormData);

    if (
      CaseFormData &&
      CaseFormData.data &&
      CaseFormData.data.formFormat &&
      typeof CaseFormData?.data?.formFormat["JAhkKQjlDaQ"] === "string" &&
      CaseFormData?.data?.formFormat["JAhkKQjlDaQ"].startsWith("data:image/")
    ) {
      const file = base64ToFile(
        CaseFormData.data.formFormat["JAhkKQjlDaQ"],
        "signature.png"
      );

      CaseFormData.data.formFormat["JAhkKQjlDaQ"] = file;
      setActiveCaseFormData(CaseFormData);
    }

    if (
      CaseFormData &&
      CaseFormData.data &&
      CaseFormData.data.formFormat &&
      typeof CaseFormData?.data?.formFormat["HDbRoNrt77N"] === "string" &&
      CaseFormData?.data?.formFormat["HDbRoNrt77N"].startsWith("data:image/")
    ) {
      const file = base64ToFile(
        CaseFormData.data.formFormat["HDbRoNrt77N"],
        "finger.png"
      );

      CaseFormData.data.formFormat["HDbRoNrt77N"] = file;
      setActiveCaseFormData(CaseFormData);
    }

    let ContactFlag = await OfflineDb.getDataFromPouchDB("linkContactFlag");
    setLinkContactFlag(ContactFlag);
  }

  useEffect(() => {
    fetchCaseDetailsFromDatabase();

    return () => {
      localStorage.removeItem("childDropDown");
      // localStorage.removeItem("searchtype");
    };
  }, []);

  useEffect(() => {
    if (props.selectTrackedEnityInstanceId) {
      setAddContactFlag(false);
      fetchCaseDetailsFromDatabase();
      setReduxSelectTrackedEntityInstanceId(null);
    }
  }, [props.selectTrackedEnityInstanceId]);

  //this is for UNDP
  useEffect(() => {
    getCustomVariableIds();
  }, []);

  useEffect(() => {
    if (
      trackentityInstanceDetails != null &&
      !_.isEmpty(trackentityInstanceDetails) &&
      navigator.onLine
    ) {
      let InitialValueData = {};
      let stageInitialValueData = {};
      let behaviouralstageInitialValueData = {};
      let promises = [];
      const DataElementGroup = dataElementGroup;
      const stageList = programData.programs[0].programStages;
      let registrationData = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.attributes;
      let stageData1 = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.enrollments[0].events;
      let stageData = [];
      let ObjecteHolder = {};
      let regObjecteHolder = {};
      if (stageList != null) {
        stageList.map((stages) => {
          const filterEvent = stageData1.filter(
            (obj) => obj.programStage == stages.id
          );
          if (filterEvent.length > 1) {
            let sortedEvents = filterEvent.filter(
              (obj) => obj.status != "SCHEDULE"
            );
            if (sortedEvents.length > 0) {
              sortedEvents = _.sortBy(sortedEvents, "lastUpdated");
              stageData.push(sortedEvents[sortedEvents.length - 1]);
            } else {
            }
          } else if (filterEvent.length == 1) {
            stageData.push(filterEvent[0]);
          }
        });
      }

      registrationData.map((fields) => {
        const filterField =
          programData.programs[0].programTrackedEntityAttributes.find(
            (obj) => obj.trackedEntityAttribute.id == fields.attribute
          );

        InitialValueData[fields.attribute] = fields.value;

        if (
          filterField &&
          filterField.trackedEntityAttribute &&
          (filterField.trackedEntityAttribute.valueType == "IMAGE" ||
            filterField.trackedEntityAttribute.valueType == "FILE_RESOURCE")
        ) {
          if (fields.value) {
            const resourceGetApi = "fileResources/" + fields.value;
            regObjecteHolder[fields.attribute] = fields.value;
            promises.push(
              apiServices.getAPI(resourceGetApi).then((resources) => {
                return { dataElement: fields.attribute, value: resources.data };
              })
            );
          }
        }

        // multicheckbox edit logic
        programData.programs[0].programSections.map((programSection) => {
          //if (programSection.renderType['DESKTOP'].type == "SEQUENTIAL") {
          programSection.trackedEntityAttributes.map((elements) => {
            if (
              programSection.trackedEntityAttributes.find(
                (array) => array.id == fields.attribute
              )
            ) {
              if (InitialValueData[programSection.id] == undefined) {
                InitialValueData[programSection.id] = [fields.attribute];
              } else {
                if (
                  !InitialValueData[programSection.id].includes(
                    fields.attribute
                  )
                ) {
                  InitialValueData[programSection.id].push(fields.attribute);
                }
              }
            }
          });
          //}
        });
      });

      const filterStageevent = stageData.filter(
        (obj) => obj.programStage == "DxQpOKIzDXn"
      );

      filterStageevent.map((events) => {
        events.dataValues.map((fields) => {
          if (stageList != null) {
            stageList.map((stages) => {
              const filter = stages.programStageDataElements.filter(
                (obj) => obj.dataElement.id == fields.dataElement
              );

              if (filter.length > 0) {
                if (filter[0].dataElement.fieldMask == "Facility Referral") {
                  try {
                    if (stages.description == "CD Screening")
                      InitialValueData[fields.dataElement] =
                        fields.value.split(",");

                    stageInitialValueData[fields.dataElement] =
                      fields.value.split(",");
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  filter[0].dataElement.valueType == "IMAGE" ||
                  filter[0].dataElement.valueType == "FILE_RESOURCE"
                ) {
                  if (fields.value) {
                    const resourceGetApi = "fileResources/" + fields.value;
                    ObjecteHolder[fields.dataElement] = fields.value;
                    promises.push(
                      apiServices.getAPI(resourceGetApi).then((resources) => {
                        return {
                          dataElement: fields.dataElement,
                          value: resources.data,
                        };
                      })
                    );
                  }
                } else {
                  DataElementGroup.map((DEG) => {
                    DEG.dataElements.map((dataElements) => {
                      if (
                        DEG.dataElements.find(
                          (array) =>
                            array.id == fields.dataElement &&
                            fields.value == "true"
                        )
                      ) {
                        if (stageInitialValueData[DEG.id] == undefined) {
                          if (stages.description == "CD Screening")
                            InitialValueData[DEG.id] = [fields.dataElement];

                          stageInitialValueData[DEG.id] = [fields.dataElement];
                        } else {
                          if (
                            !stageInitialValueData[DEG.id].includes(
                              fields.dataElement
                            )
                          ) {
                            if (stages.description == "CD Screening")
                              InitialValueData[DEG.id].push(fields.dataElement);

                            stageInitialValueData[DEG.id].push(
                              fields.dataElement
                            );
                          }
                        }
                      }
                    });
                  });
                  if (stages.description == "CD Screening") {
                    const exists =
                      stages.programStageSections[0].dataElements.some(
                        (el) => el.id === fields.dataElement
                      );
                    if (exists)
                      InitialValueData[fields.dataElement] =
                        fields.value == "false"
                          ? false
                          : fields.value == "true"
                          ? true
                          : fields.value;
                  }
                  stageInitialValueData[fields.dataElement] =
                    fields.value == "false"
                      ? false
                      : fields.value == "true"
                      ? true
                      : fields.value;
                }
              }
            });
          }
        });
      });

      const filterBehavioralStageevent = stageData.filter(
        (obj) => obj.programStage == "iwQi3VbyxTc"
      );

      // console.log("filterBehavioralStageevent", filterBehavioralStageevent);

      filterBehavioralStageevent.map((events) => {
        events.dataValues.map((fields) => {
          if (stageList != null) {
            stageList.map((stages) => {
              const filter = stages.programStageDataElements.filter(
                (obj) => obj.dataElement.id == fields.dataElement
              );

              if (filter.length > 0) {
                if (filter[0].dataElement.fieldMask == "Facility Referral") {
                  try {
                    behaviouralstageInitialValueData[fields.dataElement] =
                      fields.value.split(",");
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  filter[0].dataElement.valueType == "IMAGE" ||
                  filter[0].dataElement.valueType == "FILE_RESOURCE"
                ) {
                  if (fields.value) {
                    const resourceGetApi = "fileResources/" + fields.value;
                    ObjecteHolder[fields.dataElement] = fields.value;
                    promises.push(
                      apiServices.getAPI(resourceGetApi).then((resources) => {
                        return {
                          dataElement: fields.dataElement,
                          value: resources.data,
                        };
                      })
                    );
                  }
                } else {
                  DataElementGroup.map((DEG) => {
                    DEG.dataElements.map((dataElements) => {
                      if (
                        DEG.dataElements.find(
                          (array) =>
                            array.id == fields.dataElement &&
                            fields.value == "true"
                        )
                      ) {
                        if (
                          behaviouralstageInitialValueData[DEG.id] == undefined
                        ) {
                          behaviouralstageInitialValueData[DEG.id] = [
                            fields.dataElement,
                          ];
                        } else {
                          if (
                            !behaviouralstageInitialValueData[DEG.id].includes(
                              fields.dataElement
                            )
                          ) {
                            behaviouralstageInitialValueData[DEG.id].push(
                              fields.dataElement
                            );
                          }
                        }
                      }
                    });
                  });
                  behaviouralstageInitialValueData[fields.dataElement] =
                    fields.value == "false"
                      ? false
                      : fields.value == "true"
                      ? true
                      : fields.value;
                }
              }
            });
          }
        });
      });

      setbehaviouralstageInitialValueData(behaviouralstageInitialValueData);
      setstagesInitialValues(stageInitialValueData);
      setStageregImageValue(regObjecteHolder);
      setStageImageValue(ObjecteHolder);
      if (promises.length == 0) {
        const activeCaseFormData = {
          data: {
            formFormat: InitialValueData, //valueForFormInput,
            dhisFormat: null, //
          },
        };

        OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
        setActiveCaseFormData(activeCaseFormData);

        if (props.stageTabValue) {
          setValue(props.stageTabValue);
        } else {
          if (
            props.selectTrackedEnityInstanceId &&
            activeCaseDetails &&
            activeCaseDetails.data &&
            props.selectTrackedEnityInstanceId ==
              activeCaseDetails.data.trackedEntityInstance
          ) {
            if (!reduxSelectTrackedEntityInstanceId) {
              setValue(0);
              setReduxSelectTrackedEntityInstanceId(true);
            }
          } else if (value == 0) {
            if (searchEnabled) {
              setValue(1);
            } else {
              setValue(0);
            }
          }
          if (userrolename && userrolename.toLowerCase() == superAdmin) {
            setValue(0);
          }
        }
      } else {
        Promise.all(promises).then((responses) => {
          responses.map((response) => {
            InitialValueData[response.dataElement] = [
              new File([""], response.value.displayName, {
                size: response.value.contentLength,
                type: response.value.contentType,
                webkitRelativePath: "",
              }),
            ];
          });
          const activeCaseFormData = {
            data: {
              formFormat: InitialValueData, //valueForFormInput,
              dhisFormat: null, //
            },
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData(activeCaseFormData);

          if (props.stageTabValue) {
            setValue(props.stageTabValue);
          } else {
            if (
              props.selectTrackedEnityInstanceId &&
              activeCaseDetails &&
              activeCaseDetails.data &&
              props.selectTrackedEnityInstanceId ==
                activeCaseDetails.data.trackedEntityInstance
            ) {
              if (!reduxSelectTrackedEntityInstanceId) {
                setValue(0);
                setReduxSelectTrackedEntityInstanceId(true);
              }
            } else if (value == 0) {
              if (searchEnabled) {
                setValue(1);
              } else {
                setValue(0);
              }
            }
          }
          if (userrolename && userrolename.toLowerCase() == superAdmin) {
            setValue(0);
          }
        });
      }
    }
  }, [trackentityInstanceDetails]);

  useEffect(() => {
    if (activeCaseDetails != null) {
      //DownLoad trackentity instace data using api
      if (activeCaseDetails.data != undefined && navigator.onLine) {
        const getURL =
          "trackedEntityInstances/" +
          activeCaseDetails.data.trackedEntityInstance +
          ".json?program=" +
          programData.programs[0].id +
          "&fields=*?";
        setGlobalSpinner(true);
        apiServices
          .getAPI(getURL)
          .then((trackentityInstanceData) => {
            setGlobalSpinner(false);
            if (trackentityInstanceData.data) {
              setTrackentityInstanceDetails(trackentityInstanceData.data);

              const RegDate = trackentityInstanceData.data.attributes.find(i => i.attribute === "OjeHLMsC0gy")?.value;
              if(RegDate)
              setisRegAvailable(true)
              if (programData) {
                const filterEvent =
                  trackentityInstanceData.data.enrollments[0].events.filter(
                    (obj) => obj.programStage == "DxQpOKIzDXn"
                  );
                let sortedEvent = _.sortBy(filterEvent, "created");
                if (sortedEvent.length > 0) {
                  sortedEvent.reverse();
                  const updatedHivArray = hivarray1.map((entry) => {
                    let matchedValues = [];

                    for (const event of sortedEvent) {
                      matchedValues = event.dataValues
                        .filter((dv) => dv.dataElement === entry.id && dv.value)
                        .map((dv) => dv.value);

                      if (matchedValues.length > 0) {
                        // Stop at first event where match is found
                        return {
                          ...entry,
                          status: true,
                          value: matchedValues[0],
                        };
                      }
                    }

                    // No match in any event
                    return { ...entry, status: false, value: [] };
                  });

                  sethivarraydata(updatedHivArray);
                  const conditions = checkConditions(updatedHivArray);
                  setHivConditions(conditions);
                  if (conditions.all) {
                    setAllHIVConditionCheck(true);
                  }
                } else {
                  sethivarraydata(hivarray1);
                }
              }
            } else {
              setTrackentityInstanceDetails({});
            }
          })
          .catch((err) => {
            setGlobalSpinner(false);
          });

        const getImageURL =
          "trackedEntityInstances/" +
          activeCaseDetails.data.trackedEntityInstance +
          "/JAhkKQjlDaQ/image";
        apiServices.getBlobAPI(getImageURL).then((res) => {
          // console.log(res);
          var blob = new Blob([res.data]);
          const imageObjectURL = URL.createObjectURL(blob);
          setSignatureDataURL(imageObjectURL);
        });

        const getFingerURL =
          "trackedEntityInstances/" +
          activeCaseDetails.data.trackedEntityInstance +
          "/HDbRoNrt77N/image";
        apiServices.getBlobAPI(getFingerURL).then((res) => {
          // console.log(res);
          var blob = new Blob([res.data]);
          const imageObjectURL = URL.createObjectURL(blob);
          setFingerDataURL(imageObjectURL);
        });
      } else {
        setTrackentityInstanceDetails({});
      }
    }
  }, [activeCaseDetails, programData]);

  const checkConditions = (updatedHivArray) => {
    let testcondition = false;
    let confirmatorytest = false;
    let confirmatoryresult = "NA";
    let ARTlist = false;
    let ARTDate = false;
    let ARTNumber = false;

    updatedHivArray.forEach((item) => {
      // console.log(`Checking ID: ${item.id}`);

      if (item.status) {
        if (item.id === "sxGSAPKZPnv" && item.value === "Reactive") {
          testcondition = true;
        }
        if (item.id === "rEGsPX8IiLb" && item.value === "Yes") {
          confirmatorytest = true;
        }
        if (item.id === "D8rDnihLJ6L" && item.value === "Positive") {
          confirmatoryresult = true;
        }
        if (item.id === "D8rDnihLJ6L" && item.value === "Negative") {
          confirmatoryresult = false;
        }
        if (item.id === "vYCSpTwJqr5" && item.value === "Yes") {
          ARTlist = true;
        }
      }
    });

    return {
      reactive: testcondition && confirmatoryresult === "NA",
      positive: confirmatorytest && confirmatoryresult,
      art: ARTlist && confirmatoryresult,
      confirmatoryresult,
      all:
        testcondition &&
        confirmatorytest &&
        confirmatoryresult !== "NA" &&
        confirmatoryresult &&
        ARTlist,
    };
    // if (testcondition && confirmatorytest && confirmatoryresult && ARTlist)
    // return true;
    // else return false;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (navigator.onLine) {
    } else {
      try {
        OfflineDb.getSingleEntity(
          activeCaseDetails.data.trackedEntityInstance
        ).then((res) => {});
      } catch (e) {}
    }
  };

  function fetchActiveTabs(currentStage, formValues) {
    // console.log('currentStageformValues', formValues)
    let Flag = true;
    const values = formValues; //activeCaseFormData.data ? activeCaseFormData.data.formFormat : {}
    // console.log('tabschecking', values)
    let prevStageId = "";
    let workFlowHideFlag = true;
    let submittedEventsList = _.isEmpty(trackentityInstanceDetails)
      ? []
      : trackentityInstanceDetails.enrollments[0].events;
    if (programRules != null && programRulesVariables != null) {
      programRules.map((rules) => {
        const filteredRule = rules.programRuleActions.filter(
          (obj) => obj.programRuleActionType == "HIDEPROGRAMSTAGE"
        );

        if (filteredRule.length > 0) {
          const getStageRule = filteredRule.find(
            (obj) => obj.programStage.id == currentStage.id
          );
          if (getStageRule != undefined) {
            const operators = ["==", "!="];
            const condition = rules.condition;
            const splitConditions = condition.split("&&");

            let val = null;
            let conditionArray = [];
            splitConditions.map((splitCondition) => {
              const variableName = splitCondition.match(/\{(.*?)\}/)[1];
              const parentRaw = programRulesVariables.filter(
                (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
              ); //[0] .dataElement.id
              const parentNameFromFilter =
                parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
              const parentId =
                parentRaw.length > 0
                  ? parentRaw[0].dataElement
                    ? parentRaw[0].dataElement.id
                    : undefined
                  : undefined;

              const parentNameFromFilterStart =
                splitCondition.search(parentNameFromFilter);
              const parentNameLength = parentNameFromFilter
                ? parentNameFromFilter.length
                : undefined;

              const operatorInitLength =
                parentNameFromFilterStart + parentNameLength + 2;

              const operator = splitCondition.substring(
                operatorInitLength,
                operatorInitLength + 2
              );

              const alternateOperatorFinding = operators.map((ops) => {
                if (splitCondition.search(ops) > -1) {
                  const a = {
                    operator: ops,
                    operatorLength: splitCondition.search(ops),
                  };
                  return a;
                }
              });

              const stringLength = splitCondition.length;
              if (parentNameFromFilter) {
                const filteredOperator = alternateOperatorFinding.filter(
                  (obj) => obj != undefined
                );

                const conditionValueRaw =
                  filteredOperator.length > 0
                    ? splitCondition.substring(
                        filteredOperator[0].operatorLength + 3,
                        splitCondition.length
                      )
                    : undefined;

                const removeEmptySpace =
                  conditionValueRaw != undefined
                    ? conditionValueRaw.substring(
                        conditionValueRaw.length - 1,
                        conditionValueRaw.length
                      ) == " "
                      ? conditionValueRaw.substring(
                          0,
                          conditionValueRaw.length - 1
                        )
                      : conditionValueRaw
                    : undefined;

                const conditionValue =
                  removeEmptySpace != undefined
                    ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                    : undefined;
                const conditionalOperator =
                  filteredOperator.length > 0
                    ? filteredOperator[0].operator
                    : undefined;
                let conditionForValidation = null;
                if (conditionalOperator != undefined) {
                  val = conditionValue;
                  switch (conditionalOperator) {
                    case "==":
                      if (values != undefined) {
                        if (
                          values[parentId] != undefined &&
                          String(values[parentId]) == String(conditionValue)
                        ) {
                          Flag = false;
                        } else {
                          Flag = true;
                        }
                      }
                      break;
                  }
                }
              }
            });
          }
        }
      });
    }

    if (Flag == true) {
      if (activeTabsOnSubmit[activeTabsOnSubmit.length - 1]) {
        // console.log('submittedEventsList', submittedEventsList, activeTabsOnSubmit)
        prevStageId = activeTabsOnSubmit[activeTabsOnSubmit.length - 1];
        let filterPrevStageEvents = submittedEventsList.filter(
          (obj) => obj.programStage == prevStageId
        );
        // console.log('filterPrevStageEvents', filterPrevStageEvents)
        if (filterPrevStageEvents.length > 0) {
          const prevStageLatestData = filterPrevStageEvents[0]; //filterPrevStageEvents[filterPrevStageEvents.length - 1]
          const prevStageLatestDataEventId = prevStageLatestData.event;
          const findIndexOfPrevStageLatestDataEventId =
            submittedEventsList.findIndex(
              (obj) => obj.event == prevStageLatestDataEventId
            );
          const findNextIndexOfIndexOfPrevStageLatestDataEventId =
            submittedEventsList[findIndexOfPrevStageLatestDataEventId + 1];

          if (findNextIndexOfIndexOfPrevStageLatestDataEventId == undefined) {
            workFlowHideFlag = false;
          } else {
            workFlowHideFlag = true;
          }
        } else {
          workFlowHideFlag = false;
        }
      } else {
        workFlowHideFlag = true;
      }

      activeTabsOnSubmit.push(currentStage.id);
    } else {
    }
    return activeTabsOnSubmit;
  }

  function checkTabs(currentStage) {
    // console.log('currentStage', currentStage, trackentityInstanceDetails, activeCaseFormData, programRules, programRulesVariables)
    let Flag = true;
    const values = activeCaseFormData.data
      ? activeCaseFormData.data.formFormat
      : {};
    let prevStageId = "";
    let workFlowHideFlag = true;
    let submittedEventsList = _.isEmpty(trackentityInstanceDetails)
      ? []
      : trackentityInstanceDetails.enrollments[0].events;
    if (programRules != null && programRulesVariables != null) {
      programRules.map((rules) => {
        const filteredRule = rules.programRuleActions.filter(
          (obj) => obj.programRuleActionType == "HIDEPROGRAMSTAGE"
        );

        if (filteredRule.length > 0) {
          const getStageRule = filteredRule.find(
            (obj) => obj.programStage.id == currentStage.id
          );
          if (getStageRule != undefined) {
            const operators = ["==", "!="];
            const condition = rules.condition;
            const splitConditions = condition.split("&&");

            let val = null;
            let conditionArray = [];
            splitConditions.map((splitCondition) => {
              const variableName = splitCondition.match(/\{(.*?)\}/)[1];
              const parentRaw = programRulesVariables.filter(
                (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
              ); //[0] .dataElement.id
              const parentNameFromFilter =
                parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
              const parentId =
                parentRaw.length > 0
                  ? parentRaw[0].dataElement
                    ? parentRaw[0].dataElement.id
                    : undefined
                  : undefined;

              const parentNameFromFilterStart =
                splitCondition.search(parentNameFromFilter);
              const parentNameLength = parentNameFromFilter
                ? parentNameFromFilter.length
                : undefined;

              const operatorInitLength =
                parentNameFromFilterStart + parentNameLength + 2;

              const operator = splitCondition.substring(
                operatorInitLength,
                operatorInitLength + 2
              );

              const alternateOperatorFinding = operators.map((ops) => {
                if (splitCondition.search(ops) > -1) {
                  const a = {
                    operator: ops,
                    operatorLength: splitCondition.search(ops),
                  };
                  return a;
                }
              });

              const stringLength = splitCondition.length;
              if (parentNameFromFilter) {
                const filteredOperator = alternateOperatorFinding.filter(
                  (obj) => obj != undefined
                );

                const conditionValueRaw =
                  filteredOperator.length > 0
                    ? splitCondition.substring(
                        filteredOperator[0].operatorLength + 3,
                        splitCondition.length
                      )
                    : undefined;

                const removeEmptySpace =
                  conditionValueRaw != undefined
                    ? conditionValueRaw.substring(
                        conditionValueRaw.length - 1,
                        conditionValueRaw.length
                      ) == " "
                      ? conditionValueRaw.substring(
                          0,
                          conditionValueRaw.length - 1
                        )
                      : conditionValueRaw
                    : undefined;

                const conditionValue =
                  removeEmptySpace != undefined
                    ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                    : undefined;
                const conditionalOperator =
                  filteredOperator.length > 0
                    ? filteredOperator[0].operator
                    : undefined;
                let conditionForValidation = null;
                if (conditionalOperator != undefined) {
                  val = conditionValue;
                  switch (conditionalOperator) {
                    case "==":
                      if (values != undefined) {
                        if (
                          values[parentId] != undefined &&
                          String(values[parentId]) == String(conditionValue)
                        ) {
                          Flag = false;
                        } else {
                          Flag = true;
                        }
                      }
                      break;
                  }
                }
              }
            });
          }
        }
      });
    }

    if (Flag == true) {
      if (activeTabs[activeTabs.length - 1]) {
        prevStageId = activeTabs[activeTabs.length - 1];
        let filterPrevStageEvents = submittedEventsList.filter(
          (obj) => obj.programStage == prevStageId
        );
        // console.log('filterPrevStageEvents', filterPrevStageEvents)
        if (filterPrevStageEvents.length > 0) {
          const prevStageLatestData = filterPrevStageEvents[0]; //filterPrevStageEvents[filterPrevStageEvents.length - 1]
          const prevStageLatestDataEventId = prevStageLatestData.event;
          const findIndexOfPrevStageLatestDataEventId =
            submittedEventsList.findIndex(
              (obj) => obj.event == prevStageLatestDataEventId
            );
          const findNextIndexOfIndexOfPrevStageLatestDataEventId =
            submittedEventsList[findIndexOfPrevStageLatestDataEventId + 1];

          if (findNextIndexOfIndexOfPrevStageLatestDataEventId == undefined) {
            workFlowHideFlag = false;
          } else {
            workFlowHideFlag = true;
          }
        } else {
          workFlowHideFlag = false;
        }
      } else {
        workFlowHideFlag = true;
      }
      activeTabs.push(currentStage.id);
    }
    //console.log('activeTabs', activeTabs)
    if (workFlow) {
      if (Flag && workFlowHideFlag) {
        return true;
      } else {
        return false;
      }
    } else {
      return Flag;
    }
  }

  function stageAccessCheck(stages) {
    const userList = stages.userAccesses;
    const userGroups = stages.userGroupAccesses;
    let stageAcsess = false;
    const getUSerBo = userData;
    const userGroupID =
      getUSerBo.userGroups && getUSerBo.userGroups.length > 0
        ? getUSerBo.userGroups[0].id
        : getUSerBo.id;
    const filterUserIdInMeta =
      userList && userList.length > 0
        ? userList.filter((obj) => obj.id == getUSerBo.id)
        : [];
    const filterUserGroupInMeta =
      userGroups && userGroups.length > 0
        ? userGroups.filter((obj) => obj.id == userGroupID)
        : [];
    if (filterUserIdInMeta.length > 0) {
      const filteredUserList = filterUserIdInMeta[0].access;
      if (filteredUserList == "rw------" || filteredUserList == "rwrw----") {
        stageAcsess = true;
      }
    } else if (filterUserGroupInMeta.length > 0) {
      const filteredUserList = filterUserGroupInMeta[0].access;
      if (filteredUserList == "rw------" || filteredUserList == "rwrw----") {
        stageAcsess = true;
      }
    }
    return stageAcsess;
  }

  function renderRegistrationSections(
    registrationFieldsObj,
    values,
    form,
    programRules,
    icons
  ) {
    let sectionWiseDE = [];

    registrationFieldsObj.programSections.map((section, j) => {
      let updateafterapproved = false;
      let subsectionDeArray = [];
      if (section.renderType.DESKTOP.type == "SEQUENTIAL") {
      } else {
        sectionWiseDE.push(
          <Grid
            container
            spacing={3}
            className="sectiondivmaincontainer mrunnerClientrecord  mt-10px"
          >
            <Grid item xs={12} sm={12} md={12}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={`${classes.heading} mrunnerHeader`}>
                    <strong>{t(section.name)}</strong>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div>
                      <Grid container spacing={3} className="">
                        {/* <Grid item xs={12} sm={6} md={6} lg={3}> */}
                        {section.trackedEntityAttributes.map((de, i) => {
                          return registrationFieldsObj.programTrackedEntityAttributes.map(
                            (fields) => {
                              if (
                                de.id == fields.trackedEntityAttribute.id ||
                                (j == 0 &&
                                  i ==
                                    section.trackedEntityAttributes.length -
                                      1 &&
                                  fields &&
                                  fields.trackedEntityAttribute &&
                                  fields.trackedEntityAttribute.description &&
                                  fields.trackedEntityAttribute.description ==
                                    "ProfileImage")
                              ) {
                                if (
                                  de.id == fields.trackedEntityAttribute.id &&
                                  !allsubsectiondes.includes(de.id)
                                ) {
                                  return renderRegistrationField(
                                    fields,
                                    values,
                                    form,
                                    programRules,
                                    icons,
                                    registrationFieldsObj
                                  );
                                }
                              }
                            }
                          );
                        })}
                      </Grid>

                      {/* REnder sub section here */}
                      {subSectionJson[section.name]?.length > 0 ? (
                        <>
                          {subSectionJson[section.name].map((section) => {
                            return (
                              <>
                                <Typography className="lab-heading mb-10px fbold mt-20px">
                                  {" "}
                                  {t(section.subsectionName)}
                                </Typography>
                                <Divider
                                  className="mb-10px"
                                  style={{ maxWidth: "98%" }}
                                />
                                <Grid container spacing={3} className="">
                                  {section.deList.map((de) => {
                                    return registrationFieldsObj.programTrackedEntityAttributes.map(
                                      (fields) => {
                                        if (
                                          de == fields.trackedEntityAttribute.id
                                        ) {
                                          subsectionDeArray.push(de);

                                          return renderRegistrationField(
                                            fields,
                                            values,
                                            form,
                                            programRules,
                                            icons,
                                            registrationFieldsObj
                                          );
                                        }
                                      }
                                    );
                                  })}
                                </Grid>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        );
      }
    });

    return sectionWiseDE;
  }

  const incrementPaddedNumber = (input) => {
    const number = parseInt(input, 10) + 1;
    return number.toString().padStart(input.length, "0");
  };

  async function registerNewUSer(
    saveCaseInput,
    valuesToSave,
    valueForFormInput,
    whatsAppFieldId,
    orgUnit
  ) {
    if (navigator.onLine) {
      //setGlobalSpinner(true);
      let UICCode;
      const ouAPI =
        "organisationUnits/" +
        sessionUserBoValue.organisationUnits[0].id +
        "?fields=*";

      await apiServices
        .getAPI(ouAPI)
        .then((OUStructureParams) => {
          // console.log("ou", OUStructureParams);
          if (
            !OUStructureParams.data.description ||
            OUStructureParams.data.description == "000000"
          ) {
            UICCode = OUStructureParams.data.description = "000001";
          } else {
            UICCode = OUStructureParams.data.description =
              incrementPaddedNumber(OUStructureParams.data.description);
          }

          const ouputAPI =
            "organisationUnits/" +
            sessionUserBoValue.organisationUnits[0].id +
            "?mergeMode=REPLACE";

          const updateUserActiveFlag = async (userId, isSyncedValue) => {
            try {
              await db.collection("users").doc(userId).update({
                isSynced: isSyncedValue,
              });
              // console.log("User flag updated");
            } catch (error) {
              console.error("Error updating user flag:", error);
            }
          };

          apiServices
            .putAPI(ouputAPI, OUStructureParams.data)
            .then((res) => {
              // console.log(res);

              const orgdata = orgDetails.ancestors || [];
              const level3Item = orgdata.find((item) => item.level === 3);
              const level4Item = orgdata.find((item) => item.level === 4);

              if (!level3Item || !level4Item) {
                console.error("Missing level3 or level4 organization data");
                setGlobalSpinner(false);
                return;
              }

              const UIC = `${level3Item.code}-${level4Item.name
                .slice(0, 2)
                .toUpperCase()}-${orgDetails.code}-${UICCode}`;

              // If you need to store it in state or pass somewhere:
              setUIC(UIC);
              let UICode = { attribute: uicId, value: UIC };
              saveCaseInput.attributes.push(UICode);
              // console.log(UIC, saveCaseInput, "UIC");
              setGlobalSpinner(false);

              apiServices
                .postAPI("trackedEntityInstances", saveCaseInput)
                .then((response) => {
                  axios.post(
                    process.env.NODE_ENV === "development"
                      ? `http://localhost:9000/mrunner_api/refreshDashboards`
                      : `${window.location.protocol}//${window.location.host}/mrunner_api/refreshDashboards`,
                    { r_id: 2 }
                  );

                  if (
                    valueForFormInput["whatsApp"] &&
                    valueForFormInput[whatsAppFieldId]
                  ) {
                    let phoneCode =
                      regPhoneNumberCodeId &&
                      valueForFormInput[regPhoneNumberCodeId]
                        ? valueForFormInput[regPhoneNumberCodeId]
                        : "91";
                    apiServices
                      .getAPI(
                        `whatsapp/send/custommessage?phonenumbers=${phoneCode}${valueForFormInput[whatsAppFieldId]}&name=${valueForFormInput[firstNameId]}&uic=${valueForFormInput[uicId]}&msgtype=registration`
                      )
                      .then((response) => {});
                  }

                  const trackedEntityInstance =
                    response.data.response.importSummaries[0].reference;
                  const programId = programData.programs[0].id;
                  const enrollmentInputJson = {
                    trackedEntityInstance: trackedEntityInstance,
                    program: programId,
                    status: "ACTIVE",
                    orgUnit: orgUnit,
                    enrollmentDate: moment().format("YYYY-MM-DD"),
                    incidentDate: moment().format("YYYY-MM-DD"),
                  };
                  //setGlobalSpinner(false)

                  registartionSuccess();
                  setGlobalSpinner(false);

                  function registartionSuccess() {
                    const enroll = ""; //enrollmentResponse.data.response.importSummaries[0].reference
                    if (
                      programData.programs[0].useFirstStageDuringRegistration ==
                        false &&
                      relationShipId != "" &&
                      Configuration.registrationForm.linkContactInAlert
                    ) {
                      //save data
                      const activeCaseDetails = {
                        trackedEntityInstance: trackedEntityInstance,
                        enrollmentId: enroll,
                      };

                      const activeCaseFormData = {
                        formFormat: valueForFormInput,
                        dhisFormat: valuesToSave,
                      };
                      const linkContact = {
                        enabled: false,
                        linkTrackedEntityInstance: trackedEntityInstance,
                      };
                      OfflineDb.setDataIntoPouchDB(
                        "activeCaseDetails",
                        activeCaseDetails
                      );
                      OfflineDb.setDataIntoPouchDB(
                        "activeCaseFormData",
                        activeCaseFormData
                      );
                      OfflineDb.setDataIntoPouchDB(
                        "linkContactFlag",
                        linkContact
                      );
                      swal({
                        title: t("Success"),
                        text: t(
                          "Individual Registered. Your dashboard will load shortly."
                        ),
                        icon: "success",
                        button: t("Close"),
                      });
                      //laod next active tab
                      if (localStorage.getItem("fbuserid"))
                        updateUserActiveFlag(
                          localStorage.getItem("fbuserid"),
                          true
                        );

                      const nextTab = activeTabs[0];
                      if (nextTab) {
                        const indexOfNextTab =
                          programData.programs[0].programStages.findIndex(
                            (obj) => obj.id == nextTab
                          );
                        setValue(indexOfNextTab + 1);
                      } else {
                        setValue(value);
                      }

                      setActiveCaseDetails({
                        data: {
                          trackedEntityInstance: trackedEntityInstance,
                          enrollmentId: enroll,
                        },
                      });
                    } else {
                      const activeCaseDetails = {
                        trackedEntityInstance: trackedEntityInstance,
                        enrollmentId: enroll,
                      };

                      const activeCaseFormData = {
                        formFormat: valueForFormInput,
                        dhisFormat: valuesToSave,
                      };
                      const linkContact = {
                        enabled: false,
                        linkTrackedEntityInstance: trackedEntityInstance,
                      };
                      OfflineDb.setDataIntoPouchDB(
                        "activeCaseDetails",
                        activeCaseDetails
                      );
                      OfflineDb.setDataIntoPouchDB(
                        "activeCaseFormData",
                        activeCaseFormData
                      );
                      OfflineDb.setDataIntoPouchDB(
                        "linkContactFlag",
                        linkContact
                      );
                      swal({
                        title: t("Success"),
                        text: t(
                          "Individual Registered. Your dashboard will load shortly."
                        ),
                        icon: "success",
                        button: t("Close"),
                      });
                      
                      updateUserActiveFlag(
                        localStorage.getItem("fbuserid"),
                        true
                      );
                      //save data
                      setActiveCaseDetails({
                        data: {
                          trackedEntityInstance: trackedEntityInstance,
                          enrollmentId: enroll,
                        },
                      });
                      setActiveCaseFormData({
                        data: {
                          formFormat: valueForFormInput, //valueForFormInput,
                          dhisFormat: valuesToSave, //
                        },
                      });
                    }
                  }
                  //})
                })
                .catch((err) => {
                  swal({
                    title: t("Error"),
                    text: err,
                    icon: "error",
                    button: t("Close"),
                  });
                  setGlobalSpinner(false);
                });
            })
            .catch((err) => {
              console.log(err);
              setGlobalSpinner(false);
            });
        })
        .catch((err) => {
          console.log(err);
          swal({
            title: t("Error"),
            text: err,
            icon: "error",
            button: t("Close"),
          });
          setGlobalSpinner(false);
        });
    }
  }

  function renderRegistrationField(registrationFields, values, form) {
    const onGoogleLocatioChangeParent = (value) => {
      values[value.fieldId] = value.value.label;
      if (
        Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId]
      ) {
        if (
          Configuration.registrationForm.googleLocationLatLngFeilds[
            value.fieldId
          ].lat &&
          Configuration.registrationForm.googleLocationLatLngFeilds[
            value.fieldId
          ].lng
        ) {
          if (value.lat && value.lng) {
            values[
              Configuration.registrationForm.googleLocationLatLngFeilds[
                value.fieldId
              ].lat
            ] = value.lat.toString();
            values[
              Configuration.registrationForm.googleLocationLatLngFeilds[
                value.fieldId
              ].lng
            ] = value.lng.toString();
          }
        }
      }

      const activeCaseFormData = {
        data: {
          formFormat: values, //valueForFormInput,
          dhisFormat: null, //
        },
      };

      OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
      setActiveCaseFormData(activeCaseFormData);
    };

    return (
      <CreateField
        fieldData={registrationFields}
        values={values}
        programRules={programRules}
        programData={programData.programs[0]}
        orgDetails={orgDetails}
        programRulesVariables={programRulesVariables}
        linkContactFlag={linkContactFlag}
        onGoogleLocatioChangeParent={onGoogleLocatioChangeParent}
        activeCaseDetails={activeCaseDetails}
        activeCaseFormData={activeCaseFormData}
        OUJSON={OUJSON}
        Configuration={Configuration}
        customfieldobj={customfieldobj}
        currentGeolocation={currentGeolocation}
        userBO={sessionUserBoValue}
        form={form}
        isRegAvailable={isRegAvailable}
        customClassName={
          localStorage.getItem("fontSize")
            ? "FS" + localStorage.getItem("fontSize")
            : ""
        }
      />
    );
  }

  function renderStageField(
    fields,
    values,
    form,
    stages,
    currentStage,
    activeAccordion,
    hivBehavioural
  ) {
    const hivArr = hivarraydata.filter((h) => h.shouldHide).map((h) => h.id);
    const defaultValues = hivarraydata.filter((h) => h.shouldSetDefault);
    const removeDateDeps = hivarraydata.find((h) => h.shouldRemoveDateDeps);
    const updatedHIVArray = [...hivarraydata];
    let dateDeps = {};
    if (defaultValues.length > 0 && hivBehavioural) {
      defaultValues.forEach((d) => {
        values[d.id] = d.defaultValue;
        const isIndex = updatedHIVArray.findIndex((u) => u.id === d.id);
        updatedHIVArray[isIndex] = {
          ...updatedHIVArray[isIndex],
          status: true,
        };
      });
    }

    if (removeDateDeps && hivBehavioural) {
      Object.keys(dateDependencies).forEach((d) => {
        dateDeps[d] = dateDependencies[d].filter(
          (dIn) => dIn !== removeDateDeps.id
        );
      });
    } else {
      dateDeps = { ...dateDependencies };
    }

    console.log("hivBehavioural", hivBehavioural);
    console.log("hivConditions", hivConditions);

    const conditions = hivBehavioural
      ? {
          reactive: true,
          positive: true,
          art: AllHIVConditionCheck.art,
          all: AllHIVConditionCheck,
        }
      : hivConditions;

    if (
      (currentStage.id == referralServiceStageId &&
        fields.dataElement.id != referToFacilityCenter &&
        fields.dataElement.id != selectReferralServiceId) ||
      (currentStage.id == referralServiceStageId &&
        fields.dataElement.id == symptomsID) ||
      (hivArr.includes(fields.dataElement.id) && hivBehavioural)
    ) {
      return;
    } else {
      return (
        <>
          <CreateStageField
            fieldData={fields}
            dateDependencies={dateDeps}
            AllHIVConditionCheck={AllHIVConditionCheck}
            values={values}
            formRef={formRef}
            programRules={programRules}
            activeAccordion={activeAccordion}
            programData={programData.programs[0]}
            programRulesVariables={programRulesVariables}
            dataElementGroup={dataElementGroup}
            stages={stages}
            orgid={userData.organisationUnits[0].id}
            OUJSON={OUJSON}
            customfieldobj={customfieldobj}
            currentStage={currentStage}
            programBoDetails={programBoDetails}
            Configuration={Configuration}
            hivarray={updatedHIVArray}
            hivConditions={conditions}
            hivBehavioural={hivBehavioural}
            customClassName={
              localStorage.getItem("fontSize")
                ? "FS" + localStorage.getItem("fontSize")
                : ""
            }
          />
        </>
      );
    }
  }

  function checkUserPhoneNumberExist(valueForFormInput, callback) {
    if (
      programData &&
      programData.programs &&
      programData.programs[0] &&
      programData.programs[0].code &&
      programData.programs[0].code == "Zambia_Program"
    ) {
      try {
        if (
          regPhoneNumberSecondaryId &&
          valueForFormInput[regPhoneNumberSecondaryId] &&
          valueForFormInput[regPhoneNumberSecondaryId] ==
            valueForFormInput[regPhoneNumberId]
        ) {
          swal({
            title: t(
              "Permanent and secondary phone numbers entered are the same. Please enter different phone numbers."
            ),
            text: "",
            icon: "warning",
            buttons: t("Ok"),
          });
          return;
        }
        if (
          activeCaseFormData &&
          activeCaseFormData.data &&
          activeCaseFormData.data.formFormat &&
          activeCaseFormData.data.formFormat[regPhoneNumberId]
        ) {
          if (
            activeCaseFormData.data.formFormat[regPhoneNumberId] ==
            valueForFormInput[regPhoneNumberId]
          ) {
            callback(true);
            return;
          }
        }
        if (navigator.onLine) {
          setGlobalSpinner(true);
          apiServices
            .getAPI(
              `users?fields=[id,displayName,attributeValues]&phoneNumber=${valueForFormInput[regPhoneNumberId]}`
            )
            .then((response) => {
              setGlobalSpinner(false);
              // console.log("response ", response);
              if (response && response.data) {
                if (response.data.users && response.data.users.length > 0) {
                  swal({
                    title: t(
                      "The entered phone number is already registered on the system. Do you want to continue?"
                    ),
                    text: "",
                    icon: "warning",
                    buttons: [t("No"), t("Yes")],
                  }).then((AlertRes) => {
                    if (AlertRes) {
                      callback(true);
                    } else {
                      //callback(false)
                    }
                  });
                } else {
                  callback(true);
                }
              } else {
                callback(true);
              }
            })
            .catch((err) => {
              setGlobalSpinner(false);
              callback(true);
            });
        } else {
          setGlobalSpinner(false);
          callback(true);
        }
      } catch (e) {
        setGlobalSpinner(false);
        callback(true);
      }
    } else {
      callback(true);
    }
  }

  function checkDuplicateId(valueForFormInput, Idtobechecked, callback) {
    if (navigator.onLine) {
      setGlobalSpinner(true);
      let fieldname = "Phone number";
      let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
        programID = programData.programs[0].id, //`nSy7PFqQykt`,
        searchQuery = ``;

      searchQuery += `&attribute=${Idtobechecked}:LIKE:${valueForFormInput[Idtobechecked]}`;

      let subURL =
        "trackedEntityInstances/query.json?ou=" +
        orgID +
        "&ouMode=ACCESSIBLE&&order=created:desc&program=" +
        programID +
        searchQuery +
        "&pageSize=50&page=1&totalPages=false&skipPaging=true";

      apiServices
        .getAPI(subURL)
        .then((res) => {
          setGlobalSpinner(false);
          // console.log("response ", res.data.rows);
          if (res && res.data) {
            if (res.data.rows && res.data.rows.length > 0) {
              swal({
                title: t(
                  `The entered ${fieldname} is already registered on the system.`
                ),
                text: "",
                icon: "warning",
              }).then((AlertRes) => {
                callback(false);
              });
            } else {
              callback(true);
            }
          } else {
            callback(true);
          }
        })
        .catch((err) => {
          setGlobalSpinner(false);
          callback(true);
        });
    } else {
      setGlobalSpinner(false);
      callback(true);
    }
  }

  function saveRegData(valuesToSave, valueForFormInput) {
    try {
    } catch (e) {}

    checkDuplicateId(
      valueForFormInput,
      "tUUPZDHE5vq",
      function (callbackResponse) {
        if (callbackResponse) {
          checkUserPhoneNumberExist(valueForFormInput, function (callbackRes) {
            const orgUnit = userData.organisationUnits[0].id;
            const trackedEntityType =
              programData.programs[0].trackedEntityType.id;
            let registrationFields =
              programData.programs[0].programTrackedEntityAttributes;
            let whatsAppFieldId = "";

            registrationFields.map((regField) => {
              const findWhatsAppAttribute =
                regField.trackedEntityAttribute.attributeValues.find(
                  (x) => x.attribute.name == "WhatsAppNumber"
                );
              if (findWhatsAppAttribute) {
                whatsAppFieldId = regField.trackedEntityAttribute.id;
              }
            });

            let saveCaseInput = {
              trackedEntityType: trackedEntityType,
              orgUnit: orgUnit,
              attributes: valuesToSave,
              enrollments: [
                {
                  //"trackedEntityInstance": trackedEntityInstance,
                  program: programData.programs[0].id,
                  //"status": "ACTIVE",
                  orgUnit: orgUnit,
                  enrollmentDate: moment().format("YYYY-MM-DD"),
                  incidentDate: moment().format("YYYY-MM-DD"),
                },
              ],
              geometry: {
                type: "Point",
                coordinates: [currentGeolocation.lng, currentGeolocation.lat],
              },
            };

            let searchableFields = [];
            let searchQuery = ``;
            if (qrCodeId && valueForFormInput && !valueForFormInput[qrCodeId]) {
              var code = generateQRCode(8);
              let qrcode = { attribute: qrCodeId, value: code };
              valuesToSave.push(qrcode);
              valueForFormInput[qrCodeId] = code;
            }
            if (navigator.onLine) {
              if (dedupEnabled) {
                setGlobalSpinner(true);
                registrationFields.map((fields) => {
                  if (
                    (fields.searchable == true || fields.fields == "true") &&
                    fields.trackedEntityAttribute.displayName
                      .trim()
                      .toLowerCase() != "qr code"
                  ) {
                    searchableFields.push(fields.trackedEntityAttribute.id);
                  }
                });

                searchableFields.map((searchableField) => {
                  if (
                    valuesToSave.find(
                      (obj) => obj.attribute == searchableField
                    ) != undefined
                  ) {
                    const findValue = valuesToSave.find(
                      (obj) => obj.attribute == searchableField
                    );
                    searchQuery += `&attribute=${searchableField}:LIKE:${findValue.value}`;
                  }
                });
                let subURL =
                  "trackedEntityInstances/query.json?ou=" +
                  orgUnit +
                  "&ouMode=ACCESSIBLE&&order=created:desc&program=" +
                  programData.programs[0].id +
                  searchQuery +
                  "&pageSize=50&page=1&totalPages=false&skipPaging=true";
                apiServices.getAPI(subURL).then((searchResponse) => {
                  setGlobalSpinner(false);

                  if (searchResponse.data.rows.length > 0) {
                    try {
                      searchResponse.data.headers.map((ele) => {
                        if (ele.column && metaData) {
                          let fieldBO = _.find(
                            metaData.trackedEntityAttributes,
                            { displayName: ele.column }
                          );
                          if (fieldBO && ele.column != fieldBO.description) {
                            ele.column = fieldBO.description;
                          }
                        }
                      });
                    } catch (e) {
                      console.log(e);
                    }
                    setSearchHeader(searchResponse.data.headers);
                    setSearchResponse(searchResponse.data.rows);
                    setFormValuePostDeDup({
                      valuesToSave: valuesToSave,
                      valueForFormInput: valueForFormInput,
                    });
                  } else {
                    setGlobalSpinner(true);
                    registerNewUSer(
                      saveCaseInput,
                      valuesToSave,
                      valueForFormInput,
                      whatsAppFieldId,
                      orgUnit
                    );
                  }
                });
              } else {
                setGlobalSpinner(true);
                registerNewUSer(
                  saveCaseInput,
                  valuesToSave,
                  valueForFormInput,
                  whatsAppFieldId,
                  orgUnit
                );
              }
            } else {
              setGlobalSpinner(true);
              //OfflineStorage
              OfflineDb.getAllEntities().then((res) => {
                let UICode = { attribute: uicId, value: "" };
                valueForFormInput[uicId] = "";
                saveCaseInput.attributes.push(UICode);

                let offlineObj = {
                  data: valueForFormInput,
                  registration: saveCaseInput,
                  services: [],
                  formVersion: programData.programs[0].version,
                };
                OfflineDb.saveEntity(offlineObj).then((res) => {
                  setGlobalSpinner(false);

                  const activeCaseDetails = {
                    trackedEntityInstance: res.id,
                    enrollmentId: "",
                  };
                  const activeCaseFormData = {
                    formFormat: valueForFormInput,
                    dhisFormat: valuesToSave,
                  };
                  const linkContact = {
                    enabled: false,
                    linkTrackedEntityInstance: res.id,
                  };

                  setActiveCaseDetails({
                    data: {
                      trackedEntityInstance: res.id,
                      enrollmentId: "",
                    },
                  });
                  setActiveCaseFormData({
                    data: activeCaseFormData,
                  });
                  OfflineDb.setDataIntoPouchDB(
                    "activeCaseDetails",
                    activeCaseDetails
                  );
                  OfflineDb.setDataIntoPouchDB(
                    "activeCaseFormData",
                    activeCaseFormData
                  );
                  OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
                  swal({
                    title: t("Success"),
                    text: t("Individual registered offline successfully"),
                    icon: "success",
                    button: t("Close"),
                  });

                  //laod next active tab
                  const nextTab = activeTabs[0];
                  if (nextTab) {
                    const indexOfNextTab =
                      programData.programs[0].programStages.findIndex(
                        (obj) => obj.id == nextTab
                      );
                    setValue(indexOfNextTab + stepIncrement);
                  } else {
                    setValue(value);
                  }
                });

                //}
              });
            }
          });
        }
      }
    );
  }

  function generateQRCode(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return "dureProg_" + result;
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const base64ToFile = (base64String, fileName) => {
    const arr = base64String.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  };

  function linkeRegData(valuesToSave, valueForFormInput) {
    const orgUnit = userData.organisationUnits[0].id;
    const trackedEntityType = programData.programs[0].trackedEntityType.id;
    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;
    if (qrCodeId && valueForFormInput && !valueForFormInput[qrCodeId]) {
      var code = generateQRCode(8);
      let qrcode = { attribute: qrCodeId, value: code };
      valuesToSave.push(qrcode);
      valueForFormInput[qrCodeId] = code;
    }
    let saveCaseInput = {
      trackedEntityType: trackedEntityType,
      orgUnit: orgUnit,
      attributes: valuesToSave,
      enrollments: [
        {
          //"trackedEntityInstance": trackedEntityInstance,
          program: programData.programs[0].id,
          //"status": "ACTIVE",
          orgUnit: orgUnit,
          enrollmentDate: moment().format("YYYY-MM-DD"),
          incidentDate: moment().format("YYYY-MM-DD"),
        },
      ],
      geometry: {
        type: "Point",
        coordinates: [currentGeolocation.lng, currentGeolocation.lat],
      },
    };

    if (navigator.onLine) {
      setGlobalSpinner(true);

      apiServices
        .postAPI("trackedEntityInstances", saveCaseInput)
        .then((response) => {
          const trackedEntityInstance =
            response.data.response.importSummaries[0].reference;
          const programId = programData.programs[0].id;
          const enrollmentInputJson = {
            trackedEntityInstance: trackedEntityInstance,
            program: programId,
            status: "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          };

          // apiServices.postAPI('enrollments', enrollmentInputJson)
          //     .then(enrollmentResponse => {
          const userCreationInput = {
            userCredentials: {
              cogsDimensionConstraints: [],
              catDimensionConstraints: [],
              username: valueForFormInput[uicId],
              password: "Test@123",
              userRoles: [{ id: patientroleid }],
            },
            surname: valueForFormInput[lastNameId],
            firstName: valueForFormInput[firstNameId],
            phoneNumber: valueForFormInput[regPhoneNumberId],
            organisationUnits: [{ id: orgUnit }],
            dataViewOrganisationUnits: [{ id: orgUnit }],
            teiSearchOrganisationUnits: [{ id: orgUnit }],
            //"userGroups": [{"id": userGroupId}],
            attributeValues: [
              {
                value: trackedEntityInstance,
                attribute: { id: patienttrackedInstanceId },
              },
              { value: true, attribute: { id: mainAccountId } },
            ],
          };

          registartionSuccess();
          setGlobalSpinner(false);

          // apiServices.postAPI('users', userCreationInput)
          //     .then(userResponse => {
          //         registartionSuccess()
          //         setGlobalSpinner(false)
          //     }).catch(err => {
          //         setGlobalSpinner(false)
          //         swal({
          //             title: t("Patient registered successfully, but patient has not created as user"),
          //             text: "",
          //             icon: "warning",
          //             button: t("Close"),
          //         }).then(userResponse => {
          //             registartionSuccess()
          //         });
          //     })
          function registartionSuccess() {
            const enroll = ""; //enrollmentResponse.data.response.importSummaries[0].reference
            const getURL =
              "trackedEntityInstances/" +
              linkContactFlag.data.linkTrackedEntityInstance +
              ".json?program=" +
              programId +
              "&fields=*?";
            apiServices.getAPI(getURL).then((getParentData) => {
              const parentAttribute = [];
              getParentData.data.attributes.map((attributes) => {
                const obj = {
                  attribute: attributes.attribute,
                  value: attributes.value,
                };
                parentAttribute.push(obj);
              });

              getParentData.data.relationships.push({
                from: {
                  trackedEntityInstance: {
                    trackedEntityInstance:
                      linkContactFlag.data.linkTrackedEntityInstance,
                  },
                },
                to: {
                  trackedEntityInstance: {
                    trackedEntityInstance: trackedEntityInstance,
                  },
                },
                relationshipType: relationShipId,
              });

              const linkContactJson = {
                created: moment().format("YYYY-MM-DD"),
                orgUnit: orgUnit,
                createdAtClient: moment().format("YYYY-MM-DD"),
                trackedEntityInstance:
                  linkContactFlag.data.linkTrackedEntityInstance,
                lastUpdated: moment().format("YYYY-MM-DD"),
                trackedEntityType: trackedEntityType,
                lastUpdatedAtClient: moment().format("YYYY-MM-DD"),
                inactive: false,
                deleted: false,
                featureType: "NONE",
                programOwners: [
                  {
                    ownerOrgUnit: orgUnit,
                    program: programId,
                    trackedEntityInstance:
                      linkContactFlag.data.linkTrackedEntityInstance,
                  },
                ],
                relationships: getParentData.data.relationships,
                attributes: parentAttribute,
                geometry: {
                  type: "Point",
                  coordinates: [currentGeolocation.lng, currentGeolocation.lat],
                },
              };

              const putURL =
                "trackedEntityInstances/" +
                linkContactFlag.data.linkTrackedEntityInstance;

              apiServices
                .putAPI(putURL, linkContactJson)
                .then((linkResponse) => {
                  if (Configuration.registrationForm.linkContactInAlert) {
                    swal({
                      title: t("Contact Registered"),
                      text: t("Do you want to register another Contact?"),
                      icon: "success",
                      buttons: [t("No"), t("Yes")],
                    }).then((AlertRes) => {
                      if (AlertRes) {
                        //save data
                        const activeCaseDetails = {
                          trackedEntityInstance: trackedEntityInstance,
                          enrollmentId: enroll,
                        };
                        const linkContact = {
                          enabled: true,
                          linkTrackedEntityInstance:
                            linkContactFlag.data.linkTrackedEntityInstance,
                        };
                        const activeCaseFormData = {
                          formFormat: null,
                          dhisFormat: null,
                        };
                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseDetails",
                          activeCaseDetails
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseFormData",
                          activeCaseFormData
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "linkContactFlag",
                          linkContact
                        );

                        setActiveCaseFormData({
                          data: {
                            formFormat: null, //valueForFormInput,
                            dhisFormat: null, //
                          },
                        });
                        setValue(0);

                        //empty form
                      } else {
                        //save data
                        const activeCaseDetails = {
                          trackedEntityInstance: trackedEntityInstance,
                          enrollmentId: enroll,
                        };
                        const activeCaseFormData = {
                          formFormat: valueForFormInput,
                          dhisFormat: valuesToSave,
                        };
                        const linkContact = {
                          enabled: false,
                          linkTrackedEntityInstance: trackedEntityInstance,
                        };

                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseDetails",
                          activeCaseDetails
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseFormData",
                          activeCaseFormData
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "linkContactFlag",
                          linkContact
                        );

                        //load next active tabs
                        const nextTab = activeTabs[0];
                        if (nextTab) {
                          const indexOfNextTab =
                            programData.programs[0].programStages.findIndex(
                              (obj) => obj.id == nextTab
                            );
                          setValue(indexOfNextTab + stepIncrement);
                        } else {
                          setValue(value);
                        }
                        setActiveCaseDetails({
                          data: {
                            trackedEntityInstance: trackedEntityInstance,
                            enrollmentId: enroll,
                          },
                        });
                      }
                    });
                  } else {
                    const activeCaseDetails = {
                      trackedEntityInstance: trackedEntityInstance,
                      enrollmentId: enroll,
                    };
                    const activeCaseFormData = {
                      formFormat: valueForFormInput,
                      dhisFormat: valuesToSave,
                    };
                    const linkContact = {
                      enabled: false,
                      linkTrackedEntityInstance: trackedEntityInstance,
                    };
                    setLinkContactFlag({
                      data: linkContact,
                    });

                    OfflineDb.setDataIntoPouchDB(
                      "activeCaseDetails",
                      activeCaseDetails
                    );
                    OfflineDb.setDataIntoPouchDB(
                      "activeCaseFormData",
                      activeCaseFormData
                    );
                    OfflineDb.setDataIntoPouchDB(
                      "linkContactFlag",
                      linkContact
                    );
                    setAddContactFlag(false);
                    //load next active tabs
                    swal({
                      title: t("Success"),
                      text: t("Contact Registered successfully."),
                      icon: "success",
                      buttons: t("Ok"),
                    });
                    const nextTab = activeTabs[0];
                    if (nextTab) {
                      const indexOfNextTab =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == nextTab
                        );
                      setValue(indexOfNextTab + stepIncrement);
                    } else {
                      setValue(value);
                    }
                    setActiveCaseDetails({
                      data: {
                        trackedEntityInstance: trackedEntityInstance,
                        enrollmentId: enroll,
                      },
                    });
                  }
                  setGlobalSpinner(false);
                });
              setGlobalSpinner(false);
            });
            // })
          }
        });
    } else {
      //OfflineStorage
      let offlineObj = {
        data: valueForFormInput,
        registration: saveCaseInput,
        services: [],
        formVersion: programData.programs[0].version,
        parentId: linkContactFlag.data.linkTrackedEntityInstance,
      };
      // console.log("offlineObj ", offlineObj);
      OfflineDb.saveEntity(offlineObj)
        .then((res) => {
          setGlobalSpinner(false);
          const activeCaseDetails = {
            trackedEntityInstance: res.id,
            enrollmentId: "",
          };
          const activeCaseFormData = {
            formFormat: valueForFormInput,
            dhisFormat: valuesToSave,
          };
          const linkContact = {
            enabled: false,
            linkTrackedEntityInstance: res.id,
          };

          setActiveCaseDetails({
            data: {
              trackedEntityInstance: res.id,
              enrollmentId: "",
            },
          });
          OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
          setAddContactFlag(false);
          //laod next active tab
          swal({
            title: t("Registered"),
            text: t("Contact registered offline successfully."),
            icon: "success",
            buttons: t("Ok"),
          });
          const nextTab = activeTabs[0];
          if (nextTab) {
            const indexOfNextTab =
              programData.programs[0].programStages.findIndex(
                (obj) => obj.id == nextTab
              );

            setValue(indexOfNextTab + stepIncrement);
          } else {
            setValue(value);
          }
        })
        .catch((err) => {
          console.log("linkregdataoff>>", err);
          setGlobalSpinner(false);
        });
    }
  }

  function updateRegData(
    valuesToSave,
    valueForFormInput,
    trackentityInstanceDetail
  ) {
    if (qrCodeId && valueForFormInput && !valueForFormInput[qrCodeId]) {
      var code = generateQRCode(8);
      let qrcode = { attribute: qrCodeId, value: code };
      valuesToSave.push(qrcode);
      valueForFormInput[qrCodeId] = code;
    }
    checkUserPhoneNumberExist(valueForFormInput, function (callbackRes) {
      if (navigator.onLine) {
        const orgUnit =
          userrolename &&
          userrolename.toLowerCase() == superAdmin &&
          trackentityInstanceDetail
            ? trackentityInstanceDetail.orgUnit
            : userData.organisationUnits[0].id;
        const programId = programData.programs[0].id;
        const trackedEntityType = programData.programs[0].trackedEntityType.id;
        const updateURL =
          "trackedEntityInstances/" +
          trackentityInstanceDetail.trackedEntityInstance;
        const lat = trackentityInstanceDetail.geometry
          ? trackentityInstanceDetail.geometry.coordinates[1]
          : "";
        const lng = trackentityInstanceDetail.geometry
          ? trackentityInstanceDetail.geometry.coordinates[0]
          : "";
        const updateCaseInput = {
          created: trackentityInstanceDetail.created,
          orgUnit: orgUnit,
          createdAtClient: trackentityInstanceDetail.createdAtClient,
          trackedEntityInstance:
            trackentityInstanceDetail.trackedEntityInstance,
          lastUpdated: trackentityInstanceDetail.lastUpdated,
          trackedEntityType: trackedEntityType,
          lastUpdatedAtClient: trackentityInstanceDetail.lastUpdatedAtClient,
          inactive: false,
          deleted: false,
          featureType: "NONE",
          programOwners: [
            {
              ownerOrgUnit: orgUnit,
              program: programId,
              trackedEntityInstance:
                trackentityInstanceDetail.trackedEntityInstance,
            },
          ],
          relationships:
            trackentityInstanceDetail &&
            trackentityInstanceDetail.relationships &&
            trackentityInstanceDetail.relationships.length > 0
              ? trackentityInstanceDetail.relationships
              : [],
          attributes: valuesToSave,
          geometry: { type: "Point", coordinates: [lng, lat] },
        };
        setGlobalSpinner(true);
        apiServices.putAPI(updateURL, updateCaseInput).then((updateRes) => {
          setGlobalSpinner(false);
          swal({
            title: t("Updated"),
            text: t(
              "Client data successfully updated. Your dashboard will load shortly."
            ),
            icon: "success",
            button: t("Close"),
          });
          const activeCaseFormData = {
            formFormat: valueForFormInput,
            dhisFormat: valuesToSave,
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData({
            data: {
              formFormat: valueForFormInput, //valueForFormInput,
              dhisFormat: valuesToSave, //
            },
          });

          const nextTab = activeTabs[0];
          if (nextTab) {
            const indexOfNextTab =
              programData.programs[0].programStages.findIndex(
                (obj) => obj.id == nextTab
              );
            setValue(indexOfNextTab + stepIncrement);
          } else {
            setValue(value);
          }
        });
      } else {
        OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance)
          .then((res) => {
            const tempdata = { ...res };
            tempdata.formVersion = programData.programs[0].version;
            tempdata.data = { ...tempdata.data, ...valueForFormInput };
            tempdata.registration.attributes = valuesToSave;
            //console.log("tempdata",tempdata);
            OfflineDb.updateFullEntity(tempdata)
              .then((response) => {
                setGlobalSpinner(false);
                const activeCaseFormData = {
                  data: {
                    formFormat: valueForFormInput,
                    dhisFormat: valuesToSave,
                  },
                };
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeCaseFormData
                );
                setActiveCaseFormData(activeCaseFormData);
                swal({
                  title: t("Updated offline"),
                  text: t(
                    "Client data successfully updated. Your dashboard will load shortly."
                  ),
                  icon: "success",
                  button: t("Close"),
                });
                const nextTab = activeTabs[0];
                if (nextTab) {
                  const indexOfNextTab =
                    programData.programs[0].programStages.findIndex(
                      (obj) => obj.id == nextTab
                    );
                  setValue(indexOfNextTab + stepIncrement);
                } else {
                  setValue(value);
                }
              })
              .catch((e) => {
                setGlobalSpinner(false);
              });
          })
          .catch((e) => {
            setGlobalSpinner(false);
          });
      }
    });
  }

  function onSubmit(values) {
    try {
      let registrationFields =
        programData.programs[0].programTrackedEntityAttributes;

      if (!values[clientregdateId]) {
      } else {
        if (fingerOrSignature === "signature") {
          // if (!signatureBlob && !signatureDataURL) {
          //   swal({
          //     title: "Error",
          //     text: "Please add Signature",
          //     icon: "error",
          //     button: "Close",
          //   });
          //   return;
          // }
          if (signatureBlob) {
            values["HDbRoNrt77N"] = []; //remove fingerprint
            values["JAhkKQjlDaQ"] = [];
            values["JAhkKQjlDaQ"].push(signatureBlob);
          }
        }

        if (fingerOrSignature === "finger") {
          // if (!fingerBlob && !fingerDataURL) {
          //   swal({
          //     title: "Error",
          //     text: "Please add Fingerprint",
          //     icon: "error",
          //     button: "Close",
          //   });
          //   return;
          // }
          if (fingerBlob) {
            values["JAhkKQjlDaQ"] = []; //remove signature
            values["HDbRoNrt77N"] = [];
            values["HDbRoNrt77N"].push(fingerBlob);
          }
        }

        setGlobalSpinner(true);
        let fieldValueWithAttribute = [];
        const data = values;
        if (!navigator.onLine && values[offlineFieldId] == undefined) {
          values[offlineFieldId] = Date.now();
        }

        let promises = [];
        Object.keys(values).map(async function (objectKey, index) {
          var obj = {
            attribute: objectKey,
            value: values[objectKey],
          };
          const CurrentValueFilter = registrationFields
            ? registrationFields.find(
                (obj) => obj.trackedEntityAttribute.id == objectKey
              )
            : undefined;

          if (CurrentValueFilter) {
            if (
              CurrentValueFilter.trackedEntityAttribute.valueType == "IMAGE" ||
              CurrentValueFilter.trackedEntityAttribute.valueType ==
                "FILE_RESOURCE"
            ) {
              let formData = new FormData();
              if (navigator.onLine) {
                formData.append("file", data[objectKey][0]);
                promises.push(
                  apiServices
                    .postAPI("fileResources", formData)
                    .then((res) => {
                      if (res.data) {
                        let fileobj = {
                          attribute: objectKey,
                          value: res.data.response.fileResource.id,
                        };
                        fieldValueWithAttribute.push(fileobj);
                      }
                    })
                    .catch((err) => {
                      let fileobj = {
                        attribute: objectKey,
                        value: stageregImageValue?.[objectKey] || null,
                      };
                      fieldValueWithAttribute.push(fileobj);
                    })
                );
              } else {
                if (
                  Array.isArray(obj.value) &&
                  obj.value.length > 0 &&
                  obj.value[0] instanceof File
                ) {
                  const file = obj.value[0]; // Or loop if you want multiple
                  const base64 = await fileToBase64(file);
                  let fileobj = { attribute: objectKey, value: base64 };
                  fieldValueWithAttribute.push(fileobj);
                  values[obj.attribute] = base64;
                }
                // console.log("xxx", fieldValueWithAttribute);
              }
            } else {
              fieldValueWithAttribute.push(obj);
            }
          }
        });

        if (promises.length == 0) {
          if (linkContactFlag.data) {
            if (linkContactFlag.data.enabled == true) {
              //linkContact function

              linkeRegData(fieldValueWithAttribute, values);
            } else {
              setGlobalSpinner(false);
              if (values["declaration"] || values["phLcEDwSQS6"]) {
                if (activeCaseDetails.data) {
                  //update
                  updateRegData(
                    fieldValueWithAttribute,
                    values,
                    trackentityInstanceDetails
                  );
                } else {
                  //save
                  saveRegData(fieldValueWithAttribute, values);
                }
              } else if (!values["declaration"]) {
                swal({
                  title: "Error",
                  text: "Please select declaration to proceed.",
                  icon: "error",
                  button: "Close",
                });
              }
            }
          } else {
            if (activeCaseDetails.data) {
              //update
              updateRegData(
                fieldValueWithAttribute,
                values,
                trackentityInstanceDetails
              );
            } else {
              //save
              saveRegData(fieldValueWithAttribute, values);
            }
          }
        } else {
          Promise.all(promises).then((responses) => {
            // responses.map(imageData => {
            //     fieldValueWithAttribute.push(imageData)
            // })
            if (linkContactFlag.data) {
              if (linkContactFlag.data.enabled == true) {
                //linkContact function

                linkeRegData(fieldValueWithAttribute, values);
              } else {
                if (activeCaseDetails.data) {
                  //update
                  updateRegData(
                    fieldValueWithAttribute,
                    values,
                    trackentityInstanceDetails
                  );
                } else {
                  //save
                  saveRegData(fieldValueWithAttribute, values);
                }
              }
            } else {
              if (values["declaration"] || values["phLcEDwSQS6"]) {
                if (activeCaseDetails.data) {
                  //update
                  updateRegData(
                    fieldValueWithAttribute,
                    values,
                    trackentityInstanceDetails
                  );
                } else {
                  //save
                  saveRegData(fieldValueWithAttribute, values);
                }
              } else if (!values["declaration"]) {
                setGlobalSpinner(false);
                swal({
                  title: "Error",
                  text: "Please select declaration to proceed.",
                  icon: "error",
                  button: "Close",
                });
              }
            }
          });
        }
      }
    } catch (e) {
      console.log("e", e);
      setGlobalSpinner(false);
    }
    //saveRegData(fieldValueWithAttribute, values)
  }
  // Code for Link Tab
  function addContactCallBack() {
    let address = "";
    let addressLocation = "";
    if (trackentityInstanceDetails && trackentityInstanceDetails.attributes) {
      address = trackentityInstanceDetails.attributes.find(
        (x) => x.attribute == regAddressId
      )
        ? trackentityInstanceDetails.attributes.find(
            (x) => x.attribute == regAddressId
          ).value
        : "";
      addressLocation = trackentityInstanceDetails.attributes.find(
        (x) => x.attribute == addressLocationId
      )
        ? trackentityInstanceDetails.attributes.find(
            (x) => x.attribute == addressLocationId
          ).value
        : "";
    }
    setAddContactFlag(true);
    const activeCaseDetails1 = {
      trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      enrollmentId: activeCaseDetails.data.enrollmentId,
    };
    const linkContact = {
      enabled: true,
      linkTrackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
    };
    const activeCaseFormData = {
      formFormat: null, //valueForFormInput,
      dhisFormat: null, //
    };

    OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails1);
    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
    OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

    setActiveCaseFormData({
      data: {
        //'formFormat': null, //valueForFormInput,
        formFormat: {
          [clientTypeID]: Configuration.ltbiLinkVariables.contact,
          [addressLocationId]: addressLocation,
          [regAddressId]: address,
        },
        dhisFormat: null, //
      },
    });
    setLinkContactFlag({
      data: {
        enabled: true,
        linkTrackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      },
    });

    if (searchEnabled && navigator.onLine) {
      setValue(1);
    } else {
      setValue(0);
    }
  }
  function createLinkForm(programObj) {
    function editLinks(linkObject) {
      const activeCaseDetails = {
        trackedEntityInstance: linkObject.trackedEntityInstance,
        enrollmentId: "",
      };
      OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
      setActiveCaseDetails({
        data: {
          trackedEntityInstance: linkObject.trackedEntityInstance,
          enrollmentId: "",
        },
      });
      setSearchResponse(null);
      if (searchEnabled) {
        setValue(1);
      } else {
        setValue(0);
      }
    }
    return (
      <div>
        <form className="fullWidth" onSubmit={(e) => e.preventDefault()}>
          <div className="innertabdivreg subclass1">
            <div className="buttons linkbtn">
              <button
                className="regformsubmitbtn submitButton"
                onClick={addContactCallBack}
              >
                <Trans>{t("Add Contact")}</Trans>
              </button>
            </div>
            <p>{t("Linked Index")}:</p>
            {linkIndexList.length > 0
              ? linkIndexList.map((indexItem) => {
                  return indexItem.data.attributes.map((item) => {
                    //if (item.displayName.trim() == 'First name') {
                    if (item.attribute == givenName) {
                      return (
                        <div style={{ marginBottom: 10 }}>
                          <Grid item xs={12} sm={12} md={12}>
                            <Card
                              className={classes.root}
                              onClick={() => editLinks(indexItem.data)}
                            >
                              <CardContent className="casescardheader d-flex">
                                <PersonIcon />
                                {item.value}
                              </CardContent>
                            </Card>
                          </Grid>
                        </div>
                      );
                    }
                  });
                })
              : ""}
            <p>{t("Linked Contact")}:</p>
            {linkContactList.length > 0
              ? linkContactList.map((contactItem) => {
                  return contactItem.data.attributes.map((item) => {
                    //if (item.displayName.trim() == 'First name') {
                    if (item.attribute == givenName) {
                      return (
                        <div style={{ marginBottom: 10 }}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ marginBottom: "10" }}
                          >
                            <Card
                              className={classes.root}
                              onClick={() => editLinks(contactItem.data)}
                            >
                              <CardContent className="casescardheader">
                                <PersonIcon />
                                {item.value}
                              </CardContent>
                            </Card>
                          </Grid>
                        </div>
                      );
                    }
                  });
                })
              : ""}
          </div>
        </form>
      </div>
    );
  }
  function createIndexContactList() {
    if (activeCaseDetails.data && navigator.onLine) {
      let programID = programData.programs[0].id,
        url = `trackedEntityInstances/${activeCaseDetails.data.trackedEntityInstance}.json?program=${programID}&fields=relationships`;
      apiServices
        .getAPI(url)
        .then((res) => {
          getChildrenById(res.data.relationships, programID);
        })
        .catch((error) => {
          setGlobalSpinner(false);
          swal({
            title: "Error",
            text: error,
            icon: "error",
            button: "Close",
          });
        });
    }
  }
  function getChildrenById(relationshipsArr, programid) {
    let p = [];
    let q = [];
    //setGlobalSpinner(true);
    relationshipsArr.map((relobj) => {
      if (
        relobj.from.trackedEntityInstance.trackedEntityInstance !=
        activeCaseDetails.data.trackedEntityInstance
      ) {
        let url = `trackedEntityInstances/${relobj.from.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
        q.push(apiServices.getAPI(url));
      }
      if (
        relobj.to.trackedEntityInstance.trackedEntityInstance !=
        activeCaseDetails.data.trackedEntityInstance
      ) {
        let url1 = `trackedEntityInstances/${relobj.to.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
        p.push(apiServices.getAPI(url1));
      }
    });

    Promise.all([...p]).then(([...res]) => {
      let childrenArr = [...res];
      setGlobalSpinner(false);
      setLinkContactList(childrenArr);
    });
    Promise.all([...q]).then(([...res]) => {
      let childrenArr = [...res];
      setGlobalSpinner(false);
      setLinkIndexList(childrenArr);
    });
  }

  function searchAPI(param) {
    setGlobalSpinner(true);

    //let programData = programObj.programs[0]
    let registrationFields =
      props.programData.programs[0].programTrackedEntityAttributes;
    let clientTypeID = null;
    registrationFields.map((field, index) => {
      if (field.trackedEntityAttribute.displayName == "Client type") {
        clientTypeID = field.trackedEntityAttribute.id;
        param[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
      }
    });

    if (!_.isEmpty(param) && uicId && !param.hasOwnProperty(uicId)) {
      //do not save uic field data
      OfflineDb.setDataIntoPouchDB("activeCaseFormData", {
        formFormat: param, //valueForFormInput,
        dhisFormat: null, //
      });
      setActiveCaseFormData({
        data: {
          formFormat: param, //valueForFormInput,
          dhisFormat: null, //
        },
      });
    }
    let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
      programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`,
      searchQuery = ``;

    for (var i in param) {
      searchQuery += `&attribute=${i}:LIKE:${param[i]}`;
    }
    let subURL =
      "trackedEntityInstances/query.json?ou=" +
      orgID +
      "&ouMode=ACCESSIBLE&&order=created:desc&program=" +
      programID +
      searchQuery +
      "&pageSize=50&page=1&totalPages=false&skipPaging=true";

    apiServices
      .getAPI(subURL)
      .then((searchResponse) => {
        setGlobalSpinner(false);
        if (searchResponse.data.rows.length > 0) {
          try {
            searchResponse.data.headers.map((ele) => {
              if (ele.column && metaData) {
                let fieldBO = _.find(metaData.trackedEntityAttributes, {
                  displayName: ele.column,
                });
                if (fieldBO && ele.column != fieldBO.description) {
                  ele.column = fieldBO.description;
                }
              }
            });
          } catch (e) {
            console.log(e);
          }
          setSearchHeader(searchResponse.data.headers);
          setSearchResponse(searchResponse.data.rows);
        } else {
          setSearchHeader([]);
          setSearchResponse([]);
        }
      })
      .catch((error) => {
        setGlobalSpinner(false);
        // setLoading(false)
        swal({
          title: t("Error"),
          text: t(
            "At least 1 attributes should be mentioned in the search criteria."
          ),
          icon: "error",
          button: t("Close"),
        });
      });
  }

  function createSearchForm(programObj) {
    const rulesObject = {
      programRule: [],
      programRuleVariable: [],
    };
    let attributes = programObj.programs[0].programTrackedEntityAttributes;
    const searchPageMeta = Configuration.searchpage;
    function createCustomSearchForm() {
      const rulesObject = {
        programRule: [],
        programRuleVariable: [],
      };
      let attributes = metaData.programs[0].programTrackedEntityAttributes;
      return (
        <Form
          onSubmit={(values) => searchAPI(values, null, 2)}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="fullWidth searchdiv" onSubmit={handleSubmit}>
              <div className="innertabdivreg subclass3">
                <>
                  <Grid container spacing={3}>
                    {attributes.map((attribute, i) => {
                      if (
                        attribute.searchable &&
                        attribute.trackedEntityAttribute.displayName
                          .trim()
                          .toLowerCase() != "qr code"
                      ) {
                        return (
                          <CreateSearchField
                            fieldData={attribute}
                            values={values}
                            programRules={[]}
                            programData={programObj.programs[0]}
                            programRulesVariables={[]}
                            linkContactFlag={linkContactFlag}
                            activeCaseDetails={activeCaseDetails}
                            customClassName={
                              localStorage.getItem("fontSize")
                                ? "FS" + localStorage.getItem("fontSize")
                                : ""
                            }
                          />
                        );
                      }
                    })}
                  </Grid>

                  <div className="buttons">
                    <button
                      className="regformsubmitbtn submitButton"
                      type="submit"
                      disabled={submitting}
                    >
                      <Trans>Submit</Trans>
                    </button>
                    <button
                      className="regformresetbtn"
                      type="button"
                      onClick={() => form.reset()}
                      disabled={submitting}
                    >
                      <Trans>Reset</Trans>
                    </button>
                  </div>
                </>
              </div>
            </form>
          )}
        />
      );
    }

    function createUICSearchForm() {
      const rulesObject = {
        programRule: [],
        programRuleVariable: [],
      };
      let attributes = metaData.programs[0].programTrackedEntityAttributes;
      return (
        <Form
          onSubmit={(values) => searchAPI(values, null, 2)}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="fullWidth" onSubmit={handleSubmit}>
              <div className="innertabdivreg subclass4">
                <>
                  <Grid container spacing={3}>
                    {attributes.map((attribute, i) => {
                      if (attribute.trackedEntityAttribute.unique) {
                        return (
                          <CreateSearchField
                            key={i}
                            fieldData={attribute}
                            values={values}
                            form={form}
                            programRules={rulesObject}
                            customClassName={
                              localStorage.getItem("fontSize")
                                ? "FS" + localStorage.getItem("fontSize")
                                : ""
                            }
                          />
                        );
                      }
                    })}
                  </Grid>

                  <div className="buttons buttonFlex">
                    <button
                      className="regformsubmitbtn submitButton"
                      type="submit"
                      disabled={submitting}
                    >
                      <Trans>Submit</Trans>
                    </button>
                    <button
                      className="regformresetbtn hide"
                      type="button"
                      onClick={() => form.reset()}
                      disabled={submitting}
                    >
                      <Trans>Reset</Trans>
                    </button>
                  </div>

                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </>
              </div>
            </form>
          )}
        />
      );
    }
    const closeQrScanner = () => {
      setshowScanner(false);
    };

    function handleQRScan(data) {
      if (data) {
        setshowScanner(false);
        let obj = {};
        programObj.programs[0].programTrackedEntityAttributes.map(
          (attribute) => {
            if (
              attribute.renderType &&
              attribute.renderType["DESKTOP"].type == "QR_CODE"
            ) {
              obj[attribute.trackedEntityAttribute.id] = data;
            }
          }
        );
        searchAPI(obj);
      }
    }

    function qrErrorhandler(err) {
      setshowScanner(false);
      alert(err);
    }

    function createQRFrom() {
      return (
        <div
          className="searchformcontainer qrreaderholder"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {showScanner ? (
            // <QrReader
            //     delay={300}
            //     onError={() => qrErrorhandler()}
            //     onScan={() => handleQRScan()}
            //     style={{ width: '30%', cursor: 'pointer' }}
            // />
            <div style={{ height: "200px", width: "200px", marginTop: "10px" }}>
              <Html5QrcodePlugin
                fps={10}
                qrbox={200}
                disableFlip={false}
                qrCodeSuccessCallback={(e) => handleQRScan(e)}
              />
              <span onClick={() => closeQrScanner()}>
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </div>
          ) : (
            <p className="qrIcon" onClick={() => openQrSacnner()}>
              <FontAwesomeIcon className="fa-5x" icon={faQrcode} />
            </p>
          )}
        </div>
      );
    }

    const resetSearch = () => {
      setSearchResult([]);
      setsearchFilter({});
    };
    function openCordovaQrScanner() {
      let that = this;
      window.cordova.plugins.barcodeScanner.scan(
        function (result) {
          handleQRScan(result.text);
        },
        function (error) {},
        {
          preferFrontCamera: false, // iOS and Android
          showFlipCameraButton: true, // iOS and Android
          showTorchButton: false, // iOS and Android
          torchOn: false, // Android, launch with the torch switched on (if available)
          prompt: "Place a barcode inside the scan area", // Android
          resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations: true, // iOS
          disableSuccessBeep: false, // iOS
        }
      );
    }
    function openQrSacnner() {
      if (window.cordova) {
        openCordovaQrScanner();
      } else {
        setshowScanner(true);
      }
    }

    const handleSearchTabChange = (event, newValue) => {
      setSearchTabValue(newValue);
    };

    return (
      <div className="searchtabscontainer customregistrationtabs regcasetabs customPadding">
        <AppBar
          position="static"
          // style={{ bottom: '115px' }}
        >
          <Tabs
            value={searchTabvalue}
            onChange={handleSearchTabChange}
            aria-label="simple tabs example"
            variant="fullWidth"
          >
            {searchPageMeta.tabsList.map((tabdetails, i) => {
              if (tabdetails.showMenu) {
                return (
                  <Tab
                    className="whitetext"
                    key={i}
                    style={{ color: "#fff !important" }}
                    label={t(tabdetails.name)}
                    {...a11yProps(i)}
                  />
                );
              }
            })}
          </Tabs>
        </AppBar>
        <TabPanel
          value={searchTabvalue}
          index={0}
          dir={theme.direction}
          style={{ padding: "0px 0px !important" }}
        >
          {metaData != null ? createCustomSearchForm() : null}
        </TabPanel>

        <TabPanel
          value={searchTabvalue}
          index={1}
          dir={theme.direction}
          className={classes.paddingclass}
          style={{ padding: "20px 0px !important" }}
        >
          {metaData != null ? createUICSearchForm() : null}
        </TabPanel>

        <TabPanel
          value={searchTabvalue}
          index={2}
          dir={theme.direction}
          className={classes.paddingclass}
          style={{ padding: "20px 0px !important" }}
        >
          {metaData != null ? createQRFrom() : null}
        </TabPanel>
        <TabPanel
          value={searchTabvalue}
          index={3}
          className={classes.paddingclass}
          style={{ padding: "20px 0px !important" }}
        ></TabPanel>
      </div>
    );
  }

  function CustomeCaseCard(row) {
    const history = useHistory();
    const { t } = useTranslation();

    const [headers] = React.useState(row.searchHeader);
    const findIndexOfClientType = headers.findIndex(
      (obj) => obj.column.trim().toLocaleLowerCase() == "client type"
    );
    const clientType = row.row[findIndexOfClientType]
      ? row.row[findIndexOfClientType]
      : "";
    const clientTypeId = headers[findIndexOfClientType]
      ? headers[findIndexOfClientType].name
      : "";
    //const [vType] = useState(row.viewType)
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const [UserBO, setUserBO] = useState(null);
    const [metaData, setMetaData] = useState(null);
    const setGlobalSpinner = useGlobalSpinnerActionsContext();
    //redux state selector and dispatch action
    const postResgistrationResponse = useSelector(
      (state) => state.postResgistrationResponse
    );
    const dispatch = useDispatch();

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleExpandClick = () => {
      setExpanded(!expanded);
    };

    const addContcat = () => {
      const activeCaseFormData = {
        formFormat: { [clientTypeId]: Configuration.ltbiLinkVariables.contact },
        dhisFormat: null,
      };
      const linkContact = {
        enabled: true,
        linkTrackedEntityInstance: row.row[0],
      };
      //OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
      OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
      OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
      history.push("/layout/registration");
    };

    function UpdateRecordClick() {
      setGlobalSpinner(true);

      const activeCaseDetails = {
        trackedEntityInstance: row.row[0],
        enrollmentId: "",
      };
      OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);

      setActiveCaseDetails({
        data: {
          trackedEntityInstance: row.row[0],
          enrollmentId: "",
        },
      });
      setSearchResponse(null);
      setValue(1);
    }

    const getIndividualsList = () => {
      localStorage.setItem("trackedEntityInstance", row.row[0]);
      history.push("/layout/individual-cases-list", {
        trackedEntityInstance: row.row[0],
      });
    };

    const caseCardView = () => {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={row.parentPage && row.parentPage == "registration" ? 6 : 3}
        >
          <Card className={classes.root}>
            <CardHeader
              className="casescardheader"
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  <EventNoteIcon />
                </Avatar>
              }
              title=""
              subheader=""
            />

            <CardContent className="zero caselistholder">
              <Customcaseslist
                row={row}
                viewType={row.viewType}
              ></Customcaseslist>
            </CardContent>
            <CardActions disableSpacing className="cardactionfooter">
              {row.hideOptions != "true" ? (
                <>
                  <IconButton aria-label="share" onClick={UpdateRecordClick}>
                    <EditIcon />
                  </IconButton>{" "}
                </>
              ) : (
                <> </>
              )}

              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              ></IconButton>
            </CardActions>
          </Card>
        </Grid>
      );
    };

    return row.viewType == "card" ? caseCardView() : null;
  }

  function getUICFromAPI() {
    return new Promise((resolve, reject) => {
      if (navigator.onLine) {
        setGlobalSpinner(true);
        apiServices
          .generateUIC(uicId)
          .then((response) => {
            resolve(response.value);
            setGlobalSpinner(false);
          })
          .catch((err) => {
            setGlobalSpinner(false);
            resolve();
          });
      } else {
        OfflineDb.getDataFromPouchDB("offlineUICList").then((res) => {
          if (res && res.data) {
            let uicobj = res.data.pop();
            if (uicobj) {
              resolve(uicobj.value);
            }
            OfflineDb.setDataIntoPouchDB("offlineUICList", res.data);
          }
        });
      }
    });
  }

  useEffect(() => {
  const submitted =
    !!activeCaseFormData?.data?.formFormat?.["OjeHLMsC0gy"];

  setIsRegSubmitted(submitted);
}, [activeCaseFormData]);

  // Search tab code END
  function createRegistrationForm(
    programObj,
    programRules,
    programRulesVariables,
    orgDetails
  ) {
    let programData = programObj.programs[0];
    let registrationFields = programData.programTrackedEntityAttributes;

    let initialValues = activeCaseFormData.data
      ? activeCaseFormData.data.formFormat != null
        ? activeCaseFormData.data.formFormat
        : {}
      : {};
    initialValues["declaration"] = true;
    initialValues["phLcEDwSQS6"] = activeCaseFormData?.data?.formFormat?.[
      "phLcEDwSQS6"
    ]
      ? typeof activeCaseFormData?.data?.formFormat?.["phLcEDwSQS6"] ===
          "boolean" &&
        activeCaseFormData?.data?.formFormat?.["phLcEDwSQS6"] === true
        ? true
        : activeCaseFormData?.data?.formFormat?.["phLcEDwSQS6"] === "true"
        ? true
        : false
      : false;    
    
    console.log("initialValues", initialValues);
    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form className="fullWidth" onSubmit={handleSubmit}>
            <div className="innertabdivreg subclass5">
              <>
                {
                  // multicheckbox save logic
                  programData != null
                    ? programData.programSections.map((programSection) => {
                        if (
                          programSection.renderType["DESKTOP"].type ==
                          "SEQUENTIAL"
                        ) {
                          if (values[programSection.id] != undefined) {
                            programSection.trackedEntityAttributes.map(
                              (elements) => {
                                delete values[elements.id];
                              }
                            );
                            values[programSection.id].map((value) => {
                              values[value] = true;
                            });
                          }
                        }
                      })
                    : null
                }
              </>
              <>
                {" "}
                {openCamera ? (
                  <p
                    className={
                      Configuration.registrationForm.showOCR
                        ? "ocrbuttonholder text-right"
                        : "ocrbuttonholder text-right hide"
                    }
                  >
                    <Button
                      className="regSearchCancelButton"
                      onClick={() => setCameraStatus(false)}
                    >
                      <ControlCameraIcon />
                      {t("Close OCR")}
                    </Button>
                  </p>
                ) : (
                  <> </>
                )}{" "}
              </>
              <Grid container spacing={3}>
                {programData != null
                  ? subSectionJson
                    ? orgDetails
                      ? programData.programSections.length > 0
                        ? renderRegistrationSections(
                            programData,
                            values,
                            form,
                            programRules,
                            props.icons
                          )
                        : registrationFields.map((fieldsObject) => {
                            return renderRegistrationField(
                              fieldsObject,
                              values != null ? values : {},
                              programData,
                            );
                          })
                      : null
                    : null
                  : null}
              </Grid>
              <br />

              {Configuration.registrationForm.enableWhatsapp ? (
                <Field
                  type="checkbox"
                  component={CheckboxFieldFF}
                  name="whatsApp"
                  label="Receive whatsApp update"
                  initialValue="whatsApp"
                  className="hide"
                />
              ) : (
                <></>
              )}

              {Configuration.registrationForm.declarationEnabled ? (
                <>
                  <Field
                    type="checkbox"
                    component={CheckboxFieldFF}
                    name="declaration"
                    label="I hereby declare that all the information provided by me is true and accurate to the best of my knowledge. I understand that this information will be used to support my well-being and to provide health-related facilities and services."
                    initialValue={true}
                    className="mb-20px"
                  />
                  <Field
                    type="checkbox"
                    component={CheckboxFieldFF}
                    name="phLcEDwSQS6" //old - VW597Bjif6W, new - phLcEDwSQS6
                    label="I hereby provide my full consent for the concerned healthcare provider/team to approach and communicate with my family regarding my medical condition, including but not limited to the nature of the disease, treatment options, and any necessary support or decisions related to my care."
                    initialValue={false}
                    className="mb-20px"
                  />

                  <>
                    <Grid item xs={12} sm={4} md={4}>
                      <p className="consent-link" onClick={handleOpenconsent}>
                        Consent for Initiating the Services.
                      </p>
                    </Grid>

                    <Dialog
                      open={open}
                      onClose={handleCloseconsent}
                      maxWidth="lg"
                      fullWidth
                    >
                      <DialogTitle
                        sx={{ position: "relative", fontWeight: "bold" }}
                      >
                        Consent Form for Initiating Service/s under SWASTHYA
                        Project
                        <IconButton
                          onClick={handleCloseconsent}
                          size="small"
                          style={{
                            color: "red",
                            position: "absolute",
                            top: 5,
                            right: 5,
                            background: "white",
                            borderRadius: "50%",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>

                      <DialogContent
                        dividers
                        sx={{ maxHeight: "80vh", overflowY: "auto" }}
                      >
                        {/* Introduction */}
                        <Typography variant="body1" paragraph>
                          (Consent to be taken from each Client before
                          initiating service/s under the Project SWASTHYA Kendra
                          and getting him/her registered under the Project.
                          Service provisions will be briefed to the Client,
                          along with the necessary personal information being
                          collected for the provisioning of customized services
                          under the Project.)
                        </Typography>

                        <Typography variant="body2" paragraph>
                          <i>
                            Client shall mean any and all individuals who will
                            be opting for the healthcare and any other services
                            by Plan International (India Chapter) for which this
                            consent is being obtained.
                          </i>
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="body2" paragraph>
                          Read the consent form to the Client and seek his/her
                          consent for initiating service and visit.
                        </Typography>

                        {/* Staff Introduction */}
                        <Typography variant="body2" paragraph>
                          My name is (Name of the staff) …………………………………… I work
                          as (designation) ………………………………………….. at (Name of the
                          facility) ………………………………………….
                        </Typography>

                        <Typography variant="body2" paragraph>
                          <i>
                            I would like to have your consent for providing
                            services through the SWASTHYA Project, which will be
                            facilitated by me.
                          </i>
                        </Typography>

                        <Typography variant="body2" paragraph>
                          After your registration at SWASTHYA Project, you will
                          be provided health and non-health services based on
                          your requirements and the provisions listed under the
                          Project.
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        {/* Health Services */}
                        <Typography variant="h5" gutterBottom>
                          Health Services - Minimum Package
                        </Typography>
                        <ul>
                          <li>
                            BP, Pulse, Weight, Height, Body Mass Index (BMI),
                            Eye check-up, Dental check-up
                          </li>
                        </ul>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="h5" gutterBottom>
                          Need-Based Health Services
                        </Typography>
                        <ul>
                          <li>
                            Screening for acute infections/injuries, Diabetes,
                            Diagnosis for certain musculoskeletal disorder like
                            neck pain, headache, migraine, etc., Physical
                            examination (any sings /symptoms of chronic
                            disease/early signs of cancer/genetic disease).
                          </li>
                          <li>
                            Counselling Services for safe sexual behaviour,
                            nutrition, hygiene, importance of physical activity,
                            illicit drug use.
                          </li>
                          <li>
                            Screening for anaemia (low haemoglobin), liver
                            function tests/kidney function tests by liaising
                            with local laboratories.
                          </li>
                          <li>
                            Screening services for HIV, TB, STIs, Hepatitis and
                            treatment linkages for confirmed positive clients.
                          </li>
                        </ul>

                        <Divider sx={{ my: 2 }} />

                        {/* Non-Health Services */}
                        <Typography variant="h5" gutterBottom>
                          Non-Health Services
                        </Typography>
                        <ul>
                          <li>
                            Sensitization of truckers and allied population on
                            financial planning and management.
                          </li>
                          <li>
                            Sensitization of truckers and allied population on
                            insurance support.
                          </li>
                          <li>
                            Linkages with social protection schemes like ABHA,
                            PMJAY, Highway hero, aiding in opening bank
                            accounts, updating Aadhaar cards, etc.
                          </li>
                          <li>
                            Services like resting/sleeping facility, bathing and
                            toilet facility, recreational facility etc.
                          </li>
                        </ul>

                        <Divider sx={{ my: 2 }} />

                        {/* Purpose of Information Collection */}
                        <Typography variant="h5" gutterBottom>
                          Purpose of Information Collection
                        </Typography>
                        <Typography variant="body2" paragraph>
                          The personal information collected during the formal
                          registration process will be used only for the
                          following purposes:
                        </Typography>
                        <ul>
                          <li>
                            <strong>Service Provisioning:</strong> To provide
                            health screening, social welfare services, and
                            entitlement scheme linkages under the Project.
                          </li>
                          <li>
                            <strong>
                              Project Monitoring and Reporting, Impact
                              Assessment:
                            </strong>
                            To Monitor the progress of the Project and assess
                            service delivery outcomes.
                          </li>
                          <li>
                            <strong>Communication:</strong> To contact you for
                            services, follow-ups, or Project-related updates.
                          </li>
                        </ul>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="h5" gutterBottom>
                          Types of Information Collected
                        </Typography>
                        <ul>
                          <li>Full Name</li>
                          <li>Age/Date of Birth</li>
                          <li>Gender</li>
                          <li>Contact Details (Phone Number, Address, etc.)</li>
                          <li>Occupation / Work Details</li>
                          <li>
                            Health Screening Results and Related Information
                          </li>
                        </ul>

                        <Divider sx={{ my: 2 }} />
                        <Typography variant="body2" paragraph>
                          The personal information collected shall include the
                          following:
                        </Typography>

                        {/* Confidentiality and Data Protection */}
                        <Typography variant="h5" gutterBottom>
                          Confidentiality and Data Protection
                        </Typography>
                        <ol>
                          <li>
                            All personal information collected physically as
                            well as digitally will be stored in a secured manner
                            (including digitally) and only authorized personnel
                            of Plan India shall access such information
                            collected for the purposes of this Project. It is
                            the responsibility of Plan India to destroy physical
                            copies of all personal information once saved
                            digitally.
                          </li>
                          <li>
                            Your information will not be shared with any third
                            parties, except as required by law or for
                            Project-related purposes with authorised healthcare
                            professionals and project sponsor- DP World.
                            However, your personal details shall not be
                            transferred to any third party outside the
                            jurisdiction of India.
                          </li>
                          <li>
                            The data will be used strictly for Project purposes
                            only and will be retained for the intended purposes
                            or as otherwise required by law. Post the closure of
                            the Project, the personal data received shall be
                            destroyed/ deleted by us.{" "}
                            <i>
                              For clarity, Project shall mean medical and health
                              checkup activities for truck drivers and helpers
                              visiting the Mundra port and opting for such
                              health check-up, restroom and recreation
                              facilities provided.{" "}
                            </i>
                          </li>
                          <li>
                            You have the right to access, update, request to
                            erase data or withdraw your consent regarding your
                            personal data at any time. However, withdrawal of
                            consent might impact the services provided to you by
                            us.
                          </li>
                          <li>
                            For any of aforenamed purposes, grievances you may
                            write to.
                            <br />
                            <strong>Name of Grievance Officer:</strong>{" "}
                            Mr./Ms…………………………………(Site In-charge)
                            <br />
                            <strong>Email:</strong> ………………………………………. <br />
                            <strong>Timeline:</strong> Requests will be
                            acknowledged within 24 hours and resolved within 30
                            days in accordance with provisions under applicable
                            Data Protection laws of India
                          </li>
                        </ol>

                        <Divider sx={{ my: 2 }} />

                        {/* Accuracy of Data */}
                        <Typography variant="h5" gutterBottom>
                          ACCURACY OF DATA
                        </Typography>
                        <Typography variant="body2" paragraph>
                          <strong>
                            I understand that I am responsible for - <br />
                            Providing correct information while registering for
                            the Services under the SWASTHYA Project <br />
                            Providing correct and verifiable personal data and
                            other information at time of registration and while
                            availing services under the Project.
                          </strong>
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        {/* Consent Declaration */}
                        <Typography variant="h5" gutterBottom>
                          Consent Declaration
                        </Typography>
                        <Typography variant="body2" paragraph>
                          I hereby provide my consent to the SWASTHYA Project
                          team to collect, use, and process my personal
                          information for the purposes mentioned above. I
                          understand that:
                        </Typography>
                        <ol>
                          <li>
                            My information will only be used for the stated
                            Project purpose.
                          </li>
                          <li>
                            My data will be kept confidential and protected
                            under applicable data protection laws by Plan India
                            and its policies.
                          </li>
                          <li>
                            I can withdraw my consent at any time by notifying
                            the NGO in writing to concerned Grievance Officer.
                          </li>
                        </ol>

                        <Box mt={3}>
                          <Typography variant="body2">
                            <strong>
                              Signature / Thumb Impression of Client:
                            </strong>{" "}
                            …………………………
                          </Typography>
                          <Typography variant="body2">
                            <strong>Address: </strong> ……………………………………………………
                          </Typography>
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="caption" color="textSecondary">
                          (Note: The additional line of consent is to share
                          health information of person registering for services
                          with relatives which he may or may not give, is
                          legally correct. However, name and address of such
                          relatives may also be taken and recorded. Such person
                          also should be above 18 years of age, which can be
                          verified by photo ID proof.).
                        </Typography>
                      </DialogContent>
                    </Dialog>
                  </>

                  <div>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Select an Option:
                      </FormLabel>
                      <RadioGroup
                        aria-label="options"
                        name="radioGroup"
                        value={fingerOrSignature}
                        onChange={(event) =>
                          setFingerOrSignature(event.target.value)
                        }
                      >
                        <FormControlLabel
                          value="finger"
                          control={<Radio />}
                          label="Fingerprint"
                        />
                        <FormControlLabel
                          value="signature"
                          control={<Radio />}
                          label="Signature"
                        />
                      </RadioGroup>
                    </FormControl>

                    {fingerOrSignature === "signature" && (
                      <>
                        {signatureDataURL && (
                          <Grid item xs={12} sm={4} md={4}>
                            <div
                              style={{
                                marginTop: 10,
                                position: "relative",
                                display: "inline-block",
                              }}
                            >
                              <p style={{ marginBottom: 4 }}>Signature:</p>
                              <Tooltip title={t("Delete Signature")}>
                                <IconButton
                                  onClick={DeleteSignature}
                                  size="small"
                                  style={{
                                    color: "red",
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    background: "white",
                                    borderRadius: "50%",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              {signatureDataURL && (
                                <img
                                  src={signatureDataURL}
                                  alt="Signature Preview"
                                  style={{
                                    border: "1px solid #ccc",
                                    borderRadius: 4,
                                    maxWidth: "100%",
                                    height: "60px",
                                    width: "235px",
                                  }}
                                />
                              )}
                            </div>
                          </Grid>
                        )}
                        <div className="buttons">
                          <button
                            type="button"
                            onClick={handleOpen}
                            className="regformsubmitbtn"
                            disabled={submitting}
                          >
                            {t("Add Signature")}
                          </button>
                        </div>
                      </>
                    )}
                    {fingerOrSignature === "finger" && (
                      <div style={{ width: "30%" }}>
                        <FingerprintCapture
                          setFingerBlob={setFingerBlob}
                          setFingerDataURL={setFingerDataURL}
                          fingerPrint={fingerDataURL}
                        />
                      </div>
                    )}
                  </div>
                  <Dialog
                    open={openSignatureModal}
                    onClose={handleClose}
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogTitle>Signature</DialogTitle>
                    <DialogContent>
                      <div
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: 8,
                          padding: 10,
                          backgroundColor: "#fafafa",
                          textAlign: "center",
                        }}
                      >
                        <SignatureCanvas
                          penColor="black"
                          ref={sigCanvasRef}
                          canvasProps={{
                            width: 500,
                            height: 150,
                            style: {
                              borderRadius: 4,
                              backgroundColor: "white",
                            },
                          }}
                        />
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={clearSignature}>Clear</Button>
                      <Button onClick={saveSignature} variant="contained">
                        Save
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              ) : (
                <></>
              )}
              {initialValues && initialValues[qrCodeId] ? (
                <div>
                  <QRCode
                    id="qr-gen"
                    value={initialValues[qrCodeId]}
                    size={100}
                    level={"H"}
                    includeMargin={true}
                    //onClick={enlargeImg}
                  />
                  {!window.cordova ? (
                    <p>
                      <button
                        type="button"
                        className="regformsubmitbtn"
                        onClick={() => downloadQRCode(initialValues[qrCodeId])}
                      >
                        {t("Download QR Code")}
                      </button>
                    </p>
                  ) : (
                    <></>
                  )}
                  {window.cordova && navigator.onLine ? (
                    <p>
                      <button
                        type="button"
                        onClick={() => shareQRCode(initialValues)}
                      >
                        {t("Share QR Code")}
                      </button>
                    </p>
                  ) : null}
                </div>
              ) : (
                <></>
              )}
              {Configuration.roleAccess["Client Record - Edit"][
                sessionUserBoValue.userCredentials.userRoles[0].name
              ] && (
                <div className="buttons">
                  <button
                    className="regformsubmitbtn xx submitButton"
                    type="submit"
                    disabled={submitting}
                  >
                    {t("Submit")}
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      />
    );
  }

  const downloadQRCode = (qrValue) => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qrcode.png"; //`${qrValue}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function QRImageUploadSuccessCallback(r) {
    setGlobalSpinner(false);
    if (r && r.secure_url) {
      // console.log("rr ", r.secure_url);
      //window.plugins.socialsharing.share('Prevent TB: QR Code', null, r.secure_url, null)
      window.plugins.socialsharing.shareViaWhatsApp(
        "Prevent TB: QR Code",
        r.secure_url,
        null /* url */,
        function () {
          console.log("share ok");
        },
        function (errormsg) {
          console.log(errormsg);
        }
      );
    }
  }

  const shareQRCode = (value) => {
    var canvas = document.getElementById("qr-gen");
    var dataUri = canvas.toDataURL("image/png");
    //console.log("base64String ",dataUri);
    //setGlobalSpinner(true)
    // Do stuff with the photo...

    //window.plugins.socialsharing.shareViaWhatsApp('Prevent TB: QR Code', null, dataUri, null)
    let messageTxt =
      "Dear " +
      value[firstNameId] +
      ", Thank you for registering in the program , please produce this QR code at the treatment center to avail quick services";
    window.plugins.socialsharing.shareViaWhatsApp(
      messageTxt,
      dataUri,
      null /* url */,
      function () {
        console.log("share ok");
      },
      function (errormsg) {
        console.log(errormsg);
      }
    );
    // const API_ENDPOINT = 'https://api.cloudinary.com/v1_1/dh5r8k5vs/upload';
    // dataUri = dataUri.includes("data:image/jpeg;base64,") ? dataUri : "data:image/jpeg;base64,"+dataUri;
    // const fileData = new FormData();
    // fileData.append('file', dataUri);
    // fileData.append('upload_preset', 'uploadthroughapp');
    // //fileData.append('tags', 'xxxxxx'); // optional

    // fetch(API_ENDPOINT, {
    //     method: 'post',
    //     body: fileData
    // })
    // .then(response => response.json())
    // .then(data => QRImageUploadSuccessCallback(data))
    // .catch(err => {
    //     console.error('Error:', err)
    //     setGlobalSpinner(false)
    // });

    // Generate download with use canvas and stream
    //const canvas = document.getElementById("qr-gen");
    // const pngUrl = canvas
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // window.canvas2ImagePlugin.saveImageDataToLibrary(
    //     function(msg){
    //         console.log(msg);  //msg is the filename path (for android and iOS)
    //     },
    //     function(err){
    //         console.log(err);
    //     },
    //     document.getElementById('qr-gen')
    // );

    // var params = {data: base64String, prefix: 'mqr_', format: 'JPG', quality: 80, mediaScanner: true};
    // window.imageSaver.saveBase64Image(params,
    //     function (filePath) {
    //       console.log('File saved on ' + filePath);
    //     },
    //     function (msg) {
    //       console.error(msg);
    //     }
    //   );
  };

  function updateRegDataToIndex() {
    const values = [];
    const UserBO = props.userData;
    const programData = props.programData.programs[0];
    const programId = programData.id;
    const orgUnit = UserBO.organisationUnits[0].id;
    const trackedEntityType = programData.trackedEntityType.id;
    const caseDetails = trackentityInstanceDetails;
    const updateURL =
      "trackedEntityInstances/" + caseDetails.trackedEntityInstance;

    caseDetails.attributes.map((attr) => {
      var obj = {
        attribute: attr.attribute,
        value: attr.value,
      };
      if (attr.attribute == clientTypeID) {
        obj["value"] = "Index";
      }
      values.push(obj);
    });
    const updateCaseInput = {
      created: caseDetails.created,
      orgUnit: orgUnit,
      createdAtClient: caseDetails.createdAtClient,
      trackedEntityInstance: caseDetails.trackedEntityInstance,
      lastUpdated: caseDetails.lastUpdated,
      trackedEntityType: trackedEntityType,
      lastUpdatedAtClient: caseDetails.lastUpdatedAtClient,
      inactive: false,
      deleted: false,
      featureType: "NONE",
      programOwners: [
        {
          ownerOrgUnit: orgUnit,
          program: programId,
          trackedEntityInstance: caseDetails.trackedEntityInstance,
        },
      ],
      relationships: [],
      attributes: values,
    };
    apiServices.putAPI(updateURL, updateCaseInput).then((updateRes) => {});
  }

  function saveStage(
    valueToStore,
    valueForFormInput,
    currentStage,
    currentStageIndex,
    fetchActiveTab,
    form
  ) {
    form.reset();

    // console.log(
    //   "valueForFormInput,valueToStore",
    //   valueForFormInput,
    //   valueToStore,
    //   currentStage,
    // );
    const orgUnit = userData.organisationUnits[0].id;
    const programId = programData.programs[0].id;
    const referalAPIObject = { events: [] };

    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;
    let whatsAppFieldId = "";

    registrationFields.map((regField) => {
      const findWhatsAppAttribute =
        regField.trackedEntityAttribute.attributeValues.find(
          (x) => x.attribute.name == "WhatsAppNumber"
        );
      if (findWhatsAppAttribute) {
        whatsAppFieldId = regField.trackedEntityAttribute.id;
      }
    });

    if (activeAccordion != "HIV") {
      const filteredArray = valueToStore.filter(
        (a1) => !hivarray1.some((a2) => a2.id === a1.dataElement)
      );
      // console.log("filteredArray", filteredArray);

      valueToStore = filteredArray;
    }

    const saveStageInput = {
      trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      program: programId,
      programStage: currentStage.id,
      enrollment: activeCaseDetails.data.enrollmentId,
      orgUnit: orgUnit,
      notes: [],
      dataValues: valueToStore,
      status: "COMPLETED",
      eventDate: moment().format("YYYY-MM-DD"),
    };
    // logic for regimen stage save data
    if (
      currentStage.attributeValues &&
      currentStage.attributeValues.length > 0
    ) {
      currentStage.attributeValues.map((val, i) => {
        if (i + 1 == currentStage.attributeValues.length) {
          referalAPIObject.events.push(saveStageInput);
        }
      });
    } else {
      referalAPIObject.events.push(saveStageInput);
    }

    const getAllKeys = Object.keys(valueForFormInput);

    let OUFieldSelectedLocation = "";

    const filterReferalField = getAllKeys.map((keys) => {
      const filter = currentStage.programStageDataElements.filter(
        (obj) => obj.dataElement.id == keys
      );
      if (filter.length > 0) {
        filter.map((filteredField) => {
          if (filteredField.dataElement.fieldMask == "Facility Referral") {
            const filteredKey = filteredField.dataElement.id;
            const selectedOUField =
              currentStage.programStageDataElements.filter(
                (obj) => obj.dataElement.fieldMask == "Facility Referral OU"
              );

            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField[0].dataElement.id]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            const referalFieldValue = _.isArray(valueForFormInput[filteredKey])
              ? valueForFormInput[filteredKey]
              : [valueForFormInput[filteredKey]];

            referalFieldValue.map((stageId) => {
              const obj = {
                trackedEntityInstance:
                  trackentityInstanceDetails.trackedEntityInstance,
                program: programId,
                programStage: stageId,
                enrollment: navigator.onLine
                  ? trackentityInstanceDetails.enrollments[0].enrollment
                  : "",
                orgUnit: selectedOUFieldData,
                notes: [],
                dataValues: [],
                status: "SCHEDULE",
                dueDate: moment().format("YYYY-MM-DD"),
              };
              if (selectedOUFieldData) {
                referalAPIObject.events.push(obj);
              }
            });
          } else if (filteredField.dataElement.fieldMask == "Transfer Out") {
            const stageId = currentStage.id;
            const selectedOUField = filteredField.dataElement.id;
            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            const obj = {
              trackedEntityInstance:
                trackentityInstanceDetails.trackedEntityInstance,
              program: programId,
              programStage: stageId,
              enrollment: trackentityInstanceDetails.enrollments[0].enrollment,
              orgUnit: selectedOUFieldData,
              notes: [],
              dataValues: valueToStore,
              status: "SCHEDULE",
              dueDate: moment().format("YYYY-MM-DD"),
            };
            if (selectedOUFieldData) {
              referalAPIObject.events = [];
              referalAPIObject.events.push(obj);
            }
          }
        });
      }
    });
    // for Asign task stage logic
    if (
      currentStage.attributeValues &&
      currentStage.attributeValues.length > 0 &&
      currentStage.attributeValues[0].attribute.name == "Assign Task"
    ) {
      let taskAssignUserDataElement =
        currentStage.programStageDataElements.filter(
          (obj) => obj.dataElement.displayFormName == "Task Assign User"
        );
      referalAPIObject.events[0].status = "SCHEDULE";
      referalAPIObject.events[0]["assignedUser"] =
        valueForFormInput[taskAssignUserDataElement[0].dataElement.id];
    }

    if (navigator.onLine) {
      setGlobalSpinner(true);
      apiServices
        .postAPI("events.json", referalAPIObject)
        .then((stageResponse) => {
          setGlobalSpinner(false);
          try {
            axios.post(
              process.env.NODE_ENV === "development"
                ? `http://localhost:9000/mrunner_api/refreshDashboards`
                : `${window.location.protocol}//${window.location.host}/mrunner_api/refreshDashboards`,
              { r_id: 2 }
            );
          } catch (e) {}
          if (!workFlow) {
            OfflineDb.setDataIntoPouchDB("newSeviceStart", false);
            setServiceStartFlag(false);
          }

          if (currentStage.id == NCDStageId || currentStage.id == CDStageId) {
            apiServices
              .getAPI("dashboardIndicator/UpdateReferralData")
              .then((res) => {
                console.log(res);
              });
          }

          if (
            currentStageIndex == 1 &&
            programData.programs[0].useFirstStageDuringRegistration == true &&
            relationShipId != "" &&
            Configuration.registrationForm.linkContactInAlert
          ) {
            swal({
              title: t(
                "Individual Registered. Your dashboard will load shortly."
              ),
              text: t("Do you want to initiate the individual registration?"),
              icon: "success",
              buttons: [t("No"), t("Yes")],
            }).then((AlertRes) => {
              if (AlertRes) {
                //save data
                const linkContact = {
                  enabled: true,
                  linkTrackedEntityInstance:
                    activeCaseDetails.data.trackedEntityInstance,
                };
                const activeStageCaseFormData = {
                  formFormat: null, //valueForFormInput,
                  dhisFormat: null, //
                };

                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeStageCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                setActiveCaseFormData({
                  data: {
                    formFormat: null, //valueForFormInput,
                    dhisFormat: null, //
                  },
                });
                setValue(0);
              } else {
                const linkContact = {
                  enabled: false,
                  linkTrackedEntityInstance:
                    activeCaseDetails.data.trackedEntityInstance,
                };
                const activeStageCaseFormData = {
                  formFormat: valueForFormInput, //valueForFormInput,
                  dhisFormat: null, //
                };

                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeStageCaseFormData
                );
                setActiveCaseFormData(activeStageCaseFormData);
                activeCaseFormDataRef.current = activeStageCaseFormData;

                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                //check next active tab
                const nextTab =
                  fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];
                if (nextTab) {
                  const indexOfNextTab =
                    programData.programs[0].programStages.findIndex(
                      (obj) => obj.id == nextTab
                    );
                  setValue(indexOfNextTab + stepIncrement);
                } else {
                  setValue(value);
                  swal({
                    title: t("Success"),
                    text: t(
                      "Successfully submited event. Your dashboard will load shortly."
                    ),
                    icon: "success",
                    button: t("Close"),
                  });
                  history.push("/layout/home");
                }
              }
            });
          } else if (
            props.stageTabValue &&
            props.stageTabValue != 0 &&
            props.stageInstanceID
          ) {
            let submittedDataValues = "";
            let stageID = "";
            let orgUnit = "";
            let trackeInstanceID =
              trackentityInstanceDetails.trackedEntityInstance;
            trackentityInstanceDetails.enrollments[0].events.map((event) => {
              submittedDataValues = event.dataValues;
              stageID = event.programStage;
              orgUnit = event.orgUnit;
            });
            const updateURL = "events/" + props.stageInstanceID;
            let UpdateStageInput = {
              dataValues: submittedDataValues,
              event: props.stageInstanceID,
              program: programId,
              programStage: stageID,
              orgUnit: orgUnit,
              trackedEntityInstance: trackeInstanceID,
              status: "COMPLETED",
              dueDate: moment().format("YYYY-MM-DD"),
              eventDate: moment().format("YYYY-MM-DD"),
              completedDate: moment().format("YYYY-MM-DD"),
            };

            apiServices
              .putAPI(updateURL, UpdateStageInput)
              .then((stageResponse) => {
                const trasferAPI =
                  "30/tracker/ownership/transfer?trackedEntityInstance=" +
                  trackeInstanceID +
                  "&program=" +
                  programId +
                  "&ou=" +
                  referalAPIObject.events[0].orgUnit;
                apiServices.putAPI(trasferAPI, {}).then((trasferResponse) => {
                  swal({
                    title: t("Success"),
                    text: t(
                      "Successfully submitted event. Your dashboard will load shortly"
                    ),
                    icon: "success",
                    button: t("Close"),
                  });
                  history.push("/layout/home");
                });
              });
          } else {
            let redirectedHome = false;
            const getURL =
              "trackedEntityInstances/" +
              activeCaseDetails.data.trackedEntityInstance +
              ".json?program=" +
              programId +
              "&fields=*?";
            setGlobalSpinner(true);
            apiServices.getAPI(getURL).then((res) => {
              setGlobalSpinner(false);
              setTrackentityInstanceDetails(res.data);

              const filterEvent = res.data.enrollments[0].events.filter(
                (obj) => obj.programStage == "DxQpOKIzDXn"
              );
              let sortedEvent = _.sortBy(filterEvent, "created");
              if (sortedEvent.length > 0) {
                sortedEvent.reverse();
                const updatedHivArrayT = hivarray1.map((entry) => {
                  let matchedValues = [];

                  for (const event of sortedEvent) {
                    matchedValues = event.dataValues
                      .filter((dv) => dv.dataElement === entry.id && dv.value)
                      .map((dv) => dv.value);

                    if (matchedValues.length > 0) {
                      // Stop at first event where match is found
                      return {
                        ...entry,
                        status: true,
                        value: matchedValues[0],
                      };
                    }
                  }

                  // No match in any event
                  return { ...entry, status: false, value: [] };
                });

                sethivarraydata(updatedHivArrayT);
                const conditions = checkConditions(updatedHivArrayT);
                setHivConditions(conditions);
                if (conditions.all) {
                  setAllHIVConditionCheck(true);
                }
              }

              const previousFilledData = activeCaseFormData;

              setActiveCaseFormData({
                data: {
                  formFormat: valueForFormInput, //,
                  dhisFormat: null, //
                },
                setdata: true,
              });

              const linkContact = {
                enabled: false,
                linkTrackedEntityInstance:
                  activeCaseDetails.data.trackedEntityInstance,
              };
              const activeStageCaseFormData = {
                formFormat: valueForFormInput, //valueForFormInput,
                dhisFormat: null, //
              };

              setActiveCaseFormData({
                data: {
                  formFormat: valueForFormInput, //valueForFormInput,
                  dhisFormat: null, //
                },
              });
              activeCaseFormDataRef.current = activeStageCaseFormData;

              OfflineDb.setDataIntoPouchDB(
                "activeCaseFormData",
                activeStageCaseFormData
              );
              OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
              if (
                currentStage.name.trim().toLocaleLowerCase() ==
                "tb testing form"
              ) {
                let testResultTBObj =
                  currentStage.programStageDataElements.filter(
                    (obj) =>
                      obj.dataElement.displayName.trim() == "Test result (TB)"
                  );
                let testResultTBId =
                  testResultTBObj.length > 0
                    ? testResultTBObj[0].dataElement.id
                    : null;
                if (
                  valueForFormInput[clientTypeID] ==
                    Configuration.ltbiLinkVariables.presumptivetb &&
                  valueForFormInput[testResultTBId].trim().toUpperCase() ==
                    "POSITIVE"
                ) {
                  updateRegDataToIndex();
                }
              }
              if (
                currentStage.name.trim().toLocaleLowerCase() == "transfer out"
              ) {
                redirectedHome = true;
              }

              //next tab
              const nextTab =
                fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];
              const nextTabStage = programData.programs[0].programStages.find(
                (obj) => obj.id == nextTab
              );
              if (!stageAccessCheck(nextTabStage)) {
                redirectedHome = true;
                stepIncrement = stepIncrement + 1;
                let nextOfNextTab =
                  fetchActiveTab[fetchActiveTab.indexOf(nextTabStage.id) + 1];
                if (nextOfNextTab && !stageAccessCheck(nextOfNextTab)) {
                  redirectedHome = false;
                  stepIncrement = stepIncrement + 1;
                }
              }
              if (nextTab && !redirectedHome) {
                //if (activeAccordion != "HIV")
                starttoNewService(currentStage);
                // }
                if (currentStage.description == "CD Screening") {
                  currentStage.programStageSections.map((section, index) => {
                    if (activeAccordion === section.name) {
                      const nextIndex =
                        (index + 1) % currentStage.programStageSections.length;
                      setActiveAccordion(
                        currentStage.programStageSections[nextIndex].name
                      );
                    }
                  });
                } else if (currentStage.description == "NCD Screening") {
                  // console.log(subSectionJson[currentStage.description]);
                  (subSectionJson[activeAccordion] || []).map(
                    (subsection, index) => {
                      if (
                        subsectionactiveAccordion === subsection.subsectionName
                      ) {
                        const nextIndex =
                          (index + 1) % subSectionJson[activeAccordion].length;
                        setActiveSubSectionAccordion(
                          subSectionJson[activeAccordion][nextIndex]
                            .subsectionName
                        );
                      }
                    }
                  );
                }

                swal({
                  title: t("Success"),
                  text: t(
                    "Successfully submited event. Your dashboard will load shortly."
                  ),
                  icon: "success",
                  button: t("Close"),
                });

                const indexOfNextTab =
                  programData.programs[0].programStages.findIndex(
                    (obj) => obj.id == nextTab
                  );
                // setValue(indexOfNextTab + stepIncrement)
                if (programBoDetails && programBoDetails.isReferralWorkflow) {
                  if (
                    valueForFormInput[clientTypeID] ==
                    Configuration.ltbiLinkVariables.index
                  ) {
                    let nextTabIndex = indexOfNextTab;
                    if (currentStage.id == riskAssementStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == referralServiceStageId
                        );
                    }
                    stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                    // setValue(nextTabIndex + stepIncrement)
                  }
                }
                if (userrolename && userrolename == patientRole) {
                  history.push("/layout/home");
                }
              } else {
                //setValue(value)
                //if (activeAccordion != "HIV")
                starttoNewService(currentStage);
                if (currentStage.description == "CD Screening") {
                  currentStage.programStageSections.map((section, index) => {
                    if (activeAccordion === section.name) {
                      const nextIndex =
                        (index + 1) % currentStage.programStageSections.length;
                      setActiveAccordion(
                        currentStage.programStageSections[nextIndex].name
                      );
                    }
                  });
                } else if (currentStage.description == "NCD Screening") {
                  // console.log(subSectionJson[currentStage.description]);
                  subSectionJson[activeAccordion].map((subsection, index) => {
                    if (
                      subsectionactiveAccordion === subsection.subsectionName
                    ) {
                      const nextIndex =
                        (index + 1) % subSectionJson[activeAccordion].length;
                      setActiveSubSectionAccordion(
                        subSectionJson[activeAccordion][nextIndex]
                          .subsectionName
                      );
                    }
                  });
                }
                swal({
                  title: t("Success"),
                  text: t(
                    "Successfully submited event. Your dashboard will load shortly."
                  ),
                  icon: "success",
                  button: t("Close"),
                });
                if (userrolename && userrolename == patientRole) {
                  history.push("/layout/home");
                } else {
                  history.push("/layout/home");
                }
              }
              setGlobalSpinner(false);
            });
          }
          setGlobalSpinner(false);
        })
        .catch((err) => {
          setGlobalSpinner(false);
          swal({
            title: t("Error"),
            text: t("Something went wrong"),
            icon: "error",
            buttons: t("Close"),
          });
        });
      // if offline
    } else {
      // console.log(
      //   "valueForFormInput,valueToStore1",
      //   valueForFormInput,
      //   valueToStore,
      //   referalAPIObject
      // );
      updateOfflineServiceData(
        valueForFormInput,
        valueToStore,
        currentStage,
        referalAPIObject,
        fetchActiveTab
      );
    }
  }

  function updateStage(
    valueToStore,
    valueForFormInput,
    currentStage,
    currentStageIndex,
    eventId,
    fetchActiveTab,
    eventStatus,
    form
  ) {
    const orgUnit =
      userrolename &&
      userrolename.toLowerCase() == superAdmin &&
      trackentityInstanceDetails
        ? trackentityInstanceDetails.orgUnit
        : userData.organisationUnits[0].id;
    const programId = programData.programs[0].id;
    const updateURL = "33/events?strategy=CREATE_AND_UPDATE"; //'events/' + eventId
    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;
    let whatsAppFieldId = "";

    registrationFields.map((regField) => {
      const findWhatsAppAttribute =
        regField.trackedEntityAttribute.attributeValues.find(
          (x) => x.attribute.name == "WhatsAppNumber"
        );
      if (findWhatsAppAttribute) {
        whatsAppFieldId = regField.trackedEntityAttribute.id;
      }
    });
    let UpdateStageInput = {
      dataValues: valueToStore,
      event: eventId,
      program: programId,
      programStage: currentStage.id,
      orgUnit: orgUnit,
      trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      status: "COMPLETED",
      dueDate: moment().format("YYYY-MM-DD"),
      eventDate: moment().format("YYYY-MM-DD"),
      completedDate: moment().format("YYYY-MM-DD"),
    };

    const referalAPIObject = { events: [] };

    const getAllKeys = Object.keys(valueForFormInput);

    let OUFieldSelectedLocation = "";

    const filterReferalField = getAllKeys.map((keys) => {
      const filter = currentStage.programStageDataElements.filter(
        (obj) => obj.dataElement.id == keys
      );
      if (filter.length > 0) {
        filter.map((filteredField) => {
          if (filteredField.dataElement.fieldMask == "Facility Referral") {
            const filteredKey = filteredField.dataElement.id;
            const selectedOUField =
              currentStage.programStageDataElements.filter(
                (obj) => obj.dataElement.fieldMask == "Facility Referral OU"
              );

            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField[0].dataElement.id]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            const referalFieldValue = _.isArray(valueForFormInput[filteredKey])
              ? valueForFormInput[filteredKey]
              : [valueForFormInput[filteredKey]];
            referalFieldValue.map((stageId) => {
              let sortedEvents = _.filter(
                trackentityInstanceDetails.enrollments[0].events,
                { programStage: stageId, status: "SCHEDULE" }
              );
              if (selectedOUFieldData && sortedEvents.length == 0) {
                const obj = {
                  trackedEntityInstance:
                    activeCaseDetails.data.trackedEntityInstance,
                  program: programId,
                  programStage: stageId,
                  enrollment: navigator.onLine
                    ? trackentityInstanceDetails.enrollments[0].enrollment
                    : "",
                  orgUnit: selectedOUFieldData,
                  notes: [],
                  dataValues: [],
                  status: "SCHEDULE",
                  dueDate: moment().format("YYYY-MM-DD"),
                  eventDate: moment().format("YYYY-MM-DD"),
                };

                referalAPIObject.events.push(obj);
              }
            });
          }
          if (
            filteredField.dataElement.fieldMask == "Transfer In" ||
            filteredField.dataElement.fieldMask == "Transfer Out"
          ) {
            const stageId = currentStage.id;
            const selectedOUField = filteredField.dataElement.id;
            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            let eventStatus = "COMPLETED";
            if (filteredField.dataElement.fieldMask == "Transfer Out") {
              eventStatus = "SCHEDULE";
            }
            UpdateStageInput = {
              dataValues: valueToStore,
              event: eventId,
              program: programId,
              programStage: currentStage.id,
              orgUnit: selectedOUFieldData,
              trackedEntityInstance:
                activeCaseDetails.data.trackedEntityInstance,
              status: eventStatus,
              dueDate: moment().format("YYYY-MM-DD"),
              eventDate: moment().format("YYYY-MM-DD"),
              completedDate: moment().format("YYYY-MM-DD"),
            };
          }
        });
      }
    });
    referalAPIObject.events.push(UpdateStageInput);

    if (navigator.onLine) {
      setGlobalSpinner(true);
      apiServices
        .postAPI(updateURL, referalAPIObject)
        .then((stageResponse) => {
          if (
            props.stageTabValue &&
            props.stageTabValue != 0 &&
            props.stageInstanceID
          ) {
            swal({
              title: t("Success"),
              text: t(
                "Successfully submitted event. Your dashboard will load shortly."
              ),
              icon: "success",
              button: t("Close"),
            });
            history.push("/layout/home");
            setGlobalSpinner(false);
          } else {
            let redirectedHome = false;
            const getURL =
              "trackedEntityInstances/" +
              activeCaseDetails.data.trackedEntityInstance +
              ".json?program=" +
              programId +
              "&fields=*?";
            setGlobalSpinner(true);
            apiServices.getAPI(getURL).then((res) => {
              setGlobalSpinner(false);
              setTrackentityInstanceDetails(res.data);

              if (programData) {
                const filterEvent = res.data.enrollments[0].events.filter(
                  (obj) => obj.programStage == "DxQpOKIzDXn"
                );
                let sortedEvent = _.sortBy(filterEvent, "created");
                if (sortedEvent.length > 0) {
                  sortedEvent.reverse();
                  const updatedHivArray = hivarray1.map((entry) => {
                    let matchedValues = [];

                    for (const event of sortedEvent) {
                      matchedValues = event.dataValues
                        .filter((dv) => dv.dataElement === entry.id && dv.value)
                        .map((dv) => dv.value);

                      if (matchedValues.length > 0) {
                        // Stop at first event where match is found
                        return {
                          ...entry,
                          status: true,
                          value: matchedValues[0],
                        };
                      }
                    }

                    // No match in any event
                    return { ...entry, status: false, value: [] };
                  });

                  sethivarraydata(updatedHivArray);
                  const conditions = checkConditions(updatedHivArray);
                  setHivConditions(conditions);
                  if (conditions.all) {
                    setAllHIVConditionCheck(true);
                  }
                }
              }

              if (!workFlow) {
                OfflineDb.setDataIntoPouchDB("newSeviceStart", false);
                setServiceStartFlag(false);
              }

              const linkContact = {
                enabled: false,
                linkTrackedEntityInstance:
                  activeCaseDetails.data.trackedEntityInstance,
              };
              const activeCaseFormData = {
                formFormat: valueForFormInput, //valueForFormInput,
                dhisFormat: null, //
              };

              OfflineDb.setDataIntoPouchDB(
                "activeCaseFormData",
                activeCaseFormData
              );
              OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

              setActiveCaseFormData(activeCaseFormData);
              activeCaseFormDataRef.current = activeCaseFormData;

              //next tabs

              let nextTab =
                fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];
              // if (currentStage.name.trim().toLocaleLowerCase() == "ncd screening") {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 2]
              // }
              const nextTabStage = programData.programs[0].programStages.find(
                (obj) => obj.id == nextTab
              );
              if (!stageAccessCheck(nextTabStage)) {
                redirectedHome = true;
                stepIncrement = stepIncrement + 1;
                let nextOfNextTab =
                  fetchActiveTab[fetchActiveTab.indexOf(nextTabStage.id) + 1];
                if (nextOfNextTab && !stageAccessCheck(nextOfNextTab)) {
                  redirectedHome = false;
                  stepIncrement = stepIncrement + 1;
                }
              }

              axios.post(
                process.env.NODE_ENV === "development"
                  ? `http://localhost:9000/mrunner_api/refreshDashboards`
                  : `${window.location.protocol}//${window.location.host}/mrunner_api/refreshDashboards`,
                { r_id: 2 }
              );

              if (nextTab && !redirectedHome) {
                //if (activeAccordion != "HIV")
                starttoNewService(currentStage);
                if (currentStage.description == "CD Screening") {
                  currentStage.programStageSections.map((section, index) => {
                    if (activeAccordion === section.name) {
                      const nextIndex =
                        (index + 1) % currentStage.programStageSections.length;
                      setActiveAccordion(
                        currentStage.programStageSections[nextIndex].name
                      );
                    }
                  });
                } else if (currentStage.description == "NCD Screening") {
                  // console.log(subSectionJson[currentStage.description]);
                  subSectionJson[activeAccordion].map((subsection, index) => {
                    if (
                      subsectionactiveAccordion === subsection.subsectionName
                    ) {
                      const nextIndex =
                        (index + 1) % subSectionJson[activeAccordion].length;
                      setActiveSubSectionAccordion(
                        subSectionJson[activeAccordion][nextIndex]
                          .subsectionName
                      );
                    }
                  });
                }

                swal({
                  title: t("Updated"),
                  text: t(
                    "Successfully updated event. Your dashboard will load shortly."
                  ),
                  icon: "success",
                  button: t("Close"),
                });

                const indexOfNextTab =
                  programData.programs[0].programStages.findIndex(
                    (obj) => obj.id == nextTab
                  );
                // setValue(indexOfNextTab + stepIncrement)
              } else {
                //setValue(value);
                //if (activeAccordion != "HIV")
                starttoNewService(currentStage);
                if (currentStage.description == "CD Screening") {
                  currentStage.programStageSections.map((section, index) => {
                    if (activeAccordion === section.name) {
                      const nextIndex =
                        (index + 1) % currentStage.programStageSections.length;
                      setActiveAccordion(
                        currentStage.programStageSections[nextIndex].name
                      );
                    }
                  });
                } else if (currentStage.description == "NCD Screening") {
                  // console.log(subSectionJson[currentStage.description]);
                  subSectionJson[activeAccordion].map((subsection, index) => {
                    if (activeAccordion === subsection.subsectionName) {
                      const nextIndex =
                        (index + 1) %
                        subSectionJson[currentStage.description].length;
                      setActiveSubSectionAccordion(
                        subSectionJson[currentStage.description][nextIndex]
                          .subsectionName
                      );
                    }
                  });
                }
                swal({
                  title: t("Updated"),
                  text: t(
                    "Successfully updated event. Your dashboard will load shortly."
                  ),
                  icon: "success",
                  button: t("Close"),
                });
                history.push("/layout/home");
              }
            });
            setGlobalSpinner(false);
          }
        })
        .catch((err) => {
          setGlobalSpinner(false);
        });
    } else {
      updateOfflineServiceData(
        valueForFormInput,
        valueToStore,
        currentStage,
        referalAPIObject,
        fetchActiveTab
      );
    }
    form.reset();
  }
  function updateOfflineServiceData(
    valueForFormInput,
    valueToStore,
    currentStage,
    referalAPIObject,
    fetchActiveTab
  ) {
    setGlobalSpinner(false);
    OfflineDb.getSingleEntity(
      activeCaseDetails.data.trackedEntityInstance
    ).then((res) => {
      let redirectedHome = false;
      const tempdata = { ...res };
      tempdata.formVersion = programData.programs[0].version;
      tempdata.data = { ...tempdata.data, ...valueForFormInput };

      if (tempdata && !tempdata.hasOwnProperty("services")) {
        swal({
          title: t("Warning"),
          text: t(
            "Offline services are not be avaialble for online registered client."
          ),
          icon: "warning",
          button: t("Close"),
        });
        return;
      }
      if (tempdata.services.length > 0) {
        let servicedetails = _.find(tempdata.services, {
          events: [{ programStage: currentStage.id }],
        });
        let serviceEventIndex = _.findIndex(tempdata.services, {
          events: [{ programStage: currentStage.id }],
        });
        tempdata.services.map((service) => {
          service.events.map((ele, i) => {
            if (ele.programStage === currentStage.id) {
              servicedetails = service;
              serviceEventIndex = i;
            }
          });
        });
        if (servicedetails != undefined) {
          servicedetails.events[serviceEventIndex].dataValues = valueToStore;
        } else {
          tempdata.services.push(referalAPIObject);
        }
      } else {
        tempdata.services.push(referalAPIObject);
      }
      OfflineDb.updateFullEntity(tempdata).then((response) => {
        const linkContact = {
          enabled: false,
          linkTrackedEntityInstance:
            activeCaseDetails.data.trackedEntityInstance,
        };
        const activeStageCaseFormData = {
          formFormat: valueForFormInput,
          dhisFormat: null,
        };

        setActiveCaseFormData({
          data: {
            formFormat: valueForFormInput,
            dhisFormat: null,
          },
        });

        OfflineDb.setDataIntoPouchDB(
          "activeCaseFormData",
          activeStageCaseFormData
        );
        OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

        //next tab
        const nextTab =
          fetchActiveTab[
            fetchActiveTab.indexOf(currentStage.id) + stepIncrement
          ];
        const nextTabStage = programData.programs[0].programStages.find(
          (obj) => obj.id == nextTab
        );
        if (!stageAccessCheck(nextTabStage)) {
          redirectedHome = true;
          stepIncrement = stepIncrement + 1;
          let nextOfNextTab =
            fetchActiveTab[fetchActiveTab.indexOf(nextTabStage.id) + 1];
          if (nextOfNextTab && !stageAccessCheck(nextOfNextTab)) {
            redirectedHome = false;
            stepIncrement = stepIncrement + 1;
          }
        }
        if (nextTab && !redirectedHome) {
          swal({
            title: t("Success"),
            text: t("Successfully submited event offline"),
            icon: "success",
            button: t("Close"),
          });
          const indexOfNextTab =
            programData.programs[0].programStages.findIndex(
              (obj) => obj.id == nextTab
            );
          setValue(indexOfNextTab + stepIncrement);
          if (programBoDetails && programBoDetails.isReferralWorkflow) {
            if (
              valueForFormInput[clientTypeID] ==
              Configuration.ltbiLinkVariables.index
            ) {
              let nextTabIndex = indexOfNextTab;
              if (currentStage.id == riskAssementStageId) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == referralServiceStageId
                );
              }
              stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
              setValue(nextTabIndex + stepIncrement);
            }
            if (currentStage.id == tbTestingStageId) {
              let nextTabIndex = indexOfNextTab;
              if (
                valueForFormInput[testresultTBId] &&
                valueForFormInput[testresultTBId].toLowerCase() == "positive"
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tbTretmentInitiationStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              } else if (
                valueForFormInput[testresultTBId] &&
                valueForFormInput[testresultTBId].toLowerCase() == "negative"
              ) {
                if (
                  !valueForFormInput[IspatienteligibleforTBIId] ||
                  (valueForFormInput[IspatienteligibleforTBIId] &&
                    valueForFormInput[
                      IspatienteligibleforTBIId
                    ].toLowerCase() == "no")
                ) {
                  history.push("/layout/home");
                }
              }
            }
          }
          if (userrolename && userrolename == patientRole) {
            history.push("/layout/home");
          }
        } else {
          setValue(value);
          swal({
            title: t("Success"),
            text: t("Successfully submited event offline"),
            icon: "success",
            button: t("Close"),
          });
          if (userrolename && userrolename == patientRole) {
            history.push("/layout/home");
          } else {
            history.push("/layout/home");
          }
        }
      });
    });
  }

  function getMultiserviceArray() {
    //programRules activeCaseFormData
    let programStages = programData.programs[0].programStages;
    let stageSequenceArr = [];
    if (programRules != null) {
      programRules.map((rules) => {
        const filteredRule = rules.programRuleActions.filter(
          (obj) => obj.programRuleActionType == "DISPLAYKEYVALUEPAIR"
        );
        if (filteredRule.length > 0) {
          //const operators = ['==', '!=']
          const condition = rules.condition;
          const splitConditions = condition.split("&&");

          splitConditions.map((splitCondition) => {
            let StageDetails = {};
            StageDetails["name"] = splitCondition
              .split("V{program_stage_name} == ")[1]
              .replace(/\'/g, "")
              .trim();
            let stageObj = programStages.filter(
              (obj) =>
                obj.displayName.toLocaleLowerCase() ==
                StageDetails["name"].toLocaleLowerCase()
            );
            StageDetails["id"] =
              stageObj.length > 0 ? stageObj[0].id : undefined;
            stageSequenceArr.push(StageDetails);
          });
        }
      });
    }

    if (trackentityInstanceDetails.enrollments) {
      if (
        trackentityInstanceDetails.enrollments[0].events.length >=
        stageSequenceArr.length
      ) {
        return true;
      }
    }
    return false;
  }

  function gotoNewService() {
    let registrationFormData = {};
    programData.programs[0].trackedEntityAttribute.map((attribute) => {
      if (
        activeCaseFormData.data.formFormat.hasOwnProperty(
          attribute.trackedEntityAttribute.id
        )
      ) {
        registrationFormData[attribute.trackedEntityAttribute.id] =
          activeCaseFormData.data.formFormat[
            attribute.trackedEntityAttribute.id
          ];
      }
    });
    const activeCaseFormData = {
      formFormat: registrationFormData, //valueForFormInput,
      dhisFormat: null, //
    };

    OfflineDb.setDataIntoPouchDB("newSeviceStart", true);
    setServiceStartFlag(true);

    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
    setValue(1);
  }

  function getDateWithoutTime(dt) {
    dt.setHours(0, 0, 0, 0);
    return dt;
  }

  function starttoNewService(currentStage) {
    setGlobalSpinner(true);
    let currentStageDataToRemove = [];
    let updatedFormData = {};

    programData.programs[0].programTrackedEntityAttributes.map((attribute) => {
      if (
        activeCaseFormData?.data?.formFormat.hasOwnProperty(
          attribute.trackedEntityAttribute.id
        )
      ) {
        updatedFormData[attribute.trackedEntityAttribute.id] =
          activeCaseFormData.data.formFormat[
            attribute.trackedEntityAttribute.id
          ];
      }
    });

    programData.programs[0].programStages.map((stages, index) => {
      if (stages.id != currentStage.id) {
        stages.programStageDataElements.map((attribute) => {
          if (
            activeCaseFormData?.data.formFormat.hasOwnProperty(
              attribute.dataElement.id
            )
          ) {
            updatedFormData[attribute.dataElement.id] =
              activeCaseFormData?.data.formFormat[attribute.dataElement.id];
          }

          dataElementGroup.map((dataElements) => {
            if (dataElements.displayName == attribute.dataElement.displayName) {
              if (
                activeCaseFormData.data.formFormat.hasOwnProperty(
                  dataElements.id
                )
              ) {
                updatedFormData[dataElements.id] =
                  activeCaseFormData.data.formFormat[dataElements.id];
              }
            }
          });
        });
      } else if (stages.id == currentStage.id) {
        stages.programStageDataElements.map((attribute) => {
          if (stages.id == "DxQpOKIzDXn" && activeAccordion == "HIV") {
            // console.log("activeCaseFormDataRef", activeCaseFormDataRef);
            const fieldId = attribute.dataElement.id;
            const newValue = activeCaseFormDataRef.current?.formFormat[fieldId];

            // const match = hivarray1.find(f => f.id === fieldId);

            const hasValidValue = (obj, key) =>
              obj.hasOwnProperty(key) &&
              obj[key] !== "" &&
              obj[key] !== undefined;

            if (activeAccordion == "HIV" && activeCaseFormDataRef.current) {
              if (
                hivarray1.some((row) =>
                  hasValidValue(
                    activeCaseFormDataRef.current?.formFormat,
                    row.id
                  )
                )
              ) {
                if (hivarray1.find((f) => f.id === fieldId))
                  updatedFormData[fieldId] = newValue;
                hivarray1 = hivarray1.map((row) => ({
                  ...row,
                  status: hasValidValue(
                    activeCaseFormDataRef?.current.formFormat,
                    row.id
                  )
                    ? true
                    : row.status,
                }));
              }
              sethivarraydata(hivarray1);

              // const updatedHivArray = hivarray1.map((entry) => {
              //     let matchedValues = [];

              //     for (const event of sortedEvent) {
              //         matchedValues = event.dataValues
              //             .filter(dv => dv.dataElement === entry.id && dv.value)
              //             .map(dv => dv.value);

              //         if (matchedValues.length > 0) {
              //             // Stop at first event where match is found
              //             return { ...entry, status: true, value: matchedValues[0] };
              //         }
              //     }

              //     // No match in any event
              //     return { ...entry, status: false, value: [] };
              // });
              // sethivarraydata(updatedHivArray)
            }
          }

          dataElementGroup.map((dataElements) => {
            if (dataElements.displayName == attribute.dataElement.displayName) {
              if (
                activeCaseFormData.data.formFormat.hasOwnProperty(
                  dataElements.id
                )
              ) {
                activeCaseFormData.data.formFormat[dataElements.id] = false;
              }
            }
          });
        });
      }
    });

    const activeCaseFormData1 = {
      formFormat: updatedFormData, //valueForFormInput,
      dhisFormat: null, //
    };
    setActiveCaseFormData({
      data: {
        formFormat: updatedFormData, //valueForFormInput,
        dhisFormat: null, //
      },
    });
    OfflineDb.setDataIntoPouchDB("newSeviceStart", true);
    setServiceStartFlag(true);

    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData1);
    setTimeout(function () {
      setGlobalSpinner(false);
      document
        .querySelector(".innertabdivreg")
        .scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 500);
  }

  function checkNewServiceStatus(currentStage) {
    let updatedFormData = {};
    const events = _.isEmpty(trackentityInstanceDetails)
      ? []
      : trackentityInstanceDetails.enrollments[0].events;
    const filterCurrentEvent = events.filter(
      (obj) => obj.programStage == currentStage.id && obj.status != "SCHEDULE"
    );
    if (filterCurrentEvent.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  function createStageForms(stage, index) {
    const stageIndex = index;
    const currentStage = stage;
    let stagesData = stagesInitialValues ? stagesInitialValues : {};
    let bstageData = behaviouralstageInitialValueData
      ? behaviouralstageInitialValueData
      : {};

    let initialValues = activeCaseFormData.data
      ? activeCaseFormData.data.formFormat != null
        ? activeCaseFormData.data.formFormat
        : {}
      : {};

    var getCordovaFilePath = (imageObj) => {
      return new Promise((resolve, reject) => {
        //console.log("imageObj",imageObj)
        window.resolveLocalFileSystemURL(
          imageObj[0]["uri"],
          function (fileEntry) {
            window.requestFileSystem(
              window.LocalFileSystem.PERSISTENT,
              0,
              function (fileSys) {
                fileSys.root.getDirectory(
                  "RTMUPLOADS",
                  { create: true, exclusive: false },
                  function (dir) {
                    //var imageName = new Date().getTime() +".jpg";
                    fileEntry.copyTo(
                      dir,
                      imageObj[0]["name"],
                      function (entry) {
                        //console.log("entry ",entry)
                        var path =
                          "cdvfile://localhost/persistent" + entry.fullPath;
                        //console.log("path "+path);
                        resolve(path);
                      },
                      function (error) {
                        console.log("error 4895", JSON.stringify(error));
                        //reject(error)
                        resolve(
                          "cdvfile://localhost/persistent/RTMUPLOADS/" +
                            imageObj[0]["name"]
                        );
                      }
                    );
                  },
                  function (error) {
                    console.log("error 4902", JSON.stringify(error));
                    reject(error);
                  }
                );
              },
              function (error) {
                console.log("error 4908", JSON.stringify(error));
                reject(error);
              }
            );
          },
          function (error) {
            console.log("error 4914", JSON.stringify(error));
            reject(error);
          }
        );
      });
    };

    async function onStageSubmit(values, form) {
      setGlobalSpinner(true);

      //if(navigator.onLine){
      let fieldValueWithAttribute = [];

      programData.programs[0].programStages.map((stages, index) => {
        fetchActiveTabs(stages, values);
      });
      let fetchActiveTab = fetchActiveTabs(currentStage, values);
      const data = values;
      let promises = [];

      // Get the active accordian (tab) / sub-accordian (sub-tab) de list, and save only those value against the event
      let deList = [],
        noAccordian = false;
      if (activeAccordion) {
        if (subSectionJson[activeAccordion]) {
          const isSub = subSectionJson[activeAccordion].find((s) =>
            s.subsectionName.includes(subsectionactiveAccordion)
          );
          if (isSub) {
            deList = isSub.deList;
          }
        } else {
          const isStage = stage.programStageSections.find((s) =>
            s.displayName.includes(activeAccordion)
          );
          if (isStage) {
            deList = isStage.dataElements.map((d) => d.id);
          }
          // else {
          //   deList = stage.programStageSections.flatMap((d) =>
          //     d.dataElements.map((dIn) => dIn.id)
          //   );
          // }
        }
      } else {
        noAccordian = true;
      }

      for (let objectKey of Object.keys(values)) {
        if (deList.includes(objectKey) || noAccordian) {
          if (
            dataElementGroup.find((array) => array.id == objectKey) == undefined
          ) {
            var obj = {
              dataElement: objectKey,
              value:
                Array.isArray(data[objectKey]) == true
                  ? data[objectKey].toString()
                  : data[objectKey],
            };

            const CurrentStageValueFilter = stage.programStageDataElements.find(
              (obj) => obj.dataElement.id == objectKey
            );

            if (CurrentStageValueFilter != undefined) {
              if (
                CurrentStageValueFilter.dataElement.valueType == "IMAGE" ||
                CurrentStageValueFilter.dataElement.valueType == "FILE_RESOURCE"
              ) {
                if (data[objectKey]) {
                  let formData = new FormData();
                  formData.append("file", data[objectKey][0]);
                  //formData.append('file', data[objectKey][0]);
                  //if online
                  if (navigator.onLine) {
                    promises.push(
                      apiServices
                        .postAPI("fileResources", formData)
                        .then((res) => {
                          // console.log(res, "fileResources res");
                          if (res.data) {
                            //fieldValueWithAttribute.push({"dataElement": objectKey, "value": res.data.response.fileResource.id })
                            return {
                              dataElement: objectKey,
                              value: res.data.response.fileResource.id,
                            };
                          }
                        })
                        .catch((err) => {
                          console.log(
                            stageImageValue,
                            objectKey,
                            "fileResources err"
                          );
                          return {
                            dataElement: objectKey,
                            value: stageImageValue[objectKey],
                          };
                        })
                    );
                  } else {
                    if (
                      window.cordova &&
                      data[objectKey] &&
                      _.isArray(data[objectKey]) &&
                      data[objectKey][0] &&
                      data[objectKey][0].uri
                    ) {
                      // console.log(data[objectKey]);
                      let path = await getCordovaFilePath(data[objectKey]);
                      //console.log("4913",path)
                      fieldValueWithAttribute.push({
                        dataElement: objectKey,
                        value: path,
                      });
                      values[objectKey] = path;
                    }
                  }
                }
              } else {
                fieldValueWithAttribute.push(obj);
              }
            }
          } else {
            if (data[objectKey].length > 0) {
              data[objectKey].map((eachFields) => {
                var obj = {
                  dataElement: eachFields,
                  value: true,
                };
                const CurrentStageValueFilter =
                  stage.programStageDataElements.find(
                    (obj) => obj.dataElement.id == objectKey
                  );
                if (CurrentStageValueFilter != undefined) {
                  fieldValueWithAttribute.push(obj);
                }
              });
            }
          }
        }
      }

      //return;
      const events = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.enrollments[0].events;
      const filterCurrentEvent = events.filter(
        (obj) => obj.programStage == currentStage.id
      );

      if (promises.length == 0) {
        if (filterCurrentEvent.length > 0 && newServiceStartFlag == false) {
          if (
            currentStage.attributeValues &&
            currentStage.attributeValues.length > 0 &&
            currentStage.attributeValues[0].attribute.name == "Assign Task"
          ) {
            saveStage(
              fieldValueWithAttribute,
              values,
              currentStage,
              stageIndex,
              fetchActiveTab,
              form
            );
          } else {
            const eventId = editEventsId
              ? editEventsId
              : filterCurrentEvent[filterCurrentEvent.length - 1].event;
            if (filterCurrentEvent.length == 1) {
              updateStage(
                fieldValueWithAttribute,
                values,
                currentStage,
                stageIndex,
                eventId,
                fetchActiveTab,
                filterCurrentEvent[0].status,
                form
              );
            }

            if (filterCurrentEvent.length > 1) {
              const scheduledEvent = filterCurrentEvent.filter(
                (obj) => obj.status == "SCHEDULE"
              );
              if (scheduledEvent.length > 0) {
                const eventId = editEventsId
                  ? editEventsId
                  : scheduledEvent[scheduledEvent.length - 1].event;
                updateStage(
                  fieldValueWithAttribute,
                  values,
                  currentStage,
                  stageIndex,
                  eventId,
                  fetchActiveTab,
                  "SCHEDULE",
                  form
                );
              }
              if (scheduledEvent.length == 0) {
                updateStage(
                  fieldValueWithAttribute,
                  values,
                  currentStage,
                  stageIndex,
                  eventId,
                  fetchActiveTab,
                  null,
                  form
                );
              }
            }
          }
        } else {
          saveStage(
            fieldValueWithAttribute,
            values,
            currentStage,
            stageIndex,
            fetchActiveTab,
            form
          );
        }
      } else {
        Promise.all(promises).then((responses) => {
          responses.map((imageData) => {
            fieldValueWithAttribute.push(imageData);
          });

          if (filterCurrentEvent.length > 0 && newServiceStartFlag == false) {
            if (
              currentStage.attributeValues &&
              currentStage.attributeValues.length > 0 &&
              currentStage.attributeValues[0].attribute.name == "Assign Task"
            ) {
              saveStage(
                fieldValueWithAttribute,
                values,
                currentStage,
                stageIndex,
                fetchActiveTab,
                form
              );
            } else {
              const eventId = editEventsId
                ? editEventsId
                : filterCurrentEvent[filterCurrentEvent.length - 1].event;
              if (filterCurrentEvent.length == 1) {
                updateStage(
                  fieldValueWithAttribute,
                  values,
                  currentStage,
                  stageIndex,
                  eventId,
                  fetchActiveTab,
                  filterCurrentEvent[0].status,
                  form
                );
              }

              if (filterCurrentEvent.length > 1) {
                const scheduledEvent = filterCurrentEvent.filter(
                  (obj) => obj.status == "SCHEDULE"
                );
                if (scheduledEvent.length > 0) {
                  const eventId = editEventsId
                    ? editEventsId
                    : scheduledEvent[scheduledEvent.length - 1].event;
                  updateStage(
                    fieldValueWithAttribute,
                    values,
                    currentStage,
                    stageIndex,
                    eventId,
                    fetchActiveTab,
                    "SCHEDULE",
                    form
                  );
                }
                if (scheduledEvent.length == 0) {
                  updateStage(
                    fieldValueWithAttribute,
                    values,
                    currentStage,
                    stageIndex,
                    eventId,
                    fetchActiveTab,
                    null,
                    form
                  );
                }
              }
            }
          } else {
            saveStage(
              fieldValueWithAttribute,
              values,
              currentStage,
              stageIndex,
              fetchActiveTab,
              form
            );
          }
        });
      }
    }

    const checkNewServiceVisibility = (currentStage) => {
      return (
        Configuration.hidenewservicebutton[currentStage.displayName] ||
        Configuration.hidenewservicebutton[currentStage.description]
      );
    };

    function renderStageBySection(stage, values, form, submitting, icons) {
      let sectionWiseDE = [];
      const services = [
        "Diabetes",
        "Chronic pain or musculoskeletal",
        "Sleep-related problems and tiredness",
        "Mental Health",
        "Respiratory",
        "Acidity or Stomach",
        "Any Other NCDs",
      ];

      const ncdcolumns = [
        "Service Name",
        "PED",
        "In days",
        "Previous Treatment",
        "Checkup Date",
        "Issue Identified",
        "Counseling",
        "Treatment given at center",
        "Treatment detail",
      ];

      const checkNewServiceVisibility = (currentStage) => {
        return (
          Configuration.hidenewservicebutton[currentStage.displayName] ||
          Configuration.hidenewservicebutton[currentStage.description]
        );
      };

      const renderSectionCellValues = (section, currentStage) => {
        return section.dataElements.flatMap((de) =>
          currentStage.programStageDataElements
            .filter((fields) => de.id === fields.dataElement.id)
            .map((fields) => (
              <TableCell
                key={fields.dataElement.id}
                className={
                  fields.dataElement.shortName == "Remark"
                    ? "customremark gstablecell"
                    : "gstablecell"
                }
              >
                {fields.dataElement.shortName}
              </TableCell>
            ))
        );
      };

      const renderSectionCellDataValues = (
        section,
        currentStage,
        filteredEvents
      ) => {
        if (filteredEvents.length === 0) return null;

        let ttt = filteredEvents.reverse();

        // const paginatedEvents = filteredEvents.slice(
        //   page * rowsPerPage,
        //   page * rowsPerPage + rowsPerPage
        // );

        const allowedIds = section.dataElements.map((el) => el.id);

        // Filter only events that have at least one matching dataElement
        const matchingEvents = filteredEvents.filter((event) =>
          event.dataValues.some((dv) => allowedIds.includes(dv.dataElement))
        );

        // Apply pagination
        const paginatedEvents = matchingEvents.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        );

        const rows = paginatedEvents.map((event, i) => {
          const rowValues = [];

          const cells = section.dataElements.flatMap((de) =>
            currentStage.programStageDataElements
              .filter((fields) => de.id === fields.dataElement.id)
              .map((stages) => {
                const fieldData = event.dataValues.find(
                  (obj) => obj.dataElement === stages.dataElement.id
                );

                if (activeAccordion == "HIV")
                  fieldData && tempHIVData.push(fieldData);
                let selectedValue = "N/A";

                try {
                  if (stages.dataElement.valueType == "BOOLEAN") {
                    if (
                      dataElementGroup.filter(
                        (obj) =>
                          obj.displayName == stages.dataElement.displayName
                      ).length > 0
                    ) {
                      const filterDataElementGroup = dataElementGroup.filter(
                        (obj) =>
                          obj.displayName == stages.dataElement.displayName
                      )[0];
                      let selectedValues = "";
                      filterDataElementGroup.dataElements.map((elements) => {
                        let filterFieldData = event.dataValues.filter(
                          (obj) => elements.id === obj.dataElement
                        );
                        if (
                          filterFieldData.length > 0 &&
                          filterFieldData[0].value == "true"
                        ) {
                          selectedValues +=
                            (elements.displayName.includes("_")
                              ? elements.displayName.split("_")[1]
                              : elements.displayName) + " ,";
                        }
                      });
                      selectedValues = selectedValues.slice(0, -1);
                      selectedValue = selectedValues;
                      //return <TableCell>{selectedValues}</TableCell>;
                    }
                  } else if (stages.dataElement.valueType === "DATE") {
                    selectedValue = fieldData?.value
                      ? moment(fieldData?.value).format("YYYY-MM-DD")
                      : "";
                  } else if (
                    stages.dataElement.valueType === "ORGANISATION_UNIT"
                  ) {
                    const org = programData.programs[0].organisationUnits.find(
                      (o) => o.id === fieldData?.value
                    );
                    selectedValue = org?.displayName || "N/A";
                  } else if (
                    stages.dataElement.fieldMask === "Facility Referral"
                  ) {
                    const stageRef = programData.programs[0].programStages.find(
                      (o) => o.id === fieldData.value
                    );
                    selectedValue = stageRef?.displayName || "N/A";
                  } else if (
                    stages.dataElement.valueType == "IMAGE" ||
                    stages.dataElement.valueType == "FILE_RESOURCE"
                  ) {
                    let filterFieldData = event.dataValues.filter(
                      (obj) => stages.dataElement.id == obj.dataElement
                    );
                    if (filterFieldData.length > 0) {
                      return (
                        <TableCell>
                          <IconButton
                            onClick={(e) => {
                              setimageDataUrl(event.event, stages.dataElement);
                            }}
                          >
                            <Image />
                          </IconButton>
                        </TableCell>
                      );
                    } else return <TableCell>{t("N/A")}</TableCell>;
                  } else if (stages.dataElement.valueType == "TEXT") {
                    selectedValue =
                      fieldData?.value === "true"
                        ? "Yes"
                        : fieldData?.value === "false"
                        ? "N/A"
                        : fieldData?.value;
                  } else {
                    selectedValue =
                      fieldData?.value === "true"
                        ? "Yes"
                        : fieldData?.value === "false"
                        ? "No"
                        : fieldData?.value;
                  }
                } catch (e) {
                  console.error("Error processing field data:", e);
                }
                rowValues.push(selectedValue);

                return (
                  <TableCell key={stages.dataElement.id}>
                    {selectedValue || t("N/A")}
                  </TableCell>
                );
              })
          );
          const allNA = rowValues.every(
            (value) => value === "N/A" || value == undefined || value == ""
          );
          // if (!allNA && activeAccordion == "HIV")
          // console.log("rowValues", rowValues);
          if (allNA) return null;

          return (
            <>
              <TableRow key={`${event.event}-${i}`}>
                {cells}
                {Configuration.roleAccess["Client Record - Edit"][
                  sessionUserBoValue.userCredentials.userRoles[0].name
                ] ? (
                  <TableCell className="thisismydiv2">
                    <IconButton onClick={() => loadActiveCaseFormData(event)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                ) : null}
                {Configuration.roleAccess["Record - Delete"][
                  sessionUserBoValue.userCredentials.userRoles[0].name
                ] ? (
                  <TableCell className="thisismydiv2">
                    <IconButton onClick={() => deleteSelectedRow(event)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                ) : null}
              </TableRow>
            </>
          );
        });

        return rows.filter(Boolean); // Remove nulls
      };

      const renderSubSectionCellValues = (section, currentStage) => {
        return section.deList.map((de) => {
          return currentStage.programStageDataElements
            .filter((fields) => de === fields.dataElement.id)
            .map((fields) => (
              <TableCell key={fields.dataElement.id} className="gstablecell">
                {fields.dataElement.shortName}
              </TableCell>
            ));
        });
      };

      const renderSubSectionCellDataValues = (section, currentStage) => {
        const events =
          trackentityInstanceDetails?.enrollments?.[0]?.events || [];

        const filteredEvents = events.filter(
          (event) =>
            event.programStage === currentStage.id &&
            event.status !== "SCHEDULE"
        );

        if (filteredEvents.length === 0) return null;

        const rows = filteredEvents.map((event, i) => {
          const rowValues = [];

          const cells = section?.deList?.flatMap((de) =>
            currentStage.programStageDataElements
              .filter((field) => de === field.dataElement.id)
              .map((field) => {
                const fieldData = event.dataValues.find(
                  (obj) => obj.dataElement === field.dataElement.id
                );

                let selectedValue = t("N/A");

                try {
                  if (fieldData) {
                    const { value } = fieldData;
                    const valueType = field.dataElement.valueType;
                    const fieldMask = field.dataElement.fieldMask;

                    if (valueType === "DATE") {
                      selectedValue = moment(value).format("YYYY-MM-DD");
                    } else if (valueType === "ORGANISATION_UNIT") {
                      const org =
                        programData.programs[0].organisationUnits.find(
                          (o) => o.id === value
                        );
                      selectedValue = org?.displayName || t("N/A");
                    } else if (fieldMask === "Facility Referral") {
                      const stageRef =
                        programData.programs[0].programStages.find(
                          (o) => o.id === value
                        );
                      selectedValue = stageRef?.displayName || t("N/A");
                    } else {
                      selectedValue =
                        value === "true"
                          ? t("Yes")
                          : value === "false"
                          ? t("No")
                          : value;
                    }
                  }
                } catch (e) {
                  console.error("Error processing field data:", e);
                }

                rowValues.push(selectedValue);
                return (
                  <TableCell key={field.dataElement.id}>
                    {selectedValue}
                  </TableCell>
                );
              })
          );

          const allNA = rowValues.every((value) => value === t("N/A"));

          if (allNA) return null;

          return (
            <TableRow key={`${event.event}-${i}`}>
              {cells}
              {Configuration.roleAccess["Client Record - Edit"][
                sessionUserBoValue.userCredentials.userRoles[0].name
              ] ? (
                <TableCell className="thisismydiv1">
                  <IconButton onClick={() => loadActiveCaseFormData(event)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              ) : null}
              {Configuration.roleAccess["Record - Delete"][
                sessionUserBoValue.userCredentials.userRoles[0].name
              ] ? (
                <TableCell className="thisismydiv2">
                  <IconButton onClick={() => deleteSelectedRow(event)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              ) : null}
            </TableRow>
          );
        });
        return rows.filter(Boolean); // Remove skipped rows
      };

      const deleteSelectedRow = (event) => {
        const programId = programData.programs[0].id;
        swal({
          title: "Warnimg",
          text: t("Are you sure you want to delete this record?"),
          icon: "warning",
          buttons: ["No", "Yes"],
        }).then((alertRes) => {
          if (alertRes) {
            return new Promise(async (resolve, reject) => {
              let deletedataurl = `events/${event.event}`;
              apiServices
                .deletePatientRecordData(deletedataurl, {})
                .then((res) => {
                  // console.log('postAPI>>>', res)
                  if (res && res.data && res.data.httpStatusCode) {
                    const getURL =
                      "trackedEntityInstances/" +
                      activeCaseDetails.data.trackedEntityInstance +
                      ".json?program=" +
                      programData.programs[0].id +
                      "&fields=*?";
                    setGlobalSpinner(true);
                    apiServices
                      .getAPI(getURL)
                      .then((trackentityInstanceData) => {
                        setGlobalSpinner(false);
                        if (trackentityInstanceData.data) {
                          setTrackentityInstanceDetails(
                            trackentityInstanceData.data
                          );

                          if (programData) {
                            const filterEvent =
                              trackentityInstanceData.data.enrollments[0].events.filter(
                                (obj) => obj.programStage == "DxQpOKIzDXn"
                              );
                            let sortedEvent = _.sortBy(filterEvent, "created");
                            if (sortedEvent.length > 0) {
                              sortedEvent.reverse();
                              const updatedHivArray = hivarray1.map((entry) => {
                                let matchedValues = [];

                                for (const event of sortedEvent) {
                                  matchedValues = event.dataValues
                                    .filter(
                                      (dv) =>
                                        dv.dataElement === entry.id && dv.value
                                    )
                                    .map((dv) => dv.value);

                                  if (matchedValues.length > 0) {
                                    // Stop at first event where match is found
                                    return {
                                      ...entry,
                                      status: true,
                                      value: matchedValues[0],
                                    };
                                  }
                                }

                                // No match in any event
                                return { ...entry, status: false, value: [] };
                              });

                              sethivarraydata(updatedHivArray);
                              const conditions =
                                checkConditions(updatedHivArray);
                              setHivConditions(conditions);
                              if (conditions.all) {
                                setAllHIVConditionCheck(true);
                              }
                            }
                          }
                        } else {
                          setTrackentityInstanceDetails({});
                        }
                      })
                      .catch((err) => {
                        setGlobalSpinner(false);
                      });

                    const getImageURL =
                      "trackedEntityInstances/" +
                      activeCaseDetails.data.trackedEntityInstance +
                      "/JAhkKQjlDaQ/image";
                    apiServices.getBlobAPI(getImageURL).then((res) => {
                      // console.log(res);
                      var blob = new Blob([res.data]);
                      const imageObjectURL = URL.createObjectURL(blob);
                      setSignatureDataURL(imageObjectURL);
                    });

                    const getFingerURL =
                      "trackedEntityInstances/" +
                      activeCaseDetails.data.trackedEntityInstance +
                      "/HDbRoNrt77N/image";
                    apiServices.getBlobAPI(getFingerURL).then((res) => {
                      // console.log(res);
                      var blob = new Blob([res.data]);
                      const imageObjectURL = URL.createObjectURL(blob);
                      setFingerDataURL(imageObjectURL);
                    });
                  }
                })
                .catch((err) => {
                  // console.log('postAPIerr>>>', err, err.response.data.httpStatusCode)
                  setGlobalSpinner(false);
                  resolve(true);
                });
            });
          }
        });
      };

      const loadActiveCaseFormData = (event) => {
        OfflineDb.setDataIntoPouchDB("newSeviceStart", false);
        setServiceStartFlag(false);
        setEditEventsId(event.event);
        let InitialValueData = {};
        let promises = [];
        const DataElementGroup = dataElementGroup;
        const stageList = programData.programs[0].programStages;
        let registrationData = _.isEmpty(trackentityInstanceDetails)
          ? []
          : trackentityInstanceDetails.attributes;
        let stageData1 = _.isEmpty(trackentityInstanceDetails)
          ? []
          : trackentityInstanceDetails.enrollments[0].events;
        let stageData = [];
        let ObjecteHolder = {};
        let regObjecteHolder = {};

        if (stageList != null) {
          stageList.map((stages) => {
            const filterEvent = stageData1.filter(
              (obj) => obj.programStage == stages.id
            );
            if (filterEvent.length > 1) {
              stageData.push(filterEvent[filterEvent.length - 1]);
            } else if (filterEvent.length == 1) {
              stageData.push(filterEvent[0]);
            }
          });
        }

        registrationData.map((fields) => {
          const filterField =
            programData.programs[0].programTrackedEntityAttributes.find(
              (obj) => obj.trackedEntityAttribute.id == fields.attribute
            );
          InitialValueData[fields.attribute] = fields.value;

          if (
            filterField &&
            filterField.trackedEntityAttribute &&
            (filterField.trackedEntityAttribute.valueType == "IMAGE" ||
              filterField.trackedEntityAttribute.valueType == "FILE_RESOURCE")
          ) {
            if (fields.value) {
              const resourceGetApi = "fileResources/" + fields.value;
              regObjecteHolder[fields.attribute] = fields.value;
              promises.push(
                apiServices.getAPI(resourceGetApi).then((resources) => {
                  return {
                    dataElement: fields.attribute,
                    value: resources.data,
                  };
                })
              );
            }
          }

          // multicheckbox edit logic
          programData.programs[0].programSections.map((programSection) => {
            if (programSection.renderType["DESKTOP"].type == "SEQUENTIAL") {
              programSection.trackedEntityAttributes.map((elements) => {
                if (
                  programSection.trackedEntityAttributes.find(
                    (array) => array.id == fields.attribute
                  )
                ) {
                  if (InitialValueData[programSection.id] == undefined) {
                    InitialValueData[programSection.id] = [fields.attribute];
                  } else {
                    if (
                      !InitialValueData[programSection.id].includes(
                        fields.attribute
                      )
                    ) {
                      InitialValueData[programSection.id].push(
                        fields.attribute
                      );
                    }
                  }
                }
              });
            }
          });
        });

        stageData.map((events) => {
          let dataValue = [];
          if (events.programStage == event.programStage)
            dataValue = event.dataValues;
          else dataValue = events.dataValues;
          dataValue.map((fields) => {
            if (stageList != null) {
              stageList.map((stages) => {
                const filter = stages.programStageDataElements.filter(
                  (obj) => obj.dataElement.id == fields.dataElement
                );

                if (filter.length > 0) {
                  if (filter[0].dataElement.fieldMask == "Facility Referral") {
                    try {
                      InitialValueData[fields.dataElement] =
                        fields.value.split(",");
                    } catch (e) {
                      console.log(e);
                    }
                  } else if (
                    filter[0].dataElement.valueType == "IMAGE" ||
                    filter[0].dataElement.valueType == "FILE_RESOURCE"
                  ) {
                    if (fields.value) {
                      const resourceGetApi = "fileResources/" + fields.value;
                      ObjecteHolder[fields.dataElement] = fields.value;
                      promises.push(
                        apiServices.getAPI(resourceGetApi).then((resources) => {
                          return {
                            dataElement: fields.dataElement,
                            value: resources.data,
                          };
                        })
                      );
                    }
                  } else {
                    DataElementGroup.map((DEG) => {
                      DEG.dataElements.map((dataElements) => {
                        if (
                          DEG.dataElements.find(
                            (array) =>
                              array.id == fields.dataElement &&
                              fields.value == "true"
                          )
                        ) {
                          if (InitialValueData[DEG.id] == undefined) {
                            InitialValueData[DEG.id] = [fields.dataElement];
                          } else {
                            if (
                              !InitialValueData[DEG.id].includes(
                                fields.dataElement
                              )
                            ) {
                              InitialValueData[DEG.id].push(fields.dataElement);
                            }
                          }
                        }
                      });
                    });
                    InitialValueData[fields.dataElement] =
                      fields.value == "false"
                        ? false
                        : fields.value == "true"
                        ? true
                        : fields.value;
                  }
                }
              });
            }
          });
        });

        setStageregImageValue(regObjecteHolder);
        setStageImageValue(ObjecteHolder);
        if (promises.length == 0) {
          const activeCaseFormData = {
            data: {
              formFormat: InitialValueData, //valueForFormInput,
              dhisFormat: null, //
            },
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData(activeCaseFormData);
        } else {
          Promise.all(promises).then((responses) => {
            responses.map((response) => {
              InitialValueData[response.dataElement] = [
                new File([""], response.value.displayName, {
                  size: response.value.contentLength,
                  type: response.value.contentType,
                  webkitRelativePath: "",
                }),
              ];
            });
            const activeCaseFormData = {
              data: {
                formFormat: InitialValueData, //valueForFormInput,
                dhisFormat: null, //
              },
            };

            OfflineDb.setDataIntoPouchDB(
              "activeCaseFormData",
              activeCaseFormData
            );
            setActiveCaseFormData(activeCaseFormData);
          });
        }
      };

      const events = trackentityInstanceDetails?.enrollments?.[0]?.events || [];
      let tempHIVData = [];
      const filteredEvents = events.filter(
        (event) =>
          event.programStage === currentStage.id && event.status !== "SCHEDULE"
      );

      stage.programStageSections.map((section, i) => {
        let subsectionDeArray = [];

        sectionWiseDE.push(
          <Grid
            container
            spacing={3}
            className={
              "sectiondivmaincontainer behaviouralSection  section-" +
              i +
              "-" +
              stage.id
            }
            key={"section-" + i + "-" + stage.id}
          >
            <Grid item xs={12} sm={12} md={12}>
              <Accordion
                expanded={activeAccordion === section.displayName}
                onChange={() => {
                  setActiveAccordion(section.displayName);
                  form.reset();
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={"panel1a-content" + i}
                  id={"panel1a-content" + i}
                >
                  <Typography className={classes.heading}>
                    <strong>{t(section.name)}</strong>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {activeAccordion === section.displayName && (
                    <Typography>
                      <div>
                        <Grid
                          container
                          spacing={3}
                          className="historyAccordian"
                        >
                          {section.dataElements.map((de) =>
                            stage.programStageDataElements.map((fields) => {
                              if (
                                de.id === fields.dataElement.id &&
                                !ncdsubsectionDeListItems.includes(de.id) &&
                                !healthservicesubsection.includes(de.id)
                              ) {
                                return renderStageField(
                                  fields,
                                  values || {},
                                  form,
                                  stage.programStageDataElements,
                                  stage,
                                  activeAccordion,
                                  hivBehavioural
                                );
                              }
                            })
                          )}
                        </Grid>
                        {/* REnder sub section here */}
                        {subSectionJson[section.name]?.length > 0 &&
                          subSectionJson[section.name].map(
                            (subsection, index) => (
                              <Grid
                                container
                                spacing={3}
                                className={
                                  "sectiondivmaincontainer section-" +
                                  i +
                                  "-" +
                                  stage.id
                                }
                              >
                                <Grid item xs={12} sm={12} md={12}>
                                  <Accordion
                                    key={subsection.subsectionName}
                                    expanded={
                                      subsectionactiveAccordion ===
                                      subsection.subsectionName
                                    }
                                    onChange={() => {
                                      setActiveSubSectionAccordion(
                                        subsectionactiveAccordion ===
                                          subsection.subsectionName
                                          ? null
                                          : subsection.subsectionName
                                      );
                                      form.reset();
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls={`panel-${index}-content`}
                                      id={`panel-${index}-header`}
                                    >
                                      <Typography className="lab-heading mb-10px fbold">
                                        {t(subsection.subsectionName)}
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails className="subsectionAccordion">
                                      {subsectionactiveAccordion ===
                                        subsection.subsectionName && (
                                        <>
                                          <Typography>
                                            <div>
                                              <Grid
                                                container
                                                spacing={3}
                                                className=""
                                              >
                                                {subsection.deList.map((de) =>
                                                  stage.programStageDataElements.map(
                                                    (fields) => {
                                                      if (
                                                        de ===
                                                        fields.dataElement.id
                                                      ) {
                                                        return renderStageField(
                                                          fields,
                                                          values || {},
                                                          form,
                                                          stage.programStageDataElements,
                                                          stage,
                                                          activeAccordion,
                                                          hivBehavioural
                                                        );
                                                      }
                                                      return null;
                                                    }
                                                  )
                                                )}
                                              </Grid>
                                            </div>
                                          </Typography>

                                          {/* Buttons */}
                                          {Configuration.roleAccess[
                                            "Client Record - Edit"
                                          ][
                                            sessionUserBoValue.userCredentials
                                              .userRoles[0].name
                                          ] ? (
                                            <div className="button-group mt-20px">
                                              <button
                                                className="regformsubmitbtn 15 submitButton"
                                                type="submit"
                                                disabled={submitting}
                                              >
                                                {t("Submit")}
                                              </button>

                                              <button
                                                className={
                                                  `regformsubmitbtn newservicebtn ` +
                                                  (checkNewServiceStatus(stage)
                                                    ? checkNewServiceVisibility(
                                                        stage
                                                      )
                                                      ? "hide"
                                                      : ""
                                                    : "hide")
                                                }
                                                style={{ float: "right" }}
                                                type="button"
                                                onClick={() =>
                                                  starttoNewService(stage)
                                                }
                                              >
                                                <AddIcon />
                                              </button>
                                            </div>
                                          ) : null}

                                          {/* Data Table */}
                                          <TableContainer
                                            component={Paper}
                                            className="mr-10px mt-20px mb-20px ShowServiceTab-tabel 33"
                                          >
                                            <Table
                                              className={classes.table}
                                              aria-label="simple table"
                                            >
                                              <TableHead>
                                                <TableRow>
                                                  {renderSubSectionCellValues(
                                                    subsection,
                                                    stage
                                                  )}
                                                  {Configuration.roleAccess[
                                                    "Client Record - Edit"
                                                  ][
                                                    sessionUserBoValue
                                                      .userCredentials
                                                      .userRoles[0].name
                                                  ] ? (
                                                    <TableCell className="gstablecell">
                                                      {t("Edit")}
                                                    </TableCell>
                                                  ) : null}
                                                  {Configuration.roleAccess[
                                                    "Record - Delete"
                                                  ][
                                                    sessionUserBoValue
                                                      .userCredentials
                                                      .userRoles[0].name
                                                  ] ? (
                                                    <TableCell>
                                                      {t("Delete")}
                                                    </TableCell>
                                                  ) : null}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {renderSubSectionCellDataValues(
                                                  subsection,
                                                  stage
                                                )}
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        </>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            )
                          )}
                        {section.name != "Health Service (Minimum Package)" &&
                          section.name !=
                            "NCDs Screening, Treatment and Linkages" &&
                          Configuration.roleAccess["Client Record - Edit"][
                            sessionUserBoValue.userCredentials.userRoles[0].name
                          ] && (
                            <>
                              <div class="button-group  mt-20px sectionbtn">
                                <button
                                  className="regformsubmitbtn 12 submitButton"
                                  type="submit"
                                  disabled={submitting}
                                >
                                  {t("Submit")}
                                </button>

                                {activeAccordion !== "HIV" && (
                                  <button
                                    className={
                                      `regformsubmitbtn newservicebtn ` +
                                      (checkNewServiceStatus(stage)
                                        ? checkNewServiceVisibility(stage)
                                          ? "hide"
                                          : ""
                                        : "hide")
                                    }
                                    style={{ float: "right" }}
                                    type="button"
                                    onClick={() => starttoNewService(stage)}
                                  >
                                    <AddIcon></AddIcon>
                                  </button>
                                )}
                              </div>
                              {activeAccordion == "HIV" && (
                                <div className="fa-sm">
                                  <strong>Note:&nbsp;</strong>Please click the
                                  Refresh icon to clear the field and enter new
                                  data.
                                </div>
                              )}
                            </>
                          )}

                        {section.name != "Health Service (Minimum Package)" &&
                          section.name != "CD Screening" &&
                          section.name != "Any Other NCDs" &&
                          section.name != "NCD Screening" &&
                          section.name !=
                            "NCDs Screening, Treatment and Linkages" &&
                          section.name !=
                            "Communicable & Non-Communicable Diseases Screening" && (
                            <>
                              <TableContainer
                                component={Paper}
                                className="mr-10px mb-20px mt-20px ShowServiceTab-tabel 44"
                              >
                                <Table
                                  className={classes.table}
                                  aria-label="simple table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      {renderSectionCellValues(section, stage)}
                                      {Configuration.roleAccess[
                                        "Client Record - Edit"
                                      ][
                                        sessionUserBoValue.userCredentials
                                          .userRoles[0].name
                                      ] ? (
                                        <TableCell className="gstablecell">
                                          {t("Edit")}
                                        </TableCell>
                                      ) : null}
                                      {Configuration.roleAccess[
                                        "Record - Delete"
                                      ][
                                        sessionUserBoValue.userCredentials
                                          .userRoles[0].name
                                      ] ? (
                                        <TableCell>{t("Delete")}</TableCell>
                                      ) : null}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {renderSectionCellDataValues(
                                      section,
                                      stage,
                                      filteredEvents
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>

                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                component="div"
                                count={filteredEvents.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={(event, newPage) =>
                                  setPage(newPage)
                                }
                                onRowsPerPageChange={(event) => {
                                  setRowsPerPage(
                                    parseInt(event.target.value, 10)
                                  );
                                  setPage(0);
                                }}
                              />
                            </>
                          )}
                      </div>
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        );
      });

      return sectionWiseDE;
    }

    const checkAccordianVisibility = (currentStage) => {
      return Configuration.hideformhistoryaccordian[currentStage.displayName];
    };

    let ageGender = initialValues
      ? initialValues[genderUID]
        ? " (" + t(initialValues[genderUID]) + ")"
        : ""
      : "";

    const renderCellValues = (currentStage) => {
      return currentStage.programStageDataElements.map((stagesevdata) => {
        if (stagesevdata.dataElement.valueType == "BOOLEAN") {
          if (
            dataElementGroup.filter(
              (obj) => obj.displayName == stagesevdata.dataElement.displayName
            ).length > 0
          ) {
            return (
              <TableCell className="gstablecell">
                {getTranslatedDataElementLabels(stagesevdata.dataElement)}
              </TableCell>
            );
          }
        } else {
          return (
            <TableCell className="gstablecell">
              {stagesevdata.dataElement.formName.includes("_")
                ? stagesevdata.dataElement.formName.split("_")[1]
                : stagesevdata.dataElement.formName}
            </TableCell>
          );
        }
      });
    };

    const renderCellDataValues = (currentStage) => {
      if (!trackentityInstanceDetails?.enrollments?.length) return null;

      const sortedByCreated =
        trackentityInstanceDetails?.enrollments[0]?.events.sort((a, b) => {
          return new Date(b.created) - new Date(a.created);
        });
      return (
        trackentityInstanceDetails &&
        trackentityInstanceDetails?.enrollments &&
        trackentityInstanceDetails?.enrollments.length > 0 &&
        sortedByCreated.map((events, i) => {
          if (
            currentStage.id == events.programStage &&
            events.status != "SCHEDULE"
          ) {
            return (
              <TableRow key={events.event + i}>
                {currentStage.programStageDataElements.map((stages) => {
                  if (stages.dataElement.valueType == "BOOLEAN") {
                    if (
                      dataElementGroup.filter(
                        (obj) =>
                          obj.displayName == stages.dataElement.displayName
                      ).length > 0
                    ) {
                      const filterDataElementGroup = dataElementGroup.filter(
                        (obj) =>
                          obj.displayName == stages.dataElement.displayName
                      )[0];
                      let selectedValues = "";
                      filterDataElementGroup.dataElements.map((elements) => {
                        let filterFieldData = events.dataValues.filter(
                          (obj) => elements.id == obj.dataElement
                        );
                        if (
                          filterFieldData.length > 0 &&
                          filterFieldData[0].value == "true"
                        ) {
                          selectedValues +=
                            (elements.displayName.includes("_")
                              ? elements.displayName.split("_")[1]
                              : elements.displayName) + " ,";
                        }
                      });
                      selectedValues = selectedValues.slice(0, -1);
                      return <TableCell>{selectedValues}</TableCell>;
                    }
                  } else if (
                    stages.dataElement.valueType == "IMAGE" ||
                    stages.dataElement.valueType == "FILE_RESOURCE"
                  ) {
                    let filterFieldData = events.dataValues.filter(
                      (obj) => stages.dataElement.id == obj.dataElement
                    );
                    if (filterFieldData.length > 0) {
                      return (
                        <TableCell>
                          <IconButton
                            onClick={(e) => {
                              setimageDataUrl(events.event, stages.dataElement);
                            }}
                          >
                            <Image />
                          </IconButton>
                        </TableCell>
                      );
                    } else return <TableCell>{t("N/A")}</TableCell>;
                  } else {
                    let filterFieldData = events.dataValues.filter(
                      (obj) => stages.dataElement.id == obj.dataElement
                    );
                    let selectedValues = ""; //filterFieldData.length > 0 ? filterFieldData[0].value : ""
                    try {
                      if (
                        filterFieldData.length > 0 &&
                        stages.dataElement.valueType == "DATE"
                      ) {
                        //IF VALUE OF DATAELEMENT IS DATE
                        selectedValues = moment(
                          filterFieldData[0].value
                        ).format("YYYY-MM-DD");
                      } else if (
                        filterFieldData.length > 0 &&
                        stages.dataElement.valueType == "ORGANISATION_UNIT"
                      ) {
                        let orgobj =
                          programData.programs[0].organisationUnits.find(
                            (o) => o.id == filterFieldData[0].value
                          );
                        if (orgobj) {
                          selectedValues = orgobj.displayName;
                        }
                      } else if (
                        filterFieldData.length > 0 &&
                        stages.dataElement.fieldMask == "Facility Referral"
                      ) {
                        let stageNme =
                          programData.programs[0].programStages.find(
                            (o) => o.id == filterFieldData[0].value
                          );
                        if (stageNme) {
                          selectedValues = stageNme.displayName;
                        }
                      } else if (
                        filterFieldData &&
                        filterFieldData.length > 0
                      ) {
                        selectedValues =
                          filterFieldData[0].value == "true"
                            ? "Yes"
                            : filterFieldData[0].value == "false"
                            ? "No"
                            : filterFieldData[0].value;
                      }
                    } catch (e) {
                      console.log(e);
                    }
                    if (selectedValues) {
                      return <TableCell>{selectedValues}</TableCell>;
                    } else return <TableCell>{t("N/A")}</TableCell>;
                  }
                })}
                {Configuration.roleAccess["Client Record - Edit"][
                  sessionUserBoValue.userCredentials.userRoles[0].name
                ] ? (
                  <TableCell>
                    <IconButton
                      onClick={(e) => {
                        loadActiveCaseFormData(events);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                ) : null}

                {Configuration.roleAccess["Record - Delete"][
                  sessionUserBoValue.userCredentials.userRoles[0].name
                ] ? (
                  <TableCell>
                    <IconButton onClick={() => deleteSelectedRow(events)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                ) : null}
              </TableRow>
            );
          }
        })
      );
    };

    const deleteSelectedRow = (event) => {
      const programId = programData.programs[0].id;
      swal({
        title: "Warnimg",
        text: t("Are you sure you want to delete this record?"),
        icon: "warning",
        buttons: ["No", "Yes"],
      }).then((alertRes) => {
        if (alertRes) {
          return new Promise(async (resolve, reject) => {
            let deletedataurl = `events/${event.event}`;
            apiServices
              .deletePatientRecordData(deletedataurl, {})
              .then((res) => {
                // console.log('postAPI>>>', res)
                if (res && res.data && res.data.httpStatusCode) {
                  const getURL =
                    "trackedEntityInstances/" +
                    activeCaseDetails.data.trackedEntityInstance +
                    ".json?program=" +
                    programData.programs[0].id +
                    "&fields=*?";
                  setGlobalSpinner(true);
                  apiServices
                    .getAPI(getURL)
                    .then((trackentityInstanceData) => {
                      axios.post(
                        process.env.NODE_ENV === "development"
                          ? `http://localhost:9000/mrunner_api/refreshDashboards`
                          : `${window.location.protocol}//${window.location.host}/mrunner_api/refreshDashboards`,
                        { r_id: 2 }
                      );

                      setGlobalSpinner(false);
                      if (trackentityInstanceData.data) {
                        setTrackentityInstanceDetails(
                          trackentityInstanceData.data
                        );

                        if (programData) {
                          const filterEvent =
                            trackentityInstanceData.data.enrollments[0].events.filter(
                              (obj) => obj.programStage == "DxQpOKIzDXn"
                            );
                          let sortedEvent = _.sortBy(filterEvent, "created");
                          if (sortedEvent.length > 0) {
                            sortedEvent.reverse();
                            const updatedHivArray = hivarray1.map((entry) => {
                              let matchedValues = [];

                              for (const event of sortedEvent) {
                                matchedValues = event.dataValues
                                  .filter(
                                    (dv) =>
                                      dv.dataElement === entry.id && dv.value
                                  )
                                  .map((dv) => dv.value);

                                if (matchedValues.length > 0) {
                                  // Stop at first event where match is found
                                  return {
                                    ...entry,
                                    status: true,
                                    value: matchedValues[0],
                                  };
                                }
                              }

                              // No match in any event
                              return { ...entry, status: false, value: [] };
                            });

                            sethivarraydata(updatedHivArray);
                            const conditions = checkConditions(updatedHivArray);
                            setHivConditions(conditions);
                            if (conditions.all) {
                              setAllHIVConditionCheck(true);
                            }
                          }
                        }
                      } else {
                        setTrackentityInstanceDetails({});
                      }
                    })
                    .catch((err) => {
                      setGlobalSpinner(false);
                    });

                  const getImageURL =
                    "trackedEntityInstances/" +
                    activeCaseDetails.data.trackedEntityInstance +
                    "/JAhkKQjlDaQ/image";
                  apiServices.getBlobAPI(getImageURL).then((res) => {
                    // console.log(res);
                    var blob = new Blob([res.data]);
                    const imageObjectURL = URL.createObjectURL(blob);
                    setSignatureDataURL(imageObjectURL);
                  });

                  const getFingerURL =
                    "trackedEntityInstances/" +
                    activeCaseDetails.data.trackedEntityInstance +
                    "/HDbRoNrt77N/image";
                  apiServices.getBlobAPI(getFingerURL).then((res) => {
                    // console.log(res);
                    var blob = new Blob([res.data]);
                    const imageObjectURL = URL.createObjectURL(blob);
                    setFingerDataURL(imageObjectURL);
                  });
                }
              })
              .catch((err) => {
                // console.log('postAPIerr>>>', err, err.response.data.httpStatusCode)
                setGlobalSpinner(false);
                resolve(true);
              });
          });
        }
      });
    };

    const loadActiveCaseFormData = (event) => {
      OfflineDb.setDataIntoPouchDB("newSeviceStart", false);
      setServiceStartFlag(false);
      setEditEventsId(event.event);
      let InitialValueData = {};
      let promises = [];
      const DataElementGroup = dataElementGroup;
      const stageList = programData.programs[0].programStages;
      let registrationData = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.attributes;
      let stageData1 = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.enrollments[0].events;
      let stageData = [];
      let ObjecteHolder = {};
      let regObjecteHolder = {};

      if (stageList != null) {
        stageList.map((stages) => {
          const filterEvent = stageData1.filter(
            (obj) => obj.programStage == stages.id
          );
          if (filterEvent.length > 1) {
            stageData.push(filterEvent[filterEvent.length - 1]);
          } else if (filterEvent.length == 1) {
            stageData.push(filterEvent[0]);
          }
        });
      }

      registrationData.map((fields) => {
        const filterField =
          programData.programs[0].programTrackedEntityAttributes.find(
            (obj) => obj.trackedEntityAttribute.id == fields.attribute
          );

        InitialValueData[fields.attribute] = fields.value;

        if (
          filterField &&
          filterField.trackedEntityAttribute &&
          (filterField.trackedEntityAttribute.valueType == "IMAGE" ||
            filterField.trackedEntityAttribute.valueType == "FILE_RESOURCE")
        ) {
          if (fields.value) {
            const resourceGetApi = "fileResources/" + fields.value;
            regObjecteHolder[fields.attribute] = fields.value;
            promises.push(
              apiServices.getAPI(resourceGetApi).then((resources) => {
                return { dataElement: fields.attribute, value: resources.data };
              })
            );
          }
        }

        // multicheckbox edit logic
        programData.programs[0].programSections.map((programSection) => {
          if (programSection.renderType["DESKTOP"].type == "SEQUENTIAL") {
            programSection.trackedEntityAttributes.map((elements) => {
              if (
                programSection.trackedEntityAttributes.find(
                  (array) => array.id == fields.attribute
                )
              ) {
                if (InitialValueData[programSection.id] == undefined) {
                  InitialValueData[programSection.id] = [fields.attribute];
                } else {
                  if (
                    !InitialValueData[programSection.id].includes(
                      fields.attribute
                    )
                  ) {
                    InitialValueData[programSection.id].push(fields.attribute);
                  }
                }
              }
            });
          }
        });
      });

      stageData.map((events) => {
        let dataValue = [];
        if (events.programStage == event.programStage)
          dataValue = event.dataValues;
        else dataValue = events.dataValues;
        dataValue.map((fields) => {
          if (stageList != null) {
            stageList.map((stages) => {
              const filter = stages.programStageDataElements.filter(
                (obj) => obj.dataElement.id == fields.dataElement
              );

              if (filter.length > 0) {
                if (filter[0].dataElement.fieldMask == "Facility Referral") {
                  try {
                    InitialValueData[fields.dataElement] =
                      fields.value.split(",");
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  filter[0].dataElement.valueType == "IMAGE" ||
                  filter[0].dataElement.valueType == "FILE_RESOURCE"
                ) {
                  if (fields.value) {
                    const resourceGetApi = "fileResources/" + fields.value;
                    ObjecteHolder[fields.dataElement] = fields.value;
                    promises.push(
                      apiServices.getAPI(resourceGetApi).then((resources) => {
                        return {
                          dataElement: fields.dataElement,
                          value: resources.data,
                        };
                      })
                    );
                  }
                } else {
                  DataElementGroup.map((DEG) => {
                    DEG.dataElements.map((dataElements) => {
                      if (
                        DEG.dataElements.find(
                          (array) =>
                            array.id == fields.dataElement &&
                            fields.value == "true"
                        )
                      ) {
                        if (InitialValueData[DEG.id] == undefined) {
                          InitialValueData[DEG.id] = [fields.dataElement];
                        } else {
                          if (
                            !InitialValueData[DEG.id].includes(
                              fields.dataElement
                            )
                          ) {
                            InitialValueData[DEG.id].push(fields.dataElement);
                          }
                        }
                      }
                    });
                  });
                  InitialValueData[fields.dataElement] =
                    fields.value == "false"
                      ? false
                      : fields.value == "true"
                      ? true
                      : fields.value;
                }
              }
            });
          }
        });
      });

      setStageregImageValue(regObjecteHolder);
      setStageImageValue(ObjecteHolder);
      if (promises.length == 0) {
        const activeCaseFormData = {
          data: {
            formFormat: InitialValueData, //valueForFormInput,
            dhisFormat: null, //
          },
        };

        OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
        setActiveCaseFormData(activeCaseFormData);
      } else {
        Promise.all(promises).then((responses) => {
          responses.map((response) => {
            InitialValueData[response.dataElement] = [
              new File([""], response.value.displayName, {
                size: response.value.contentLength,
                type: response.value.contentType,
                webkitRelativePath: "",
              }),
            ];
          });
          const activeCaseFormData = {
            data: {
              formFormat: InitialValueData, //valueForFormInput,
              dhisFormat: null, //
            },
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData(activeCaseFormData);
        });
      }
    };

    const setimageDataUrl = (eventid, dataelementid) => {
      setGlobalSpinner(true);
      apiServices
        .getBlobAPI(
          "events/files?eventUid=" +
            eventid +
            "&dataElementUid=" +
            dataelementid.id
        )
        .then((res) => {
          // console.log(res);
          if (res.data.type == "application/pdf") {
            var blob = new Blob([res.data], { type: "application/pdf" });
            const pdfObjectURL = URL.createObjectURL(blob);
            window.open(pdfObjectURL);
            setGlobalSpinner(false);
          } else {
            var blob = new Blob([res.data]);
            const imageObjectURL = URL.createObjectURL(blob);
            setImageResponse(imageObjectURL);
            setImageTitle(dataelementid.formName);
            setGlobalSpinner(false);
          }
        });
    };

    let testList = [];
    let noteMsg = "";

    if (bstageData[LoverId] || bstageData[PaidId]) {
      //noteMsg = "You are eligible for HIV, Syphilis, HBV Test"
      const newlist = ["HIV", "Syphilis", "HBV"];

      newlist.forEach((item) => {
        if (!testList.includes(item)) {
          testList.push(item);
        }
      });
    }

    let Noofparttnerinlast1weekIdList = [
      "2 - 5",
      "6 - 10",
      "2-5",
      "6-10",
      ">10",
    ];
    let optionsList = ["Never", "Occasionally"];

    if (
      Noofparttnerinlast1weekIdList.includes(
        bstageData[Noofparttnerinlast1weekId]
      ) ||
      optionsList.includes(bstageData[howmanytimescomdomusedwithregularId]) ||
      optionsList.includes(bstageData[howmanytimescomdomusedwithotherId]) ||
      bstageData[didyouexpSTIId] == "Yes" ||
      bstageData[didyourecsyphilistreatmentId] == "No"
    ) {
      //noteMsg = "You are eligible for HIV, Syphilis, HBV Test"
      const newlist = ["HIV", "Syphilis", "HBV"];
      newlist.forEach((item) => {
        if (!testList.includes(item)) {
          testList.push(item);
        }
      });
    }

    if (
      bstageData[haveyouuseddrugininjectionId] == "Yes" ||
      bstageData[heroinbrownsugarId] ||
      bstageData[whitenersolventId]
    ) {
      //noteMsg = "You are eligible for HIV, HBV, HCV Test"
      const newlist = ["HIV", "HBV", "HCV"];
      newlist.forEach((item) => {
        if (!testList.includes(item)) {
          testList.push(item);
        }
      });
    }

    if (
      bstageData[howmanydaysareyouusuallyawayfromhomeId] == "6 - 10 days" ||
      bstageData[howmanydaysareyouusuallyawayfromhomeId] == "More than 10 days"
    ) {
      //noteMsg = "You are eligible for HIV, Syphilis Test"

      const newlist = ["HIV", "Syphilis"];
      newlist.forEach((item) => {
        if (!testList.includes(item)) {
          testList.push(item);
        }
      });
    }

    if (testList.length > 0) {
      noteMsg =
        "Based on client's responses to the behavioral screening, client is eligible for the following tests: " +
        testList.join(", ");
    } else {
      noteMsg = "";
    }

    console.log("bstageData", bstageData);
    const hivBehavioural =
      bstageData["MpTrGWW4ZoJ"] === "Yes" &&
      Boolean(bstageData["YDQFLyQCAt6"]) &&
      bstageData["qIvF2ktc01T"] === "Positive"; //new id
    // bstageData["jD2F8SfCZw6"] === "Positive"; //old id
    // bstageData["Xj1QKLJ1NyF"] === "Yes" &&

    return (
      <Form
        onSubmit={onStageSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, form, submitting, pristine, values }) => {
          formRef.current = form;
          return (
            <form
              className="fullWidth"
              onSubmit={handleSubmit}
              encrypt="multipart/form-data"
            >
              <div className="nameuicinfoholder">
                <Grid container spacing={0} xs={12} lg={12}>
                  <Grid container spacing={0} xs={6} lg={3}>
                    <Grid item>
                      <span className="fl-left">{t("UID")}</span>:{" "}
                      {initialValues
                        ? initialValues[uicId]
                          ? initialValues[uicId]
                          : t("N/A")
                        : ""}
                    </Grid>
                    <hr className="nameSeperator" />
                  </Grid>
                  <Grid container spacing={0} xs={6} lg={3}>
                    <Grid item>
                      <span className="fl-left">{t("Name")}</span>:{" "}
                      {initialValues
                        ? initialValues[firstNameId]
                          ? initialValues[firstNameId]
                          : t("N/A")
                        : ""}
                    </Grid>
                    <hr className="nameSeperator" />
                  </Grid>
                  <Grid container spacing={0} xs={6} lg={3}>
                    <Grid item>
                      <span className="fl-left">{t("Age")}</span>:{" "}
                      {initialValues
                        ? initialValues[ageUID]
                          ? initialValues[ageUID] + ageGender
                          : t("N/A")
                        : ""}
                    </Grid>
                    <hr className="nameSeperator" />
                  </Grid>
                  <Grid container spacing={0} xs={6} lg={3}>
                    <Grid item>
                      <span className="fl-left">{t("Client Type")}</span>:{" "}
                      {initialValues
                        ? moment(
                            new Date(initialValues[clientregdateId])
                          ).format("DD/MM/YYYY") ==
                            moment(new Date()).format("DD/MM/YYYY") &&
                          !checkNewServiceStatus(stage)
                          ? "New"
                          : "Repeat"
                        : ""}
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <div className="innertabdivreg subclass6 pt-0 mT-20">
                <>
                  {" "}
                  {dataElementGroup.map((DataElementGroup) => {
                    if (values != undefined) {
                      if (values[DataElementGroup.id] != undefined) {
                        DataElementGroup.dataElements.map((elements) => {
                          values[elements.id] = false;
                        });
                        if (
                          values[DataElementGroup.id].length > 0 &&
                          Array.isArray(values[DataElementGroup.id])
                        ) {
                          values[DataElementGroup.id].map((value) => {
                            values[value] = true;
                          });
                        }
                      }
                    }
                  })}{" "}
                </>

                <Grid container spacing={3} className="">
                  <Grid container className="custom-block">
                    {stage.attributeValues && stage.attributeValues.length > 0
                      ? stage.attributeValues.map((val) => {
                          if (val.attribute.displayName === "Task List") {
                            return (
                              <TaskList
                                programData={programData}
                                stagedetails={stage}
                                userdetails={userData}
                                trackentityInstanceDetails={
                                  trackentityInstanceDetails
                                }
                              />
                            );
                          }
                        })
                      : null}
                  </Grid>

                  {stage.name === "General Services" ? (
                    <>
                      {stage.programStageDataElements.map((fields) =>
                        fields.dataElement.formName === "Client Type"
                          ? renderStageField(
                              fields,
                              values ? values : {},
                              form,
                              stage.programStageDataElements,
                              stage,
                              activeAccordion,
                              hivBehavioural
                            )
                          : null
                      )}
                    </>
                  ) : null}

                  {stage.name === "General Services" ? (
                    <Card className="calender-theme">
                      <CardContent className="modalbodycontent">
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableContainer component={Paper}>
                              <Table>
                                <TableHead>
                                  <TableRow
                                    style={{ borderTop: "1px solid #E0E0E0" }}
                                  >
                                    <TableCell
                                      rowSpan={1}
                                      align="center"
                                      className="gstablecell"
                                    ></TableCell>
                                    <TableCell
                                      colSpan={4}
                                      align="center"
                                      className="gstablecell"
                                    >
                                      Basic Daily Life Facility
                                    </TableCell>
                                    <TableCell
                                      colSpan={5}
                                      align="center"
                                      className="gstablecell"
                                    >
                                      Other Facilities
                                    </TableCell>
                                    <TableCell
                                      rowSpan={1}
                                      align="center"
                                      className="gstablecell"
                                    ></TableCell>
                                  </TableRow>
                                  <TableRow>
                                    {stage.programStageDataElements.map(
                                      (fields) =>
                                        fields.dataElement.formName !==
                                          "Client Type" &&
                                        (fields.dataElement.formName ==
                                        "Remark" ? (
                                          <div className="customremark">
                                            <TableCell
                                              rowSpan={2}
                                              align="center"
                                              className={"gstablecell"}
                                              key={fields.dataElement.id}
                                            >
                                              {fields.dataElement.formName}
                                            </TableCell>
                                          </div>
                                        ) : (
                                          <TableCell
                                            rowSpan={2}
                                            align="center"
                                            className={"gstablecell"}
                                            key={fields.dataElement.id}
                                          >
                                            {fields.dataElement.formName}
                                          </TableCell>
                                        ))
                                    )}
                                  </TableRow>
                                </TableHead>
                                

                                <TableBody>
                                  <TableRow key={"day"}>
                                    {stage.programStageDataElements.map(
                                      (fields) =>
                                        fields.dataElement.formName !==
                                          "Client Type" && (
                                          <TableCell
                                            align="center"
                                            className={
                                              fields.dataElement.formName ==
                                              "Remark"
                                                ? "customRemarkInput"
                                                : ""
                                            }
                                            key={fields.dataElement.id}
                                          >
                                            {renderStageField(
                                              fields,
                                              values || {},
                                              form,
                                              stage.programStageDataElements,
                                              stage,
                                              activeAccordion,
                                              hivBehavioural
                                            )}
                                          </TableCell>
                                        )
                                    )}
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  ) : stage.programStageSections &&
                    stage.programStageSections.length > 0 ? (
                    <>
                      {noteMsg && stage.name == "CD Screening" && (
                        <h3 className="disclaimerMsg">{noteMsg}</h3>
                      )}
                      {renderStageBySection(
                        stage,
                        values || {},
                        form,
                        submitting,
                        stage.programStageDataElements
                      )}
                    </>
                  ) : (
                    stage.programStageDataElements.map((fields) =>
                      renderStageField(
                        fields,
                        values || {},
                        form,
                        stage.programStageDataElements,
                        stage,
                        activeAccordion,
                        hivBehavioural
                      )
                    )
                  )}
                </Grid>

                <div className="buttons">
                  {programData.programs[0].programStages != null &&
                  stage.name != "CD Screening" &&
                  stage.name != "Behavioural Screening" &&
                  stage.name != "NCD Screening" &&
                  stage.name != "Social Protection" &&
                  Configuration.roleAccess["Client Record - Edit"][
                    sessionUserBoValue.userCredentials.userRoles[0].name
                  ]
                    ? stage.name != "" && (
                        <button
                          className="regformsubmitbtn 11 submitButton"
                          type="submit"
                          disabled={submitting}
                        >
                          {t("Submit")}
                        </button>
                      )
                    : ""}

                  {programData.programs[0].programStages != null &&
                  workFlow &&
                  stage.name != "CD Screening" &&
                  stage.name != "NCD Screening" &&
                  Configuration.roleAccess["Client Record - Edit"][
                    sessionUserBoValue.userCredentials.userRoles[0].name
                  ] ? (
                    <button
                      className={
                        `regformsubmitbtn ` +
                        (getMultiserviceArray() ? "" : "hide")
                      }
                      style={{ float: "right" }}
                      type="button"
                      onClick={() => gotoNewService()}
                    >
                      {t("New Service")}
                    </button>
                  ) : (
                    ""
                  )}
                  {/* new service for individual stage  */}
                  {programData.programs[0].programStages != null && !workFlow
                    ? (stage.name == "General Services" ||
                        stage.name == "Family Member Linkage") && (
                        <button
                          className={
                            `regformsubmitbtn newservicebtn ` +
                            (checkNewServiceStatus(currentStage)
                              ? checkNewServiceVisibility(currentStage)
                                ? "hide"
                                : ""
                              : "hide")
                          }
                          style={{ float: "right" }}
                          type="button"
                          onClick={() => starttoNewService(currentStage)}
                        >
                          <AddIcon></AddIcon>
                        </button>
                      )
                    : ""}
                </div>
                {navigator.onLine &&
                currentStage &&
                currentStage.attributeValues &&
                currentStage.attributeValues.length > 0
                  ? currentStage.attributeValues.map((attr) => {
                      if (
                        attr.attribute.displayName == "ShowServiceTab" &&
                        attr.value == "true"
                      ) {
                        return (
                          <>
                            <TableContainer
                              component={Paper}
                              className={
                                `ml-10px mr-10px mb-20px ShowServiceTab-tabel 22` +
                                (checkNewServiceStatus(currentStage)
                                  ? checkNewServiceVisibility(currentStage)
                                    ? "hide"
                                    : ""
                                  : "hide")
                              }
                            >
                              <Table
                                className={classes.table}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    {renderCellValues(currentStage)}
                                    {Configuration.roleAccess[
                                      "Client Record - Edit"
                                    ][
                                      sessionUserBoValue.userCredentials
                                        .userRoles[0].name
                                    ] ? (
                                      <TableCell className="gstablecell">
                                        {" "}
                                        {t("Edit")}
                                      </TableCell>
                                    ) : null}
                                    {Configuration.roleAccess[
                                      "Record - Delete"
                                    ][
                                      sessionUserBoValue.userCredentials
                                        .userRoles[0].name
                                    ] ? (
                                      <TableCell>{t("Delete")}</TableCell>
                                    ) : null}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {renderCellDataValues(currentStage)}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </>
                        );
                      }
                    })
                  : null}
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </div>
            </form>
          );
        }}
      />
    );
  }

  function postSearchSubmit() {
    if (searchEnabled) {
      setSearchResponse(null);
      setValue(1);
    } else {
      const orgUnit = userData.organisationUnits[0].id;
      const trackedEntityType = programData.programs[0].trackedEntityType.id;
      let registrationFields =
        programData.programs[0].programTrackedEntityAttributes;
      let valuesToSave = formValuePostDeDup.valuesToSave;
      let valueForFormInput = formValuePostDeDup.valueForFormInput;
      let saveCaseInput = {
        trackedEntityType: trackedEntityType,
        orgUnit: orgUnit,
        attributes: valuesToSave,
        enrollments: [
          {
            //"trackedEntityInstance": trackedEntityInstance,
            program: programData.programs[0].id,
            //"status": "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          },
        ],
        geometry: {
          type: "Point",
          coordinates: [currentGeolocation.lng, currentGeolocation.lat],
        },
      };
      setGlobalSpinner(true);
      apiServices
        .postAPI("trackedEntityInstances", saveCaseInput)
        .then((response) => {
          const trackedEntityInstance =
            response.data.response.importSummaries[0].reference;
          const programId = programData.programs[0].id;
          const enrollmentInputJson = {
            trackedEntityInstance: trackedEntityInstance,
            program: programId,
            status: "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          };
          setGlobalSpinner(false);
          const enroll = ""; //enrollmentResponse.data.response.importSummaries[0].reference
          if (
            programData.programs[0].useFirstStageDuringRegistration == false &&
            relationShipId != "" &&
            Configuration.registrationForm.linkContactInAlert
          ) {
            swal({
              title: t("Individual Registered"),
              text: t("Do you want to initiate the individual registration?"),
              icon: "success",
              buttons: [t("No"), t("Yes")],
            }).then((AlertRes) => {
              if (AlertRes) {
                //save data
                const activeCaseDetails = {
                  trackedEntityInstance: trackedEntityInstance,
                  enrollmentId: enroll,
                };
                const linkContact = {
                  enabled: true,
                  linkTrackedEntityInstance: trackedEntityInstance,
                };
                const activeCaseFormData = {
                  formFormat: null, //valueForFormInput,
                  dhisFormat: null, //
                };

                OfflineDb.setDataIntoPouchDB(
                  "activeCaseDetails",
                  activeCaseDetails
                );
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                setActiveCaseFormData({
                  data: {
                    formFormat: null, //valueForFormInput,
                    dhisFormat: null, //
                  },
                });
                setValue(0);
                //empty form
              } else {
                //save data
                const activeCaseDetails = {
                  trackedEntityInstance: trackedEntityInstance,
                  enrollmentId: enroll,
                };

                const activeCaseFormData = {
                  formFormat: valueForFormInput,
                  dhisFormat: valuesToSave,
                };
                const linkContact = {
                  enabled: false,
                  linkTrackedEntityInstance: trackedEntityInstance,
                };
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseDetails",
                  activeCaseDetails
                );
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                //load next active tabs
                const nextTab = activeTabs[0];
                if (nextTab) {
                  const indexOfNextTab =
                    programData.programs[0].programStages.findIndex(
                      (obj) => obj.id == nextTab
                    );
                  setValue(indexOfNextTab + stepIncrement);
                } else {
                  setValue(value);
                }
              }
            });
          } else {
            const activeCaseDetails = {
              trackedEntityInstance: trackedEntityInstance,
              enrollmentId: enroll,
            };
            setActiveCaseDetails({
              data: {
                trackedEntityInstance: trackedEntityInstance,
                enrollmentId: enroll,
              },
            });
            const activeCaseFormData = {
              formFormat: valueForFormInput,
              dhisFormat: valuesToSave,
            };
            const linkContact = {
              enabled: false,
              linkTrackedEntityInstance: trackedEntityInstance,
            };
            OfflineDb.setDataIntoPouchDB(
              "activeCaseDetails",
              activeCaseDetails
            );
            OfflineDb.setDataIntoPouchDB(
              "activeCaseFormData",
              activeCaseFormData
            );
            OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
            swal({
              title: t("Success"),
              text: t(
                "Individual Registered. Your dashboard will load shortly."
              ),
              icon: "success",
              button: t("Close"),
            });
            //save data
            //laod next active tab
            const nextTab = activeTabs[0];
            if (nextTab) {
              const indexOfNextTab =
                programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == nextTab
                );
              setValue(indexOfNextTab + stepIncrement);
            } else {
              setValue(value);
            }
          }
          //})
          setGlobalSpinner(false);
        })
        .catch((err) => {
          swal({
            title: t("Error"),
            text: err,
            icon: "error",
            button: t("Close"),
          });
          setGlobalSpinner(false);
        });

      setSearchHeader(null);
      setSearchResponse(null);
    }
  }

  function processImage(imgeUrl) {
    let InitialValueData = {};
    let subscriptionKey = "a53cd4ec9db94138a74c6e4730dfa9e4"; // a53cd4ec9db94138a74c6e4730dfa9e4
    let endpoint = "https://duretech.cognitiveservices.azure.com"; // https://duretech.cognitiveservices.azure.com/
    let uriBase = endpoint + "/vision/v3.1/read/analyze";

    let sourceImageUrl = imgeUrl; //'https://res.cloudinary.com/dh5r8k5vs/image/upload/v1623038963/AppUploads/uubxdg8bi2knbihss9uy.jpg'

    setGlobalSpinner(true);
    axios({
      method: "post",
      url: uriBase,
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "Content-Security-Policy": "self",
        "X-Content-Type-Options": "nosniff",
        "X-XSS-Protection": "1; mode=block",
      },
      data: JSON.stringify({ url: sourceImageUrl }),
    }).then((response) => {
      setGlobalSpinner(false);

      let operationLocation = response.headers["operation-location"];
      setGlobalSpinner(true);
      setTimeout(function () {
        axios({
          method: "GET",
          url: operationLocation,
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Content-Security-Policy": "self",
            "X-Content-Type-Options": "nosniff",
            "X-XSS-Protection": "1; mode=block",
          },
        }).then((secondRes) => {
          setGlobalSpinner(false);
          setCameraStatus(false);
          var result = secondRes.data.analyzeResult.readResults[0].lines;
        });
      }, 10000);
    });
  }

  function imageUploadSuccessCallback(r) {
    if (r && r.secure_url) {
      processImage(r.secure_url);
    }
  }

  function handleTakePhoto(dataUri) {
    setGlobalSpinner(true);
    // Do stuff with the photo...

    const API_ENDPOINT = "https://api.cloudinary.com/v1_1/dh5r8k5vs/upload";
    dataUri = dataUri.includes("data:image/jpeg;base64,")
      ? dataUri
      : "data:image/jpeg;base64," + dataUri;
    const fileData = new FormData();
    fileData.append("file", dataUri);
    fileData.append("upload_preset", "uploadthroughapp");
    //fileData.append('tags', 'xxxxxx'); // optional

    fetch(API_ENDPOINT, {
      method: "post",
      body: fileData,
    })
      .then((response) => response.json())
      .then((data) => imageUploadSuccessCallback(data))
      .catch((err) => {
        console.error("Error:", err);
        setGlobalSpinner(false);
      });
  }

  function handleTakePhotoAnimationDone(dataUri) {
    // Do stuff with the photo...
    setDataUri(dataUri);
  }

  function handleCameraError(error) {}

  function handleCameraStart(stream) {
    document.body.classList.add("cameraon");
  }

  function handleCameraStop() {
    document.body.classList.remove("cameraon");
  }

  return (
    <div className={classes.root}>
      {activeCaseDetails != null &&
      activeCaseFormData != null &&
      linkContactFlag != null &&
      trackentityInstanceDetails != null &&
      Configuration != null &&
      orgDetails != null ? (
        <>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              {searchEnabled && navigator.onLine ? (
                Configuration.registrationForm.defaultTabOnSearchEnable.map(
                  (defaultTabs, index) => {
                    return (
                      <Tab
                        className={
                          props.stageInstanceID ||
                          (userrolename && userrolename == patientRole)
                            ? "hideTabs"
                            : ""
                        }
                        label={t(defaultTabs)}
                        {...a11yProps(index)}
                      />
                    );
                  }
                )
              ) : (
                <Tab
                  className={
                    props.stageInstanceID ||
                    (userrolename && userrolename == patientRole)
                      ? "hideTabs"
                      : ""
                  }
                  label={t("Registration")}
                  {...a11yProps(0)}
                />
              )}

              {programData.programs[0].programStages.map((stages, index) => {
                let checkAccess = stageAccessCheck(stages);
                let checkTabVisibility = checkTabs(stages);

                let initialValues = activeCaseFormData.data
                  ? activeCaseFormData.data.formFormat != null
                    ? activeCaseFormData.data.formFormat
                    : {}
                  : {};

                if (
                  initialValues &&
                  initialValues[PresentlyOnAntiTBMedicationId] &&
                  initialValues[PresentlyOnAntiTBMedicationId] == "YES"
                ) {
                  checkAccess = true;
                }
                /*code fore transfer module service*/
                if (props.stageInstanceID) {
                  checkAccess = false;
                  if (props.stageTabValue == index + stepIncrement) {
                    checkAccess = true;
                  }
                }

                if (addContactFlag) {
                  checkTabVisibility = false;
                }
                if (stages.id == "oTbaZad1ZvJ" || stages.id == "DDFbxxHkywS") {
                  if (
                    initialValues &&
                    initialValues[PresentlyOnAntiTBMedicationId] &&
                    initialValues[PresentlyOnAntiTBMedicationId] == "YES"
                  ) {
                    checkTabVisibility = true;
                  }
                }

                if (
                  stages.displayName.includes("Family Member") &&
                  !Boolean(initialValues?.["phLcEDwSQS6"] || false)
                ) {
                  checkAccess = false;
                }

                return (
                  <Tab
                    className={checkAccess ? "" : "hideTabs"}
                    label={getTranslatedLabels(stages)}
                    {...a11yProps(index + stepIncrement)}
                    disabled={
                      activeCaseDetails.data
                        ? checkTabVisibility
                          ? false
                          : true
                        : true
                    }
                  />
                );
              })}
            </Tabs>
          </AppBar>
          {/* <> <Button className="regSearchCancelButton" onClick={() => setCameraStatus(true)}>{t('OCR')}</Button> </> */}
          {searchEnabled && navigator.onLine ? (
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              disabled={
                activeCaseDetails &&
                activeCaseDetails.data &&
                userrolename &&
                userrolename != patientRole
                  ? false
                  : true
              }
            >
              <TabPanel value={value} index={0} dir={theme.direction}>
                {createSearchForm(programData)}
              </TabPanel>
              <TabPanel value={value} index={1} dir={theme.direction}>
                <div className="under-swipeable">
                  {createRegistrationForm(
                    programData,
                    programRules,
                    programRulesVariables,
                    orgDetails
                  )}
                </div>
              </TabPanel>
              {programData.programs[0].programStages.map((stages, index) => {
                return (
                  <TabPanel
                    value={value}
                    index={index + stepIncrement}
                    key={"tabPanel" + index + stepIncrement}
                    dir={theme.direction}
                  >
                    {createStageForms(stages, index + stepIncrement)}
                  </TabPanel>
                );
              })}
            </SwipeableViews>
          ) : (
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              disabled={
                activeCaseDetails &&
                activeCaseDetails.data &&
                userrolename &&
                userrolename != patientRole
                  ? false
                  : true
              }
            >
              <TabPanel value={value} index={0} dir={theme.direction}>
                {createRegistrationForm(
                  programData,
                  programRules,
                  programRulesVariables,
                  orgDetails
                )}
              </TabPanel>
              {programData.programs[0].programStages.map((stages, index) => {
                return (
                  <TabPanel
                    value={value}
                    index={index + stepIncrement}
                    key={"tabPanel" + index + stepIncrement}
                    dir={theme.direction}
                  >
                    {createStageForms(stages, index + stepIncrement)}
                  </TabPanel>
                );
              })}
            </SwipeableViews>
          )}
        </>
      ) : (
        <> </>
      )}

      {searchResponse != null ? (
        <div className="modaloverlay">
          <div className="modalcardholder">
            <Card className="modalcard">
              <CardHeader
                className="modalheader"
                action={
                  <IconButton aria-label="close">
                    <CloseIcon onClick={() => setSearchResponse(null)} />
                  </IconButton>
                }
                title={
                  searchResponse.length > 0 ? "Match found" : "No Match found"
                }
              />
              <CardContent className="modalbodycontent">
                <Grid container spacing={3}>
                  {searchResponse !== null ? (
                    searchResponse.map((row) => {
                      return (
                        <CustomeCaseCard
                          row={row}
                          searchHeader={searchHeader}
                          viewType={"card"}
                          parentPage={"registration"}
                          hideOptions={"false"}
                        ></CustomeCaseCard>
                      );
                    })
                  ) : (
                    <> </>
                  )}
                </Grid>
                <Typography className="modaltext modalinfo" gutterBottom>
                  {t("Click Continue to register New client")}
                </Typography>
              </CardContent>

              <CardActions className="modalfooter">
                <Button
                  className="regSearchCancelButton"
                  onClick={() => setSearchResponse(null)}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  className="modalactionbtn"
                  onClick={() => postSearchSubmit()}
                >
                  {t("Continue")}
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      ) : (
        <> </>
      )}

      {openCamera && dataUri === "" ? (
        <Camera
          onTakePhoto={(dataUri) => {
            handleTakePhoto(dataUri);
          }}
          onTakePhotoAnimationDone={(dataUri) => {
            handleTakePhotoAnimationDone(dataUri);
          }}
          onCameraError={(error) => {
            handleCameraError(error);
          }}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          idealResolution={{ width: 100, height: 100 }}
          imageType={IMAGE_TYPES.JPG}
          imageCompression={0.97}
          isMaxResolution={true}
          isImageMirror={false}
          isSilentMode={false}
          isDisplayStartCameraError={true}
          isFullscreen={false}
          sizeFactor={1}
          onCameraStart={(stream) => {
            handleCameraStart(stream);
          }}
          onCameraStop={() => {
            handleCameraStop();
          }}
        />
      ) : (
        <> </>
      )}

      {openCamera && dataUri === "" ? (
        window.cordova ? (
          navigator.camera.getPicture(handleTakePhoto, handleCameraError, {
            quality: 60,
            correctOrientation: true,
            destinationType: navigator.camera.DestinationType.DATA_URL,
          })
        ) : (
          <Camera
            onTakePhoto={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
            onTakePhotoAnimationDone={(dataUri) => {
              handleTakePhotoAnimationDone(dataUri);
            }}
            onCameraError={(error) => {
              handleCameraError(error);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            idealResolution={{ width: 100, height: 100 }}
            imageType={IMAGE_TYPES.JPG}
            imageCompression={0.97}
            isMaxResolution={true}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStart={(stream) => {
              handleCameraStart(stream);
            }}
            onCameraStop={() => {
              handleCameraStop();
            }}
          />
        )
      ) : (
        <> </>
      )}

      {imageResponse !== null ? (
        <>
          <div className="modaloverlay">
            <div className="modalcardholder">
              <Card className="modalcard">
                <CardHeader
                  className="modalheader"
                  action={
                    <IconButton aria-label="close">
                      <CloseIcon onClick={() => setImageResponse(null)} />
                    </IconButton>
                  }
                  title={imageTitle}
                />
                <CardContent className="modalbodycontent">
                  <Grid container spacing={3}>
                    <img
                      alt=""
                      style={{ width: "inherit" }}
                      className="blob-to-image"
                      src={imageResponse}
                    ></img>
                  </Grid>
                </CardContent>
              </Card>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

//export default SimpleTabs
function mapStateToProps(state) {
  const { storeState } = state;
  return {
    selectTrackedEnityInstanceId: storeState.selectTrackedEnityInstanceId,
  };
}

export default connect(mapStateToProps, {})(SimpleTabs);
